window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Returns empty string or query string with '?' prefix
   *
   * @return (string)
   */
  getQueryString: function() {
    var queryString = location.search && location.search.substr(1) || '';

    // Add the '?' prefix if there is an actual query
    if(queryString.length){
      queryString = '?' + queryString;
    }

    return queryString;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   * Will also remove the key if an empty value is passed in
   * See: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {

    uri = uri || window.location.href;

    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    uri = uri || window.location.href;

    var rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) { 
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },  

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className,
        matches;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  /**
   * Pluralizes the unit for the nuber passed in.
   * Usage mirrors the Shopify "pluralize" string filter
   *
   * @param {Number} number
   * @param {String} singular
   * @param {String} plural
   * @return {String}
   */
  pluralize: function(number, singular, plural)  {
    var output = '';

    number = parseInt(number);

    if(number == 1) {
      output = singular;
    }
    else {
      output = plural;
      if (typeof plural == "undefined") {
        output = singular + 's'; // last resort, turn singular into a plural
      }
    }
    return output;
  }
  
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    
    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },  

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/,'');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 *
 * Usage: slate.AjaxCart.init(options);
 *
 * See the following list of stubbed / incomplete methods that need to be filled in
 *
 *   - AjaxCart.onOpenClick
 *   - AjaxCart.onCloseClick
 *   - AjaxCart.open
 *   - AjaxCart.close
 *   - AjaxCart.onItemAddFail
 *   - AjaxCart.buildCart
 *
 */

 (function($, Handlebars, slate){

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

 /**
  * AJAX submit an 'add to cart' form
  *
  * @param {jQuery} $form - jQuery instance of the form
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function (lineItem) {
        //the data returned from this call is the json of the item we just added.  W
        //We can use it to grab the lineitem.key and verify the quantity.
        ShopifyAPI.getCartAndVerifyQuantities().then(function (data) {
          promise.resolve(data);
        });

      },
      error: function () {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

  /**
  * AJAX submit an 'add to cart' request.  Plural version of the above which can take an array instead of only a single item
  *
  * @param { array } - Array of objects, each one of which need at least an ID + quantity.
    {
      quantity: { integer },
      id: { variant ID },
      properties: { object } key/value pairs of lineitem properties to be added
    }
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemsToCart = function( itemsToAdd, callback ) {
    var promise = $.Deferred();

    //Shopify prevents multiple requests from firing at once, so we have to wait to execute the next one until the prior one finishes
    function addNextProduct(item){
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/add.js',
        data: item
      }).done(function(data){
        itemsToAdd.shift(); //remove first item
        if ( itemsToAdd.length ) {
          addNextProduct(itemsToAdd[0]);
        } else {
          ShopifyAPI.getCartAndVerifyQuantities().then(function (data) {
            promise.resolve(data);
          });
        }
      }).fail(function(data){
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      });
    }

    //Kick off add items function
    addNextProduct(itemsToAdd[0]);

    return promise;
  };


  /*
  * AJAX add an item with optional lineitem properties
  *
  * @param {int} variantId - variant ID of item to add
  * @param {int} quantity - quantity to be added
  * @param {obj} properties - object of key-value pairs for the line item properties to be added
  */
  ShopifyAPI.addItemToCart = function(variantId, qty, lineItemProperties) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: qty,
        properties: lineItemProperties
      }
    });
  };

  /**
  * Verify Item Quantity maximums
  *
  * Not technically part of the ShopifyAPI, but handled in a similar way.  This function checks all line items against
  * the maximum_orderable_quantity calculated in the cart json response, reduces them to their max if they've gone over,
  * and returns the cart object.
  *
  */

  ShopifyAPI.getCartAndVerifyQuantities = function() {
    var promise = $.Deferred();


    ShopifyAPI.getCart().then(function(cart){
      var lineItems = cart.items;
      var currentQuantities = [];
      var newQuantities = [];

      for (var i = 0; i < lineItems.length; i++) {
        var lineItem = lineItems[i];
        currentQuantities.push(lineItem.quantity);

        if ( lineItem.is_bundle_child && !lineItem.is_valid_bundle_child ) {
          newQuantities.push(0); //remove invalid bundle children
        }
        else if (lineItem.quantity > lineItem.maximum_orderable_quantity) {
          newQuantities.push(lineItem.maximum_orderable_quantity);
        } else {
          newQuantities.push(lineItem.quantity);
        }
      }

      //Compare two arrays, see if there are any differences.
      var valuesChanged = currentQuantities.some(function(el, i){
        return el != newQuantities[i];
      });

      if (valuesChanged) {
        //If there were changes, send a batch request to lower lineitem quantities
        ShopifyAPI.changeItemQuantities(newQuantities)
          .then(ShopifyAPI.getCart)
          .then(function(cart){
            promise.resolve(cart);
          });
      } else {
        //if there weren't, we can return the cart we got above.
        promise.resolve(cart);
      }

    });

    return promise;
  };


 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getCart = function() {
    var promise = $.Deferred();

    $.ajax({
      type: 'get',
      url: '/cart?view=json',
      success: function (data) {
        var cart = JSON.parse(data);
        promise.resolve(cart);
      },
      error: function () {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };

 /**
  * Change the quantity of an item in the users cart
  *
  * @param {int} lineItemIndex - 1-based index of the lineitem
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */

  ShopifyAPI.changeItemQuantity = function(lineItemIndex, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: {
        line: lineItemIndex,
        quantity: qty
      }
    });
  };

  /**
  * Change the quantity of an item in the users cart by lineitem
  *
  * @param {int} variantId - Variant to be adjust
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeItemQuantityByIndex = function(lineItemIndex, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: {
        line: lineItemIndex,
        quantity: qty
      }
    });
  };

   /**
  * Change the quantity of ALL lineitems in the users cart
  *
  * @param {array} array of quantities.  The length of this array must be equal to the number of lineitems, and each quantity maps to the quantity of
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeItemQuantities = function(arrayOfQuantities) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/update.js',
      data: {updates: arrayOfQuantities}
    });
  };

    /**
  * Change the props of an item in the users cart by lineitem
  *
  * @param {int} lineItemIndex - 1-based index of the lineitem
  * @param {obj} props - New quantity of the variant
  * @return {Promise} - JSON cart
  */
 ShopifyAPI.updateItemPropsByIndex = function (lineItemIndex, props) {
  return ShopifyAPI.getCart().then(function(cart){
    var currentProps = cart.items[lineItemIndex - 1].properties;
    //console.log('currentProps', currentProps);
    //console.log('props', props);
    var newProps = {
      ...currentProps,
      ...props
    }
    //console.log('newProps', newProps)
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: {
        line: lineItemIndex,
        properties: newProps
      }
    });
  })
};

 /**
  * Clear the cart
  *
  *
  */
  ShopifyAPI.clearCart = function() {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/clear.js',
    });
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {

    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      quantityAdjuster: '[data-quantity-adjuster]',
      itemIncrement: '[data-ajax-cart-item-increment]',
      itemDecrement: '[data-ajax-cart-item-decrement]',
      itemQuantityInput: '[data-ajax-cart-quantity-adjuster-input]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',
      shippingPromo: '[data-shipping-promo]',
      //Bundle stuff
      bundleProduct: '[data-bundle-product]', //data attribute added to cart/ajax-cart items that are a bundle parent
      addBundleForm: 'form[data-add-to-cart-bundle-form]', //form attribute added on PDF.
      bundleChildProduct: 'input[data-bundle-child-product]',
      bundleId: 'input[data-bundle-id]',
      bundleName: 'input[data-bundle-name]',
      pdfQuantity: 'input[name="quantity"]', //quantity adjuster input on product detail
      afterpayInfo: '.ajax-cart__footer .afterpay-paragraph .more-info'
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      backdrop: 'ajax-cart-backdrop',
      backdropVisible: 'is-visible',
      cartOpen: 'is-open',
      cartBadgeHasItems: 'has-items',
      cartRequestInProgress: 'request-in-progress'
    };

    var dataAttr = {
      bundleId: 'bundle-product',
      ariaAjaxCartHidden: 'aria-hidden'
    };

    var FOCUSELEMENTS = 'a, button, input, select, textarea, svg, area, details, summary, iframe, object, embed, [tabindex], [contenteditable]',
        nodes,
        nodeList;

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart';
      this.namespace = '.' + this.name;
      this.events = {
        RENDER:  'render'  + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL:  'scroll'  + this.namespace,
        UPDATE:  'update'  + this.namespace, //  Use this as a global event to hook into whenever the cart changes
        KEYDOWN: 'keydown' + this.namespace
      };

      var initialized = false;
      var settings = {
        disableAjaxCart: false,
        backdrop: true
      };

      this.$el                = $(selectors.container);
      this.$backdrop          = null;
      this.stateIsOpen        = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.requestInProgress  = false;

      //These allow for a slight delay in quantityAdjuster timeout.
      this.quantityAdjusterTimeout = null; //property to hold the timeout ID
      this.quantityAdjusterTimeoutDelay = 350; //timeout between changing the quantity value before AJAX request fires.

      this.selectedItemQuantity = null;

      this.$addToCartForms    = $(selectors.addForm).not(selectors.addBundleForm); //Grab reference to all the add-to-cart forms.
      this.$addBundleToCartForms = $(selectors.addBundleForm); //Grab separate reference to bundle forms

      this.seenFormsArr       = []; //array to store forms we have already overridden with the _formsOverride function

     /**
      * Initialize the cart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        var self = this;

        this.settings = $.extend(settings, options);

        if(!$(selectors.template).length){
          console.warn('['+this.name+'] - Handlebars template required to initialize');
          return;
        }

        this.$container      = $(selectors.container);
        this.$cartBadge      = $(selectors.cartBadge);
        this.$cartBadgeCount = $(selectors.cartBadgeCount);

        //Check if cart is using express buttons
        /* //replaced with a better approach
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          this.hasDynamicCheckout = true;
          this.dynamicCheckoutTextArea = document.createElement('textarea');
        }*/

        Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
          return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if(!this.settings.disableAjaxCart) {
          this._formOverride();

          //Populate the seenFormsArr with the initial pageload data.
          this.$addToCartForms.each(function(i, el){
            this.seenFormsArr.push( el );
          }.bind(this));
        }


        //Free shipping strings, need both to be present for calc to appear.
        this.$freeShippingMessage = $( selectors.shippingPromo );
        this.freeShippingTextArea = document.createElement('textarea');

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.afterpayInfo, this.onAfterpayInfoClick.bind(this));
        $body.on('change', selectors.itemQuantityInput, this.onItemQuantityChange.bind(this));
        $body.on('focus', selectors.itemQuantityInput, this.onItemQuantityFocus.bind(this));
        $body.on('blur', selectors.itemQuantityInput, this.onItemQuantityBlur.bind(this));
        $body.on('keydown', function(e){if (e.key == 'Escape'){self.onCloseClick(e)}});
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));

        window.addEventListener('openCart', this.buildAndOpenCart.bind(this));
        window.addEventListener('rebuildCartForBold', this.rebuildCartForBold.bind(this));

        this.$el.on(this.transitionEndEvent, (function(event) {
          if(event.originalEvent.propertyName === "transform" && this.isOpen()) {
            this.focus();
          }
        }).bind(this));


        // Get the cart data when we initialize the instance
        ShopifyAPI.getCartAndVerifyQuantities()
          .then(self.updateFreeGifts)
          .then(self.buildCart.bind(this));
        initialized = true;

        if (initialized) {
          return {
            //expose these two methods to the ajaxCart section
            ajaxifyForm: this.ajaxifyForm.bind(this),
            refreshForms: this.refreshForms.bind(this)
          };
        }
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

      /**
      * Call this function to AJAX-ify any add to cart forms on the page
      * Note: This function is only called on load, so it doesn't hit anything loaded after the fact.
      * You need to call refreshForms() to hit those
      */
      _formOverride: function() {
        var _this = this;

        //Submit handler for normal forms

        this.$addToCartForms.on('submit', function(e) {
          e.preventDefault();

          if(this.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          this._onRequestStart();

          ShopifyAPI.addItemFromForm( $(e.target) )
            .then(function(data) {
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        }.bind(this));

        //Separate action for bundle forms
        this.$addBundleToCartForms.on('submit', function(e){
          e.preventDefault();

          //TODO: getCart, loop through lineitems, check if bundle is already present, if it is, check maximum_orderable_quantity and inventory_quantity of bundle parent to make sure we're not surpassing either.
          var bundleId = Number($(e.currentTarget).find(selectors.bundleId).val()); //variant ID of the parent
          var bundleQty = Number($(e.currentTarget).find(selectors.pdfQuantity).val()); //Qty to be added for each bundle product
          var bundleName = $(e.currentTarget).find(selectors.bundleName).val(); //Name of the bundle parent
          var $childProducts = $(e.currentTarget).find(selectors.bundleChildProduct); //jquery obj of all child products

          //Create an array to hold each of the products we'll add for the bundle
          //Because in checkout, the more recently added items appear on top, we'll add the parent product to the *end* of the array so it displays on top.
          var productsToAdd = [];

          //Add the bundle parent to the end of the array
          productsToAdd.push({"id": bundleId, "quantity": bundleQty});

          //Add each of the children products
          $childProducts.each(function(i, el){
            var childProductObj = {
              "id": Number($(el).val()),
              "quantity": bundleQty,
              "properties": {
                "Haul": bundleName,
                "_bundle_id": bundleId.toString()
              }
            };
            productsToAdd.push(childProductObj);
          });

          if(this.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          this._onRequestStart();

          //Add items resolves with a getCart call.
          ShopifyAPI.addItemsToCart( productsToAdd )
            .then(function(data) {
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        }.bind(this));
      },

      buildAndOpenCart: function() {
        ShopifyAPI.getCart().then(function(cart){
          //Fetching the following information and passing it later to the refreshed cart//
          let freeShippingThreshold = cart.free_shipping_threshold;
          let messageuntilFreeShippingRaw = cart.message_until_free_shipping_raw;
          let messageEarnedFreeShipping = cart.message_earned_free_shipping
          let freeShippingMessage = cart.free_shipping_message;

          BOLD.common.cartDoctor.refresh();
          cart = window.BOLD.common.cartDoctor.fix(cart);

          //Adding the information back to the cart object so that it can be used again//
          cart.free_shipping_threshold = freeShippingThreshold;
          cart.message_until_free_shipping_raw = messageuntilFreeShippingRaw;
          cart.message_earned_free_shipping = messageEarnedFreeShipping;
          cart.free_shipping_message = freeShippingMessage;

          BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");

          this.buildCart(cart);
          this.open();

          /*
          var self = this;
          //updateGifts, then build cart
          this.updateFreeGifts(cart)
            .then(self.buildCart.bind(self))
            .then(self.open().bind(self));
          */
        }.bind(this));
      },

      // needed for bold bundles to display the total price correctly in the ajax cart
      // otherwise combinatin of bold bundles and regular items in cart may result in showing an incorrect subtotal amount
      rebuildCartForBold: function() {
        ShopifyAPI.getCart().then(function(cart){
          //Fetching the following information and passing it later to the refreshed cart//
          let freeShippingThreshold = cart.free_shipping_threshold;
          let messageuntilFreeShippingRaw = cart.message_until_free_shipping_raw;
          let messageEarnedFreeShipping = cart.message_earned_free_shipping
          let freeShippingMessage = cart.free_shipping_message;

          cart = window.BOLD.common.cartDoctor.fix(cart);

          //Adding the information back to the cart object so that it can be used again//
          cart.free_shipping_threshold = freeShippingThreshold;
          cart.message_until_free_shipping_raw = messageuntilFreeShippingRaw;
          cart.message_earned_free_shipping = messageEarnedFreeShipping;
          cart.free_shipping_message = freeShippingMessage;

          BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");

          if (BOLD && BOLD.common && BOLD.common.cartDoctor && !isNaN(BOLD.common.cartDoctor.cart.total_price)) {
            BOLD.common.cartDoctor.refresh().then(function () {
              var boldCartPrice = BOLD.common.cartDoctor.cart.total_price;
              var boldCartPriceFormatted = slate.Currency.formatMoney(boldCartPrice, theme.moneyFormat);
              console.log('boldCartPriceFormatted', boldCartPriceFormatted);
              $('#ajax-cart_total_price').text(boldCartPriceFormatted);
            });
          }


          /*
          var self = this;
          //updateGifts, then build cart
          this.updateFreeGifts(cart)
            .then(self.buildCart.bind(self))
            .then(self.open().bind(self));
          */
        }.bind(this));
      },

      /*
      * Shopify needs the 'submit' event to be bound at the form level in order for accurate Pixel/GA tracking.
      * Because of this, we can't catch it at the body element for BH Cosmetics.
      *
      * Solution, two exposed methods : ajaxifyForm and refreshForms.
      */

      /*
      * ajaxifyForm
      *
      * @param { element } el - cart item row or child element
      *
      * Note: This needs called on any elements added after initial dom load (Quick views, nosto, etc.)
      *
      */
      ajaxifyForm : function( el ) {
        var self = this;

        if ( self.seenFormsArr.indexOf( el ) >= 0 ) {
          return; //form is already present in array
        }

        $(el).on('submit', function(e) {
          e.preventDefault();

          if(self.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          self._onRequestStart();

          ShopifyAPI.addItemFromForm( $(e.target) )
            .then(function(data) {
              self._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              self.onItemAddSuccess.call(self, data);
            })
            .fail(function(data) {
              self._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              self.onItemAddFail.call(self, data);
            });
        }.bind(self));

        this.seenFormsArr.push(el); //push the form to the seenFormsArr
      },

      /*
      * refreshForms
      *
      * Method that loops over all addForms and ajaxify's them
      *
      */

      refreshForms: function() {
        var self = this;

        var $allForms = $( selectors.addForm ); //get a new reference to all the forms

        $allForms.each(function(i, el){
          self.ajaxifyForm( el );
        });
      },

     /**
      * Ensure we are working with a valid number
      *
      * @param {int|string} qty
      * @return {int} - Integer quantity.  Defaults to 1
      */
      _validateQty: function(qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

     /**
      * Ensure we are working with a valid number
      *
      * @param {element} el - cart item row or child element
      * @return {obj}
      */
      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id:  $row.data('id'),
          lineItemIndex : $row.data('line-item-index'),
          qty: this._validateQty($row.data('qty'))
        };
      },

      _onRequestStart: function() {
        this.requestInProgress = true;
        this.$el.addClass(classes.cartRequestInProgress);
      },

      _onRequestFinish: function() {
        this.requestInProgress = false;
        this.$el.removeClass(classes.cartRequestInProgress);
      },

      _saveFocus: function(item_id) {
        var activeElement = document.activeElement;
        if(activeElement.hasAttribute('data-ajax-cart-quantity-adjuster-input'))
          this.focusElemType = 'input';
        else if(activeElement.hasAttribute('data-ajax-cart-item-decrement'))
          this.focusElemType = 'decrement';
        else if(activeElement.hasAttribute('data-ajax-cart-item-increment'))
          this.focusElemType = 'increment';
        else
          this.focusElemType = 'input';
        this.focusItemId = item_id;
      },

      _restoreFocus: function() {
        if(!this.focusItemId) return;
        var cartItem = $(selectors.item).filter('[data-id="' + this.focusItemId + '"]');
        if(this.focusElemType === 'input')
          focusElem = cartItem.find('[data-ajax-cart-quantity-adjuster-input]')
        else if(this.focusElemType === 'decrement')
          focusElem = cartItem.find('[data-ajax-cart-item-decrement]')
        else if(this.focusElemType === 'increment')
          focusElem = cartItem.find('[data-ajax-cart-item-increment]')
        else
          focusElem = cartItem.find('[data-ajax-cart-quantity-adjuster-input]')
        focusElem.focus();
        this.focusItemId = null;
      },

      /**
      *
      * Function to check for GWP (Gifts with purchase).
      * Handles adding (if eligible) and removing (if user has become ineligible).
      *
      * @param {object} cart - the cart object to loop over
      * Returns a promise that is resolved upon completion of addition/removal of all relevant gifts
      **/
      updateFreeGifts: function(cart) {
        //Follow the promise pattern, and dont resolve until everything's done.
        var promise = $.Deferred();

        if (!cart.gwp || !cart.gwp.length) {
          promise.resolve(cart);
          return promise;
        }

        var lineItems = cart.items;
        var gwp = cart.gwp;

        var outdatedGifts = []; //array to hold any GWP items currently in the cart.  When we loop throught he GWP array, we remove items we find.  If we have any left over, they need to be removed.
        var giftsToAdd = []; //array to hold GWP product information (variant ID + lineitem props) that we need to add.
        var giftsToRemove = []; //array to hold the lineitem indexes of gifts we need to remove.
        //var giftsToAddWithVariants = []; //unused atm

        //Step 1: Check for any gifts in the cart.  If they've since been removed from the GWP, collection, we'll need to remove them.
        for (var i = 0; i < lineItems.length; i++) {
          var item = lineItems[i];
          if ( item.is_gwp ) {
            //if the lineitem is a GWP, push it to the giftsincart array, with its index matching that of its lineitem index in shopify.
            outdatedGifts[item.lineitem_index] = item.id;
          }
        }

        //Step 2: Loop through the GWP array returned with the cart JSON, which contains all products in the 'Gift with Purchase' collection
        for (var j = 0; j < gwp.length; j++) {
          var freeGift = gwp[j];

          if (!freeGift.available) {
            continue; //skip free gifts that aren't available
          }

          //For each GWP, we remove them from the outdatedGifts array if they're still present.
          var giftInCartIndex = outdatedGifts.indexOf(freeGift.id);
          if (giftInCartIndex > -1){
            outdatedGifts.splice(giftInCartIndex, 1);
          }

          if (freeGift.requirements_met && !freeGift.in_cart) {
            //The user's cart is eligible for the gift, but gift is not present in cart...
            //if (!freeGift.has_variants) {
              //The eligible gift does not have variants, so we can auto-add it!
              var giftToAdd = {
                gwp_id : freeGift.id,
                variant_id : freeGift.variant_id
              };

              //Lineitem props to be added with the item.
              giftToAdd.requires = freeGift.requires;
              giftToAdd.requires_details = freeGift.requires_details;
              giftToAdd.requires_msg = freeGift.requires_msg;

              //Conditional props to determine if product is eligible to be earned with a discount code.
              if (freeGift.non_combinable_w_discount) {
                giftToAdd.non_combinable = true;
                giftToAdd.non_combinable_msg = freeGift.non_combinable_msg;
              }


              //Push the gift to the array of GWP we'll need to add.
              giftsToAdd.push(giftToAdd);
            //} else {
              //For GWP that *have* variants, we're conditionally showing a message on the ajax-cart/cart templates.
              //This comment is here strictly to notify you that the logic is located on the template.
            //}
          } else if (!freeGift.requirements_met && freeGift.in_cart) {
            //Gift is in cart, but requirements are no longer met. Mark for removal.
            giftsToRemove.push(freeGift.lineitem_index);
          }
        }

        //Step 2.5
        //If we have any gifts left over in the outdatedGifts array, they've been removed from the GWP
        //since the user last modified their cart, so we also need to remove them!
        $.each(outdatedGifts, function(i, el){
          if (el !== undefined) {
            giftsToRemove.push(i); //the elements are pushed to outdatedGifts at the index == to their lineitem index, so we push the index to remove.
          }
        });

        //Function to update the next gift
        var updateNext = function(){
          if (giftsToAdd.length){
            //console.log('giftsToAdd', giftsToAdd);
            //add item, shift the giftsToAdd array
            var giftToAdd = giftsToAdd[0];
            var giftToAddId = giftToAdd.variant_id;
            var giftToAddProps = {
              "_gwp_id": giftToAdd.gwp_id,
              "_gwp_requires": giftToAdd.requires,
              "_gwp_details": giftToAdd.requires_details,
              "Free Gift": giftToAdd.requires_msg //message that display in checkout
            };

            //If item isn't eligible to be combined with other discounts, we add a lineitem prop to display at checkout.
            if (giftToAdd.non_combinable) {
              giftToAddProps["Not Combinable"] = giftToAdd.non_combinable_msg;
            }

            ShopifyAPI.addItemToCart(giftToAddId, 1, giftToAddProps)
              .then(function(){
                giftsToAdd.shift();
                updateNext();
              });

          } else if (giftsToRemove){
            //console.log('giftsToRemove', giftsToRemove);
            //Because the lineitem indexes would change if we did these one at a time, we instead use the change.js's array feature to update all quantities at once, but first we have to get the current state of the cart.
            ShopifyAPI.getCart().then(function(cart){
              var quantities = [];
              for (var i = 0; i < cart.items.length; i++) {
                if (giftsToRemove.indexOf(i+1) > -1) {
                  quantities.push(0);
                } else {
                  quantities.push(cart.items[i].quantity);
                }
              }

              giftsToRemove = false;

              ShopifyAPI.changeItemQuantities(quantities)
                .then(function(){
                  updateNext();
                });
            });

          } else {
            //We're done, get cart and return it
            ShopifyAPI.getCart().then(function (data) {
              promise.resolve(data); //get cart and resolve with the data
            });
          }
        }

        //If there are no gift changes, resolve with the cart data we originally fetched in this method.
        if (giftsToAdd.length == 0 && giftsToRemove.length == 0){
          promise.resolve(cart);
        } else {
          //If there are, we instead kick off the gift updating above by calling updateNext once.
          updateNext();
        }

        return promise;
      },



      addBackdrop: function(callback) {
        var _this = this;
        var cb    = callback || $.noop;

        if(this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
                        .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this));

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function(){
            _this.$backdrop && _this.$backdrop.remove();
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        var self = this;
        //updateGifts, then build cart
        this.updateFreeGifts(cart)
          .then(self.buildCart.bind(self));

        //open cart in the meantime.
        this.open();

      },

     /**
      * STUB - Callback when adding an item fails

      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        //console.log('['+this.name+'] - onItemAddFail');
        console.warn('['+this.name+'] - ' + data.message);
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {
        console.log('['+this.name+'] - onCartRender');
        slate.quantityAdjuster.refresh(); //refresh all quantity adjusters
        this._restoreFocus();
        var ajaxCartLoadedEvent = new CustomEvent('BMS_AJAX_CART_LOADED');
        document.body.dispatchEvent(ajaxCartLoadedEvent);

        //console.log('rebuildCartForBold in onCartRender');
        var e = new Event("rebuildCartForBold");
        window.dispatchEvent(e)
      },

     /**
      * Callback for when the cart HTML is removed from the page
      * Allows us to do cleanup on any event handlers applied post-render
      */
      onCartDestroy: function(e) {
        // console.log('['+this.name+'] - onCartDestroy');
      },

     /**
      * Builds the HTML for the ajax cart.
      * Modifies the JSON cart for consumption by our handlebars template
      *
      * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
      * @return ??
      */

      buildCart: function(cart) {
        // All AJAX Cart requests finish with rebuilding the cart
        // So this is a good place to add this code
        this._onRequestFinish();

        //Get the additional checkout buttons
        /* //replaced with a better approach
        if ( this.hasDynamicCheckout ) {
           this.dynamicCheckoutTextArea.innerHTML = cart.express_checkout_encoded_html;
           //Get the value of the new textarea and bind it to the dom.
          cart.expressCheckoutHtml = this.dynamicCheckoutTextArea.value;
        }
        */
       if (BOLD && BOLD.common && BOLD.common.cartDoctor){
        if (cart.free_shipping_threshold) {
            BOLD.common.customInfoFreeShippingThreshold = cart.free_shipping_threshold;
            BOLD.common.customInfoMessageuntilFreeShippingRaw = cart.message_until_free_shipping_raw;
            BOLD.common.customInfoMessageEarnedFreeShipping = cart.message_earned_free_shipping;
            BOLD.common.customInfoFreeShippingMessage = cart.free_shipping_message;
        }
        BOLD.common.cartDoctor.refresh().then(function () {
        cart = BOLD.common.cartDoctor.cart;
        cart.free_shipping_threshold = BOLD.common.customInfoFreeShippingThreshold;
        cart.message_until_free_shipping_raw = BOLD.common.customInfoMessageuntilFreeShippingRaw;
        cart.message_earned_free_shipping = BOLD.common.customInfoMessageEarnedFreeShipping;
        cart.free_shipping_message = BOLD.common.customInfoFreeShippingMessage;
        //console.log("Complete Cart Info Is: ", cart) // This log to be used to see if the information that is being received is correct or not//
        if (isNaN(BOLD.common.cartDoctor.cart.total_price)) {
          $('.ajax-cart__shipping-block').addClass('hidden');
        } else {
          $('.ajax-cart__shipping-block').removeClass('hidden');
          var boldCartPrice = BOLD.common.cartDoctor.cart.total_price;
          var amount_till_free_shipping = cart.free_shipping_threshold * 100 - boldCartPrice;
          //console.log(`amount_till_free_shipping is `, amount_till_free_shipping);
          if (amount_till_free_shipping > 0) {
            var remainder = slate.Currency.formatMoney(amount_till_free_shipping, theme.moneyFormat);
            cart.free_shipping_message = cart.message_until_free_shipping_raw.replace("[value]", remainder);
          } else {
            cart.free_shipping_message = cart.message_earned_free_shipping;
          }
          //TODO update to dynamic selector
          $('.ajax-cart__shipping-block__content').innerHTML = cart.free_shipping_message;
        }

       })

      }

        //Free shipping calculation
        this.freeShippingTextArea.innerHTML = cart.free_shipping_message;
        cart.free_shipping_message = this.freeShippingTextArea.value;

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        // cart.total_price = slate.Currency.stripZeroCents(cart.total_price);
        cart.total_savings = cart.total_savings > 0 ? slate.Currency.formatMoney(cart.total_savings, theme.moneyFormat) : null;

        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
          item.formatPrice = slate.Currency.formatMoney(item.price, "{{amount}}");

          // Adjust the item's variant options to add "name" and "value" properties
          if(item.hasOwnProperty('product')) {
            var product = item.product;
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var name  = product.options[i];
              var value = item.variant_options[i];


              item.variant_options[i] = {
                name: name,
                value: value
              };

              // Don't show this info if it's the default variant that Shopify creates
              if(value == "Default Title") {
                delete item.variant_options[i];
              }
            }
          }
          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */
        $window.trigger(this.events.DESTROY);
        this.$container.empty().append( this.template(cart) );
        $window.trigger(this.events.RENDER);
        $window.trigger(this.events.UPDATE);

        this.updateCartCount(cart);

        if (BOLD && BOLD.common && BOLD.common.cartDoctor) {
          if (isNaN(BOLD.common.cartDoctor.cart.total_price)) {
          	$('.ajax-cart__shipping-block').addClass('hidden');
          } else {
            $('.ajax-cart__shipping-block').removeClass('hidden');
            var boldCartPrice = BOLD.common.cartDoctor.cart.total_price;
            var amount_till_free_shipping = cart.free_shipping_threshold*100 - boldCartPrice;
            if (amount_till_free_shipping > 0) {
              var remainder = slate.Currency.formatMoney(amount_till_free_shipping, theme.moneyFormat);
              cart.free_shipping_message = cart.message_until_free_shipping_raw.replace("[value]", remainder);
            } else {
              cart.free_shipping_message = cart.message_earned_free_shipping;
            }
            //TODO update to dynamic selector
            $('.ajax-cart__shipping-block__content').innerHTML = cart.free_shipping_message;
          }
        }
        //console.log("cart.additional_checkout_buttons", cart.additional_checkout_buttons);
        if (!cart.additional_checkout_buttons) {
          $('.additional-checkout-buttons').addClass('hidden');
        } else {
          $('.additional-checkout-buttons').removeClass('hidden');
        }

        // Reload nosto - because of how we rebuild the nosto cart, the nosto placeholder div will be 'empty'.
        // This reloads *all* nosto recs, but thats the only api call they have, you can't scope it.
        //
        // Hypothetical: The loadRec's function fires based on classname, so you could comb through and temporarily change
        // all instances of the classname 'nosto_element' to something else, call loadRecs, then change them back.
        // This would allow you to only update the elements whose classnames you don't alter.
        if (typeof nostojs !== "undefined") {
          nostojs(function(api){
            api.sendTagging("ajax-cart"); //resubmits the cart data in ajax-cart to nosto
            api.loadRecommendations(); //loads new rec based on the updated cart data.
          });
        }

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }


      },

     /**
      * Update the cart badge + count here
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      updateCartCount: function(cart) {

        this.$cartBadgeCount.html(cart.item_count);

        if(cart.item_count) {
          this.$cartBadge.addClass(classes.cartBadgeHasItems);
        }
        else {
          this.$cartBadge.removeClass(classes.cartBadgeHasItems);
        }
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */

      onItemRemoveClick: function(e) {

        e.preventDefault();
        clearTimeout(this.quantityAdjusterTimeout); //clear any lingering timeouts

        if(this.requestInProgress) return;

        var self = this;

        this.quantityAdjusterTimeout = setTimeout(function(){
          var attrs = self._getItemRowAttributes(e.target);
          var newQty = Number(0); //set the quantity to 0
          var lineItemIndex = Number(attrs.lineItemIndex);

          var isBundleProduct = $(e.target).parents( selectors.bundleProduct ).length; //check if there's a [data-bundle-product] parent.
          var bundleId = $(e.target).parents( selectors.bundleProduct ).data( dataAttr.bundleId ); //get the id of the bundle

          self._onRequestStart();

          //Start every quantity change with a getCart, so we can keep quantities below both the order_limit and the inventory_quantity of a given product.  We match up the item we're incrementing with the lineitem prop grabbed above
          ShopifyAPI.getCart().then(function(cart){
            var lineItems = cart.items;
            var lineItemToBeModified = cart.items[lineItemIndex - 1]; //line-item-index is 1-based.


            if (isBundleProduct){
              //For Bundle products, we have to increase all the products at once!
              //Loop over items, compose array of quantities
              var quantities = [];
              for (var i = 0; i < lineItems.length; i++) {
                var lineItem = lineItems[i];
                //If the lineitem's product id matches the bundle id, it's the parent product
                //If the lineitem's _bundle_id matches the bundleId, it's a child product
                if(lineItem.properties.customBundleId == Number(bundleId) || lineItem.bundle_id == bundleId ) {
                  //Bundle parent or child
                  quantities.push(newQty);
                } else {
                  //Non-bundle item
                  quantities.push(Number(lineItem.quantity)); //keep the other item quantities the same
                }
              }

              ShopifyAPI.changeItemQuantities(quantities)
                .then(ShopifyAPI.getCart)
                .then(self.updateFreeGifts)
                .then(self.buildCart.bind(self));

            } else {
            var maxOrderQty = lineItemToBeModified.maximum_orderable_quantity; //based on order-limits and remaining inventory.
            //Quantity can't be increased beyond the max_orderable_quantity, or the inventory of a given product.
            newQty = Math.min(newQty, maxOrderQty);

              if (newQty == lineItemToBeModified.quantity) {
                // The calculated newQty isn't diff. than the current quantity
                // We already got the cart above, so we can just build off it.
                self.buildCart(cart);
              } else {
                //With the inclusion of bundles, we can't trust variant ID's anymore, so only modify quantities by lineItem.
                ShopifyAPI.changeItemQuantityByIndex(attrs.lineItemIndex, newQty)
                  .then(ShopifyAPI.getCart)
                  .then(self.updateFreeGifts)
                  .then(self.buildCart.bind(self));
              }
            }
          });
        }, this.quantityAdjusterTimeoutDelay );
      },

     /**
      * Change the quantity of an item in the cart based on quantity adjuster
      *
      * @param {event} e - Click event
      */

      onItemQuantityChange: function(e) {
        e.preventDefault();
        clearTimeout(this.quantityAdjusterTimeout); //clear any lingering timeouts

        if(this.requestInProgress) return;

        var self = this;

        this.quantityAdjusterTimeout = setTimeout(function(){
          var attrs = self._getItemRowAttributes(e.target);
          var newQty = Number(attrs.qty < 1 ? 0 : e.target.value); //we don't want quantity to be able to go below 0
          var lineItemIndex = Number(attrs.lineItemIndex);

          var isBundleProduct = $(e.target).parents( selectors.bundleProduct ).length; //check if there's a [data-bundle-product] parent.
          var bundleId = $(e.target).parents( selectors.bundleProduct ).data( dataAttr.bundleId ); //get the id of the bundle

          self._saveFocus(attrs.id);
          self._onRequestStart();

          //Start every quantity change with a getCart, so we can keep quantities below both the order_limit and the inventory_quantity of a given product.  We match up the item we're incrementing with the lineitem prop grabbed above
          ShopifyAPI.getCart().then(function(cart){
            var lineItems = cart.items;
            var lineItemToBeModified = cart.items[lineItemIndex - 1]; //line-item-index is 1-based.
            var maxOrderQty = lineItemToBeModified.maximum_orderable_quantity; //based on order-limits and remaining inventory.

            //Quantity can't be increased beyond the max_orderable_quantity, or the inventory of a given product.
            newQty = Math.min(newQty, maxOrderQty);

            if ( newQty == lineItemToBeModified.quantity ) {
              // The calculated newQty isn't diff. than the current quantity
              // We already got the cart above, so we can just build off it.
              self.buildCart(cart);

            } else if (isBundleProduct){
              //For Bundle products, we have to increase all the products at once!
              //Loop over items, compose array of quantities
              var quantities = [];
              for (var i = 0; i < lineItems.length; i++) {
                var lineItem = lineItems[i];
                //If the lineitem's product id matches the bundle id, it's the parent product
                //If the lineitem's _bundle_id matches the bundleId, it's a child product
                if(lineItem.variant_id == Number(bundleId) || lineItem.bundle_id == bundleId ) {
                  //Bundle parent or child
                  quantities.push(newQty);
                } else {
                  //Non-bundle item
                  quantities.push(Number(lineItem.quantity)); //keep the other item quantities the same
                }
              }

              ShopifyAPI.changeItemQuantities(quantities)
                .then(ShopifyAPI.getCart)
                .then(self.updateFreeGifts)
                .then(self.buildCart.bind(self));

            } else {
              //With the inclusion of bundles, we can't trust variant ID's anymore, so only modify quantities by lineItem.
              ShopifyAPI.changeItemQuantityByIndex(attrs.lineItemIndex, newQty)
                .then(ShopifyAPI.getCart)
                .then(self.updateFreeGifts)
                .then(self.buildCart.bind(self));
            }
          });
        }, this.quantityAdjusterTimeoutDelay );
      },

      /**
      * Get the current quantity of the selected item when a quantity adjuster in the ajax cart gets input
      *
      * @param {event} e - focus event
      */
      onItemQuantityFocus: function(e) {
        if(this.requestInProgress) return;

        this.selectedItemQuantity = $(e.target).val(); //get starting val to compare when input loses focus.
        $(e.target).on(this.events.KEYDOWN, function(e){
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if (keycode == 13){
            $( e.target ).blur(); //trigger blur
          }
        });
      },

      /**
      * Change the quantity by interacting directly with the input
      *
      * @param {event} e - blur event
      */
      onItemQuantityBlur: function(e) {
        e.preventDefault();
        $(e.target).off(this.events.KEYDOWN); //remove the eventHandler we attach in the onItemQuantityFocus handler

        if(this.requestInProgress) return;

        var self = this;
        var newQty = $(e.target).val();

        if (this.selectedItemQuantity ==  newQty) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._saveFocus(attrs.id);
        this._onRequestStart();
        ShopifyAPI.changeItemQuantity(attrs.lineItemIndex, newQty)
          .then(function(){
              ShopifyAPI.getCart()
                .then(self.updateFreeGifts)
                .then(self.buildCart.bind(self));
            });

      },

     /**
      * Click the 'ajaxCart - trigger' selector
      *
      * @param {event} e - Click event
      */
      onTriggerClick: function(e) {
        e.preventDefault();
        this.toggleVisibility();
      },

     /**
      * Click the 'ajaxCart - close' selector
      *
      * @param {event} e - Click event
      */
      onCloseClick: function(e) {
        e.preventDefault();

        // Do any cleanup before closing the cart
        this.close();
      },

     /**
      * Click the 'ajaxCart - AfterPay Info' selector
      *
      * @param {event} e - Click event
      */
      onAfterpayInfoClick: function(e) {
        e.preventDefault();
        //Show Afterpay Info Popup
        if (Afterpay.launchPopup != 'undefined' && typeof Afterpay.launchPopup == 'function') {
          Afterpay.launchPopup($, e);
        }
      },


     /**
      * Opens / closes the cart depending on state
      *
      */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

     /**
      * Check the open / closed state of the cart
      *
      * @return {bool}
      */
      isOpen: function() {
        return this.stateIsOpen;
      },

     /**
      * Returns true is the cart is closed.cx
      *
      * @return {bool}
      */
      isClosed: function() {
        return !this.stateIsOpen;
      },

     /**
      * STUB METHOD - Code for opening the cart
      */
      open: function() {
        if(this.stateIsOpen) return;
        this.stateIsOpen = true;

        if(this.settings.backdrop) {
          $body.addClass(classes.bodyCartOpen);
          this.addBackdrop();
        }

        this.$el.addClass(classes.cartOpen);
        // this.focus();
        // $body.on('focusin', this.checkFocus.bind(this));
        this.$el.attr(dataAttr.ariaAjaxCartHidden, 'false');
        $('iframe[title="Checkout with PayPal"]').contents().find('iframe').attr('title', "PayPal Button");
      },

     /**
      * STUB METHOD - Code for closing the cart
      */
      close: function() {
        if(!this.stateIsOpen) return;

        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);

        if(this.settings.backdrop) {
          this.removeBackdrop(function() {
            $body.removeClass(classes.bodyCartOpen);
          });
          $(selectors.trigger).focus();
        }

      },
      focus: function() {
        $(selectors.close).focus();
        var firstFocusableEl = document.querySelector(selectors.close),
            lastFocusableEl = document.getElementById('ajax-cart__bottom-focus'),
            currentFocus,
            KEYCODE_TAB = 9;

        document.getElementById('ajax-cart').addEventListener('keydown', function(e) {
          if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
            currentFocus = document.activeElement;
              if ( e.shiftKey ) /* shift + tab */ {
                  if (document.activeElement === firstFocusableEl) {
                      lastFocusableEl.focus();
                      e.preventDefault();
                  }
               }
          }
        });

        $('#ajax-cart__bottom-focus').focus(function(){
          if (currentFocus.className == "ajax-cart__close") {
            $('.ajax-cart__checkout button[type=submit]').focus();
            currentFocus = document.activeElement;
          } else {
            $(".ajax-cart__close").focus();
            currentFocus = document.activeElement;
          }
        })
        this.$el.attr(dataAttr.ariaAjaxCartHidden, 'true');
      }


    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);
/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300,
    fast:     150,
    fastest:  50,
    slow:     600,
    medium:   400,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));
/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_BH-Cosmetics_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user';
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  }

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
      subscriptionSlideupSeen: {
        name: 'subscriptionSlideup_seen',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      }      
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    generateCookie: function(key) {
      var c;
      if(this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        console.warn('['+this.name+'] - Cannot create cookie.  Key "' + key + '" not found.' );
      }
      return c;
    },    
    
   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName );
      return this;
    }
  });

  return new User();

}(Cookies));

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    w = w != undefined ? w : $window.width();
    
    var previousKey;
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w > bpMinWidth) {
        previousKey = k;
      }
      else {
        foundKey = previousKey;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    getBreakpointMinWidthKeyForWidth: getBreakpointMinWidthKeyForWidth
  };

}(jQuery));
/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {
  var selectors = {
    el: '[data-product-card]',
    gallery: '[data-product-card-gallery]',
    mainLazyImg: '[data-product-card-main-lazy]',
    altLazyImg: '[data-product-card-alt-lazy]',
    backInStockTrigger: '[data-back-in-stock-trigger]',
    backInStockTriggerInner: '[data-back-in-stock-trigger-inner]'
  };

  var classes = {
    mainLoaded: 'is-loaded',
    altLoaded: 'alt-loaded' // added to the product card once the alt image is loaded to avoid a flash of white while loading
  };

  var events = window.PointerEvent ? {
              end:   "pointerup",
              enter: "pointerenter",
              leave: "pointerleave"
            } : {
              end: "touchend",
              enter: "mouseenter",
              leave: "mouseleave"
            };

  function onEnter(e) {
    var $productCard = $(e.currentTarget);
    var $lazyImg = $productCard.find( selectors.altLazyImg );

    if($lazyImg.length) {
      $lazyImg.on('load', function() {
        $productCard.addClass(classes.altLoaded);
      });
      $lazyImg.attr('src', $lazyImg.data('src'));
      $lazyImg.removeAttr('data-src');
    }
  }

  $(document).ready(function() {

    var $productCards = $(selectors.el);

    if(!$productCards.length) {
      return;
    }

    $productCards.one(events.enter, onEnter);

    // Unveil plugin to lazy load main product card images
    $(selectors.mainLazyImg).unveil(200, function() {
      var $img = $(this);
      $img.on('load', function() {
        $img.parents(selectors.gallery).addClass(classes.mainLoaded);
      });
    });

    //Allow clicks on the inner text of the BIS triggers to trigger a click on the trigger itself.
    $('body').on('click', selectors.backInStockTriggerInner, function(e){
      $( e.target ).parent( selectors.backInStockTrigger ).trigger('click');
    });
  });



}());
/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {
  var selectors = {
    addForm: 'form[action^="/cart/add"]',
    addToCart: "[data-add-to-cart]", //add to cart button
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productZoomButton: "[data-zoom-button]",
    productGallery: "[data-product-gallery]",
    productGalleryImage: "[data-product-gallery-image]", //list items that contain the images
    productGallerySlideshow: "[data-product-gallery-slideshow]",
    productGallerySlideLink: "[data-product-gallery-slide-link]",
    productGalleryThumbnail: "[data-product-gallery-thumbnail]",
    productGalleryThumbnailSlide: "[data-product-gallery-thumbnail-slide]",
    initialSlide: "[data-initial-slide]",
    percentageOff: "[data-percentage-off]",
    saleBadge: ".product-badge--sale",
    productJson: "[data-product-json]",
    productPriceWrap: "[data-price-wrapper]",
    productPrice: "[data-product-price]",
    productSubtitle: "[data-single-option-selected-value-subtitle]",
    singleOptionSelectedValue:
      "[data-single-option-selected-value][data-position]",
    singleOptionSelector: "[data-single-option-selector]",
    variantOptionValueList:
      "[data-variant-option-value-list][data-option-position]",
    variantOptionValue: "[data-variant-option-value]",
    lowStockIndicator: "[data-low-stock-indicator]",
    quantityInput: '[data-quantity-adjuster] input[type="number"]',
    fullDetailsLink: "[data-full-details-link]",
    quickViewGallery: "[data-quick-view-gallery]", //Determines if scroll-with-page gets initialized or not.
    scrollWithPageEl: "[data-scroll-with-page]",
    scrollWithPageContainer: "[data-scroll-with-page-container]",
    header: "[data-fixed-header-wrap]",
    pdpStickyFooter: "[data-product-detail-sticky-footer]", //Not used as of now
    hiddenVariantSelectMenu: "[data-hidden-variant-menu]", //Hidden variant select menu for mobile PDP
    hiddenVariantMenuSwatches: "[data-hidden-variant-menu-swatches]", //Space to replicate the swatches
    showVariantSelectMenuBtn: "[data-show-variant-menu]", //button to show hidden variant select on mobile PDP.
    hideVariantSelectMenuBtn: "[data-hide-variant-menu]", //button to show hidden variant select on mobile PDP.
    scrollspyLinks: "[data-scrollspy-target]", //Links/thumbnails that direct towards the scrollspy target id's.
    scrollspyTargets: "[data-scrollspy-id]", //we're targeting the ID here, as the targets always have an ID class (slick has a habit of replacing the id attribute, which is why this is in a data-attr.)
    backInStockTrigger: "[data-back-in-stock-trigger]", //Trigger to fire back in stock.  Check if it's present before doing anything with it.
    backInStockTriggerInner: "[data-back-in-stock-trigger-inner]", //Because of the way BH buttons are formed, we need to trigger clicks on the trigger whenever the inner span is clicked.
    timerInput: "[data-timer-input]", //Stores the date and time the timer is counting down to
    icons: ".product-icons",
    productInfoLink: '[data-product-info-target]',
    productInfoTab: '[data-product-info-tab]',
  };

  var classes = {
    hiddenDetail: "hide",
    hiddenGallery: "hide",
    hiddenAddToCart: "hidden",
    variantOptionValueActive: "is-active",
    zoomReady: "is-zoomable",
    zoomedIn: "is-zoomed",
    headerIsFixed: "site-fixed-header",
    hiddenVariantMenuIsVisible: "is-visible", //class that gets added/removed from the menu itself
    backdrop: "mobile-variant-menu-backdrop", //stealing drawer backdrop
    backdropVisible: "is-visible",
    productOnSale: "product-detail--sale-price" //added to the price wrapper when current_variant has a markdown
  };

  var dataAttr = {
    backInStockVariantId: "variant-id", //data attribute that determines which variant is preselected in the back in stock popup
    productInfoLinkTarget: 'product-info-target',
    productInfoTabId: 'product-info-tab',
  };

  var $window = $(window);
  var $body = $(document.body);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableZoom - Toggle zoom capabilities on / off
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {
    this.settings = {};
    this.name = "productDetailForm";
    this.namespace = "." + this.name;
    var self = this;
    var $window = $(window);

    this.events = {
      RESIZE: "resize" + this.namespace,
      CLICK: "click" + this.namespace,
      READY: "ready" + this.namespace,
      TRANSITIONEND: slate.utils.whichTransitionEnd() + this.namespace
    };

    var ready = false;
    var options = options || {};
    var defaults = {
      enableZoom: true,
      enableHistoryState: true,
      minThumbnails: 3
    };

    this.initialize = function() {
      if (ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn("[" + this.name + "] - $el required to initialize");
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject = JSON.parse(
        $(selectors.productJson, this.$container).html()
      );

      var isBundleProduct =
        this.productSingleObject.type == "Bundle" ? true : false;

      // Get the max we want people to be able to add
      // This is set as a data attribute because the 'max' attribute can be less than this
      // if the current_variant has less than this number available
      this.QUANTITY_INPUT_LIMIT =
        parseInt($(selectors.quantityInput, this.$container).attr("max")) || 10;
      this.LOW_STOCK_INDICATOR_QTY =
        this.$container.data("low-stock-indicator-qty") || 10;

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(variantOptions);
      this.updateProductSaleBadge(this.variants.currentVariant);

      // See slate.Variants
      this.$container.on(
        "variantChange" + this.namespace,
        this.onVariantChange.bind(this)
      );

      this.$container.on(
        this.events.CLICK,
        selectors.variantOptionValue,
        this.onVariantOptionValueClick.bind(this)
      );

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      //Initialize quantity controls to put maximum on PDP quantity adjuster
      if (!isBundleProduct) {
        //temp workaround while we hash out bundles
        this.updateQuantityControls(this.variants._getVariantFromOptions());
      }

      ready = true;

      //Variables to determine how the gallery should be behaving:
      this.breakpointMin = slate.breakpoints.getBreakpointMinWidth("md"); //Breakpont: change this to cause the behavior to swap at diff. breakpoints.
      this.belowBreakpoint =
        window.innerWidth < this.breakpointMin ? true : false; //bool to keep track of whether we're under/over
      this.isQuickView =
        $(selectors.quickViewGallery, this.$container).length > 0
          ? true
          : false; //bool, determines if we're in the quick view or not by looking for a data-att.

      this.$addForm = $(selectors.addForm, this.$container);

      if (
        this.$addForm.length &&
        this.isQuickView &&
        slate.AjaxCart.ajaxifyForm
      ) {
        slate.AjaxCart.ajaxifyForm(this.$addForm[0]); //ajaxify the form if we're initializing a quickview.
      }

      // Info
      this.$productInfoLinks = $(selectors.productInfoLink, this.$container);
      this.$productInfoTabs = $(selectors.productInfoTab, this.$container);

      //If there are any info tabs...
      if ( this.$productInfoLinks.length ) {
        this.$productInfoLinks.eq(0).addClass( classes.infoLinkIsActive );
      }

      //If there are more than one info tabs...
      if ( this.$productInfoLinks.length > 1 ) {
        this.$productInfoLinks.on('click', this.handleInfoLinkClick.bind(this));
        this.$productInfoTabs.each(function(i){
          if ( i==0 ) {
            return;
          }

          $( this ).hide(); //hide all except the first tab.
        });
      } else if ( this.$productInfoLinks.length ) { //Else if there's only 1...
        this.$productInfoLinks.on('click', function(e){ e.preventDefault(); }); //Just prevent the link from firing so it doesn't jump the user up the page.
      }

      // Wishl
      window.wishl = window.wishl || new slate.models.Wishlist(this.$container);
      this.showNotification = window.wishl;

      //Scroll With Page vars - Makes elements with the selector scroll with the page.
      this.scrollingElements = []; //array to reference the scrollingElement objects that get created (since there can be more than one)
      this.$scrollWithPageEls = $(selectors.scrollWithPageEl, this.$container);
      this.$scrollWithPageContainer = $(
        selectors.scrollWithPageContainer,
        this.$container
      );
      this.$scrollWithPageOffset = $("body").hasClass(classes.headerIsFixed)
        ? $(selectors.header)
        : false; // if we're using the fixed header, pass it the header element.

      //Init galleries.
      this.initGalleries();

      this.$showVariantMenuBtn = $(
        selectors.showVariantSelectMenuBtn,
        this.$container
      );
      this.$hiddenVariantMenu = $(
        selectors.hiddenVariantSelectMenu,
        this.$container
      );

      //If select-shades btn is present, and the hidden variants menu is present...
      if (this.$showVariantMenuBtn.length && this.$hiddenVariantMenu.length) {
        this.hasHiddenVariantMenu = true;
        this.$showVariantMenuBtn.on(
          "click",
          this.showHiddenVariantMenu.bind(this)
        );
        $(selectors.hideVariantSelectMenuBtn, this.$container).on(
          "click",
          this.hideHiddenVariantMenu.bind(this)
        );
      }

      //If Back In Stock trigger is present, set an object property and bind a click trigger to act on its parent
      this.backInStockActive =
        $(selectors.backInStockTrigger, this.$container).length > 0
          ? true
          : false;

      if (this.backInStockActive) {
        var $backInStockTriggerInner = $(
          selectors.backInStockTriggerInner,
          this.$container
        );
        $backInStockTriggerInner.on("click", function(e) {
          $(this)
            .parent(selectors.backInStockTrigger)
            .trigger("click");
        });
      }

      // Icons
      this.$icons = $(selectors.icons, this.$container);

      $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));
      this.onResize();
    };

    return this;
  }

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {
    handleInfoLinkClick : function(e){
      //On click of an info link, show info-tab with the matching data-attr
      e.preventDefault();
      var $this = $( e.target );

      if ( $this.hasClass('is-active') ) {
        return false;
      }

      var targetTab = $this.data( dataAttr.productInfoLinkTarget );

      this.$productInfoTabs.hide(); //hide all info blocks
      $( targetTab ).show(); //show the one with the matching id

      this.$productInfoLinks.removeClass('is-active');
      $this.addClass('is-active');

      return false;
    },

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function onSlideshowSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);

        if (self.settings.enableZoom) {
          self.destroyHoverZoom($zoomTarget);
        }

        //break anchor links
        $(slick.$slides)
          .find(selectors.productGallerySlideLink)
          .on("click.breakImageLink", function(e) {
            e.preventDefault();
          });
      }

      function onSlideshowSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          self.initHoverZoom($zoomTarget);
        }

        //reenable anchor links
        $(slick.$slides)
          .find(selectors.productGallerySlideLink)
          .off("click.breakImageLink");
      }

      function onSlideshowSlickInit(e, slick) {
        if (slick.$slides) {
          var $zoomTarget = $(slick.$slides[slick.currentSlide]);
          if (self.settings.enableZoom) {
            self.initHoverZoom($zoomTarget);
          }
        }
      }

      function onSlideshowSlickDestroy(e, slick) {
        if (self.settings.enableZoom) {
          $(slick.$slides).each(function(i, el) {
            self.destroyHoverZoom($(el));
          });
        }
      }

      $galleries.each(function() {
        var $slideshow = $(this).find(selectors.productGallerySlideshow);
        var $thumbnail = $(this).find(selectors.productGalleryThumbnail);
        var slidesLength = $thumbnail.find(
          selectors.productGalleryThumbnailSlide
        ).length;
        var hasEnoughSlides = slidesLength > self.settings.minThumbnails

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length
          ? $(this)
              .find(selectors.initialSlide)
              .index()
          : 0;

        if ($slideshow.length > 0) {
          $slideshow.on({
            init: onSlideshowSlickInit,
            beforeChange: onSlideshowSlickBeforeChange,
            afterChange: onSlideshowSlickAfterChange,
            destroy: onSlideshowSlickDestroy
          });

          $slideshow.slick({
            dots: false,
            fade: true,
            swipe: Modernizr.touchevents,
            arrows: false,
            asNavFor:
              hasEnoughSlides ? "#" + $thumbnail.attr("id") : false, //have to check if the thumbnails exist...
            initialSlide: initialSlide,
            accessibility: false,
            draggable: true,
            speed: 100,
            infinite: true,
            cssEase: "linear",
            swipeToSlide: true,
            slidesToScroll: 1,
            touchThreshold: 32,
            waitForAnimate: false,
            centerPadding: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  arrows: true,
                  fade: false,
                  center: true,
                  slidesToShow: 1,
                  centerPadding: '32px',
                  prevArrow:
                    '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
                  nextArrow:
                    '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
                }
              }
            ]
          });
        }

        if ($thumbnail.length > 0) {
          var slidesLength = $thumbnail.find(
            selectors.productGalleryThumbnailSlide
          ).length;
          // Slick has trouble when slidesToShow = slide number
          var slidesToShow = slidesLength == 4 ? 3 : 4;

          if (hasEnoughSlides) {
            //Initialize slick if the thumbnails cause height to be > height of slideshow
            $thumbnail.slick({
              speed: 600,
              slidesToShow: slidesToShow,
              slidestoScroll: 1,
              infinite: true,
              dots: false,
              arrows: true,
              asNavFor: "#" + $slideshow.attr("id"),
              prevArrow:
                '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
              nextArrow:
                '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
              initialSlide: initialSlide,
              accessibility: false,
              draggable: true
            });
          }
          else {
            $thumbnail.addClass('has-no-slider');
            $thumbnail.find(selectors.productGalleryThumbnailSlide).first().addClass('is-active');
          }

          $thumbnail.on(
            self.events.CLICK,
            selectors.productGalleryThumbnailSlide,
            function() {
              var index = $(this).index();
              if (hasEnoughSlides) {
                index = $(this).data("slick-index");
              }
              else {
                $thumbnail.find(selectors.productGalleryThumbnailSlide).each(function (i, el) {
                  $(el).toggleClass('is-active', i === index);
                })
              }
              $slideshow.slick("slickGoTo", index);
            }
          );
        }
      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not(classes.hiddenGallery).each(function() {
        var $variantGallery = $(this);

        var $slider = $variantGallery.find(selectors.productGallerySlideshow)
        if ($slider) {
          var slick = $slider.slick('getSlick')
          if (slick.$slides) $slider.slick("setPosition");
        }

        var $thumbnails = $variantGallery.find(selectors.productGalleryThumbnail)
        var slidesLength = $thumbnails.find(
          selectors.productGalleryThumbnailSlide
        ).length;
        if ($thumbnails && slidesLength > self.settings.minThumbnails) {
          var slick = $thumbnails.slick('getSlick')
          if (slick.$slides) $thumbnails.slick("setPosition");
        }
      });
    },

    /**
     * Method to de-initialize the slideshows, (allows scroll with page to take over.)
     */
    stopGalleries: function() {
      //method that is basically a complete inverse of init galleries.  Destroys hover zoom, de-initalizes slick everywhere, etc.  Used if the browser gets resized
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);
      $galleries.each(function() {
        var $slideshow = $(this).find(selectors.productGallerySlideshow);
        var $thumbnail = $(this).find(selectors.productGalleryThumbnail);

        if ($slideshow.length > 0) {
          $slideshow.off("init beforeChange afterChange destroy");
          $slideshow.slick("unslick");
        }

        if ($thumbnail.length > 0) {
          $thumbnail.off(self.events.CLICK);
          $thumbnail.slick("unslick");
        }
      });
    },

    /**
     * Lifecycle methods for hoverzoom
     *
     */
    initHoverZoom: function($zoomTarget) {
      var self = this;

      var opts = {
        url: $zoomTarget.find(selectors.productGallerySlideLink).attr("href"),
        on: "click",
        touch: false,
        escToClose: true,
        magnify: 0.8,
        duration: 300,
        callback: function() {
          $zoomTarget.addClass(classes.zoomReady);
        },
        onZoomIn: function() {
          $zoomTarget.addClass(classes.zoomedIn);
          if (self.contentIsScrolling) {
            $zoomTarget.siblings().each(function(i, el) {
              if ($(el).hasClass(classes.zoomedIn)) {
                self.unZoom($(el));
              }
            });
          }
        },
        onZoomOut: function() {
          $zoomTarget.removeClass(classes.zoomedIn);
        }
      };

      $zoomTarget.zoom(opts);

      $zoomTarget
        .find(selectors.productZoomButton)
        .on(self.events.CLICK, function(e) {
          $zoomTarget.trigger(self.events.CLICK);
          return false;
        });
    },

    destroyHoverZoom: function($zoomTarget) {
      var self = this;
      $zoomTarget.trigger("zoom.destroy");
      $zoomTarget.find(selectors.productZoomButton).off(self.events.CLICK);
    },

    //Method to simply hide a zoom img for a given target.
    unZoom: function($zoomTarget) {
      $zoomTarget.trigger("click");
    },

    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     **/
    resizeGalleries: function() {
      $(".slick-slider", this.$container).resize();
    },

    onVariantChange: function(evt) {
      var variant = evt.variant;

      if (this.hasHiddenVariantMenu) {
        this.revealAddToCartBtn(); //On variant selection, hide the shade-selector button and show the real add-to-cart button
      }
      this.updateProductPrices(variant);
      this.updateProductSaleBadge(variant);
      this.updateAddToCartState(variant);
      this.updateQuantityControls(variant);
      this.updateLowStockIndicator(variant);
      this.updateVariantOptionValues(variant);
      this.updateFullDetailsLink(variant);
      this.updateGalleries(variant);

      $(selectors.singleOptionSelector, this.$container).trigger(
        "chosen:updated"
      );

      if (this.backInStockActive) {
        this.updateBackInStock(variant);
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {
      var $addToCartBtn = $(selectors.addToCart, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $priceWrapper = $(selectors.priceWrapper, this.$container);
      var $backInStockTrigger = $(
        selectors.backInStockTrigger,
        this.$container
      );

      if (variant) {
        $priceWrapper.removeClass(classes.hiddenDetail);
      } else {
        $addToCartBtn.prop("disabled", true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hiddenDetail);
        return;
      }

      //Hooking into this to determine Back In Stock functionality.
      if (variant.available) {
        $addToCartBtn.prop("disabled", false);
        $addToCartBtnText.html(theme.strings.addToCart);
      } else {
        $addToCartBtn.prop("disabled", true);
        $addToCartBtnText.html(theme.strings.soldOut);
      }
    },

    /**
     * Updates Whether the addToCart CTA or the Back in Stock trigger is shown, based on variant availability
     *
     * @param {Object} variant - Shopify variant object
     */
    updateBackInStock: function(variant) {
      var $addToCartBtn = $(selectors.addToCart, this.$container);
      var $backInStockTrigger = $(
        selectors.backInStockTrigger,
        this.$container
      );

      if (variant.available) {
        $backInStockTrigger.addClass(classes.hiddenAddToCart); //hide BIS trigger
        $addToCartBtn.removeClass(classes.hiddenAddToCart); //show CTA
      } else {
        $backInStockTrigger.removeClass(classes.hiddenAddToCart); //show BIS trigger
        $backInStockTrigger.attr("data-variant-id", variant.id); //update the data attribute on the BIS trigger
        $addToCartBtn.addClass(classes.hiddenAddToCart); //hide CTA
      }
    },

    /**
     * Updates the disabled property of the quantity controls based on the availability of the selected variant.
     * Called once on load in case user has loaded page with a variant query parameter
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityControls: function(variant) {
      var $qtyInput = $(selectors.quantityInput, this.$container);
      var max = this.QUANTITY_INPUT_LIMIT;

      if (variant && variant.available) {
        $qtyInput.prop("disabled", false);

        if (variant.inventory_management && variant.inventory_quantity < max) {
          max = variant.inventory_quantity;
        }
      } else {
        $qtyInput.prop("disabled", true);
      }

      $qtyInput.attr("max", max);
    },

    /**
     * Updates text + visibility of the low stock indicator
     *
     * @param {Object} variant - Shopify variant object
     */
    updateLowStockIndicator: function(variant) {
      var $indicator = $(selectors.lowStockIndicator, this.$container);

      if (!$indicator) return;
      // Only show the indicator if the variant is in stock and has a low stock quantity
      if (
        variant.available &&
        variant.inventory_management &&
        variant.inventory_quantity < this.LOW_STOCK_INDICATOR_QTY
      ) {
        $indicator.text("Only " + variant.inventory_quantity + " left!");
        $indicator.show();
      } else {
        $indicator.hide();
      }
    },
    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      var $productPriceWrap = $(selectors.productPriceWrap, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        $(selectors.comparePriceText, this.$container)
      );

      var $percentageOff = $(selectors.percentageOff, this.$container);
      var percentageOffString =
        window.theme.strings.percentageOff || "[value]% OFF"; //add in a default.  Not sure if this is a good idea.

      if (variant) {
        $productPrice.html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(
            slate.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          );
          $compareEls.removeClass(classes.hiddenDetail);
          $percentageOff.removeClass(classes.hiddenDetail);

          //Get percentage off, and replace the [value] placeholder in the translation string with the number
          var percentageOfOrig = variant.price / variant.compare_at_price;
          var percentageOffValue = Math.round((1 - percentageOfOrig) * 100);
          $percentageOff.html(
            percentageOffString.replace("[value]", percentageOffValue)
          );
          $productPriceWrap.addClass(classes.productOnSale);
        } else {
          $comparePrice.html("");
          $percentageOff.html("");
          $compareEls.addClass(classes.hiddenDetail);
          $percentageOff.addClass(classes.hiddenDetail);
          $productPriceWrap.removeClass(classes.productOnSale);
        }
      }
    },
    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductSaleBadge: function(variant) {
      var $productSaleBadge = $(selectors.saleBadge, this.$container);
      if(!$productSaleBadge.length) return;

      var percentageOffString = "<span>[value]%<span><br><span>OFF</span>";

      if (variant && variant.compare_at_price > variant.price) {
        $productSaleBadge.removeClass(classes.hiddenDetail);

        var percentageOfOrig = variant.price / variant.compare_at_price;
        var percentageOffValue = Math.round((1 - percentageOfOrig) * 100);
        $productSaleBadge.html(
          percentageOffString.replace("[value]", percentageOffValue)
        )
      }
      else {
        $productSaleBadge.addClass(classes.hiddenDetail);
      }
    },
    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if (variant) {
        // Loop through all the options and update the option value
        for (var i = 3; i >= 1; i--) {
          var variantOptionValue = variant["option" + i];
          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          var $variantOptionValueList = $(
            selectors.variantOptionValueList,
            this.$container
          ).filter('[data-option-position="' + i + '"]');
          var $variantOptionValueUI = $(
            '[data-variant-option-value="' + variantOptionValue + '"]',
            $variantOptionValueList
          );

          $variantOptionValueUI.addClass(classes.variantOptionValueActive)
            .find('input:radio').prop('checked', true);
          $variantOptionValueUI
            .siblings()
            .removeClass(classes.variantOptionValueActive)
            .find('input:radio').prop('checked', false);

          // Update the text inside the label to reflect the selected value
          $(selectors.singleOptionSelectedValue, this.$container)
            .filter('[data-position="' + i + '"]')
            .text(variantOptionValue);
          //$(selectors.productSubtitle).text(variantOptionValue);
        }
      }
    },

    /**
     * Used on quick view, updates the "view full details" link to point to the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateFullDetailsLink: function(variant) {
      var $fullDetailsLink = $(selectors.fullDetailsLink, this.$container);
      var updatedUrl;

      if (variant && $fullDetailsLink.length) {
        updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter(
          "variant",
          variant.id,
          $fullDetailsLink.attr("href")
        );
        $fullDetailsLink.attr("href", updatedUrl);
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {
      var $galleries = $(selectors.productGallery, this.$container);
      var self = this;

      function getVariantGalleryForOption(option) {
        return $galleries.filter(function() {
          return $(this).data("variant-gallery") == option;
        });
      }

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            if (!variant["option" + i]) {
              continue; //skip over ones where the value is null
            }

            var $variantGallery = getVariantGalleryForOption(
              variant["option" + i]
            );

            if (
              $variantGallery.length &&
              $variantGallery.hasClass(classes.hiddenGallery)
            ) {
              $galleries.not($variantGallery).addClass(classes.hiddenGallery);
              $variantGallery.removeClass(classes.hiddenGallery);

              //We also need to restart scrollwithPage for the (now visible) variant gallery's thumbnails
              $variantGalleryThumbnails = $variantGallery
                .find(selectors.scrollWithPageEl)
                .eq(0); //get elements with scrollWithPage inside the gallery.
              $.each(this.scrollingElements, function(i, el) {
                if (
                  el.$scrollingElement.is(":visible") &&
                  window.innerWidth >= self.breakpointMin
                ) {
                  //If the scrolling Element is visible now...
                  el.restart(); //...call restart method on that SWP instance
                }
              });

              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              var $sliderGallery = $variantGallery.find(selectors.productGallerySlideshow)
              if ($sliderGallery) {
                $sliderGallery.slick("getSlick").refresh();
              }

              var $thumbnailsGallery = $variantGallery.find(selectors.productGalleryThumbnail)
              if ($thumbnailsGallery && $thumbnailsGallery.find(selectors.productGalleryThumbnailSlide).length > self.settings.minThumbnails) {
                $thumbnailsGallery.slick("getSlick").refresh();
              }

              //Finally, update the list of visible targets that scrollspy is tracking (if it's been initialized).
              if (this.scrollspy) {
                this.scrollspy.refreshTargets();
              }
            }
          }
        } else {
          // $galleries is just a single gallery
          // Slide to featured image for selected variant but only if we're not already on it.
          // Have to check this way because slick clones slides so even if we're currently on it, there can be a cloned slide that also has the correct data-image attribute
          if (
            (this.isQuickView || window.innerWidth < this.breakpointMin) &&
            variant.featured_image &&
            $galleries.find(".slick-current").data("image") !=
              variant.featured_image.id
          ) {
            var $imageSlide = $galleries
              .find('[data-image="' + variant.featured_image.id + '"]')
              .first();

            if ($imageSlide.length) {
              $galleries
                .find(selectors.productGallerySlideshow)
                .slick("slickGoTo", $imageSlide.data("slick-index"));
            }
          }
        }
      } else {
        // No variant - Don't do anything?
      }
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {
      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value = $option.data("variant-option-value");
      var position = $option
        .parents(selectors.variantOptionValueList)
        .data("option-position");
      var $selector = $(selectors.singleOptionSelector, this.$container).filter(
        '[data-index="option' + position + '"]'
      );

      $selector.val(value);
      $selector.trigger("change");

      $option.addClass(classes.variantOptionValueActive).find('input:radio').prop('checked', true);
      $option.siblings().removeClass(classes.variantOptionValueActive).find('input:radio').prop('checked', false);
    },

    /**
     * Show
     *
     */
    showHiddenVariantMenu: function(e) {
      //Show overlay, add visible class
      this.$hiddenVariantMenu.show(10, function() {
        $(this).addClass(classes.hiddenVariantMenuIsVisible);
      });
      this.$hiddenVariantMenu.attr("aria-hidden", false);
      this.hiddenVariantMenuIsOpen = true;
      this.addBackdrop();
    },

    hideHiddenVariantMenu: function(e) {
      var self = this;
      //hide overlay, remove visible class
      this.$hiddenVariantMenu.one(this.events.TRANSITIONEND, function() {
        self.$hiddenVariantMenu.hide();
      });

      this.$hiddenVariantMenu.removeClass(classes.hiddenVariantMenuIsVisible);
      this.$hiddenVariantMenu.attr("aria-hidden", true);
      this.hiddenVariantMenuIsOpen = false;

      if (this.$backdrop) {
        this.$backdrop.remove();
        this.$backdrop = null;
      }
    },

    revealAddToCartBtn: function() {
      this.$showVariantMenuBtn.hide();
      $(selectors.addToCart, this.$container).removeClass(
        classes.hiddenAddToCart
      );
    },

    addBackdrop: function(callback) {
      if (!this.$backdrop) {
        var self = this;
        if (this.hiddenVariantMenuIsOpen) {
          this.$backdrop = $("<div></div>"); //create an empty div

          this.$backdrop.addClass(classes.backdrop).appendTo($body);

          this.$backdrop.one("click", this.hideHiddenVariantMenu.bind(this));

          setTimeout(function() {
            self.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
      }
    },

    /**
     * Initialize/restart scroll with page
     */
    initScrollWithPage: function() {
      var self = this;

      if (
        this.$scrollWithPageEls.length > 0 &&
        this.$scrollWithPageContainer.length > 0
      ) {
        this.$scrollWithPageEls.each(function(i, el) {
          var scrollingElIndex = self.scrollingElements
            ? self.scrollingElements.indexOf(el)
            : -1; // check if the element's in the array already
          if (scrollingElIndex >= 0) {
            //check to see if we've already initialized SWP by its presence in the scrolling Els array.  Restart if present.
            var scrollingEl = self.scrollingElements(scrollingElIndex);
            scrollingEl.restart();
          } else {
            //Element wasn't found in scrollingElements array, so create a new instance of SWP, start it, and push it to the array.
            var scrollingElement = new slate.models.ScrollWithPage(
              $(el),
              self.$scrollWithPageContainer,
              self.$scrollWithPageOffset
            );
            scrollingElement.init();
            self.scrollingElements.push(scrollingElement);
          }
        });

        self.contentIsScrolling = true;

        //Initialize zoom handlers on all photos
        $(selectors.productGalleryImage, self.$container).each(function(i, el) {
          self.initHoverZoom($(el));
        });
      }
    },

    /**
     * Stop scroll with page
     */
    stopScrollWithPage: function() {
      var self = this;
      //First, break zoomhandler on everything
      $(selectors.productGalleryImage, self.$container).each(function(i, el) {
        //find all direct li descendants of the gallery slideshow, destroy hoverzoom
        self.destroyHoverZoom($(el));
      });

      this.scrollingElements.forEach(function(obj) {
        obj.stop();
      });
    },
    /**
     * Initialize/restart scrollspy stuff
     */
    initScrollspy: function() {
      if (!this.scrollspy) {
        var scrollspyLinks = $(selectors.scrollspyLinks);
        var scrollspyTargets = $(selectors.scrollspyTargets);
        var offsetElement = this.$scrollWithPageOffset; //we can just grab this, since ScrollWithPage is checking if it exists.
        this.scrollspy = new slate.models.Scrollspy(
          scrollspyLinks,
          scrollspyTargets,
          offsetElement
        ); //init scrollspy
      } else {
        this.scrollspy.restart(); //restart scrollspy
      }
    },

    /**
     * Stop scrollspy
     */
    stopScrollspy: function() {
      this.scrollspy.stop(); //stop scrollspy
    },

    refreshScrollspy: function() {
      this.scrollspy.refresh();
    },

    onResize: function () {
      if (this.$icons.length) {
        this.$icons[0].style.top = null;
        this.$icons[0].style.width = null;
        if ($window.innerWidth() >= 1200) {
          var $slideshows = this.$container.find(selectors.productGallery + ':not(.hide) ' + selectors.productGallerySlideshow);
          var $slider = $slideshows.first();
          console.log($slider)
          if ($slider) {
            this.$icons[0].style.top = $slider.height() / 2 + 'px';
            this.$icons[0].style.width = $slider.height() + 'px';
          }
        }
      }
    }
  });

  return ProductDetailForm;
})(jQuery, Modernizr, slate);

/**
 * QuickView
 * -----------------------------------------------------------------------------
 * Initializes the quickview feature by listening for click events and signaling the quickview manager to take action
 *
 */

 slate.quickView = (function() {

  var $window = $(window);
  var $body = $(document.body);

  var selectors = {
    quickViewTrigger: '[data-quick-view-trigger]',
    quickViewTriggerText: '[data-quick-view-trigger-text]',
    quickViewParent: '[data-product-grid], [data-quick-view-parent]'
  };

  var dataAttr = {
    quickViewUrl : 'quick-view-url',
    quickViewScroll: 'quick-view-scroll', //Determines if page scrolls to quickview when opened, options are 'scroll' and 'noscroll', with default being 'scroll'
    variantTitle: 'current-variant-title'
  };

  /**
   * QuickViewManager
   *
   * - Creates and keeps track of quickviews on the page.
   * - Makes sure only one is visible at a time and that we only load a quick view *once* per product card
   *
   * @constructor
   */
  function QuickViewManager() {
    this.name = 'quickViewManager';
    this.quickViews = [];

    var isLoadingQuickView = false;

    this.register = function(qv) {
      if( !(qv instanceof slate.models.QuickView) ) {
        console.warn('['+this.name+'] - instance of slate.models.QuickView required when calling register');
        return;
      }

      this.quickViews.push(qv);

      return this;
    };

    this.getQuickViewByDestination = function(url) {
      var foundQV;

      $.each(this.quickViews, function(i, qv) {
        if( qv.settings.url === url ) {
          foundQV = qv;
          return false;
        }
      });

      return foundQV;
    };

    this.getOpenQuickViews = function() {
      var opens = [];

      $.each(this.quickViews, function(i, qv) {
        qv.isOpen() && opens.push(qv);
      });

      return opens;
    },

    this.closeOpenQuickViews = function(cb) {
      var opens = this.getOpenQuickViews();
      if(opens.length == 0 ) {
        cb();
      }
      else {
        $.each(opens, function(i, qv) {
          qv.close();
          cb();
        });
      }
    };

    this.onQuickViewTriggerClick = function($trigger) {
      if($trigger == undefined) {
        return;
      }

      var quickViewManager = this;
      var URL              = $trigger.data( dataAttr.quickViewUrl )
      var $qvParent        = $trigger.parents(selectors.quickViewParent);
      var quickView        = this.getQuickViewByDestination(URL);

      var $triggerText     = $trigger.find( selectors.quickViewTriggerText ); //get direct descendant
      //var triggerText      = $triggerText.text(); // Cache this text so we can set it as loading
      var triggerText      = $trigger.data( dataAttr.variantTitle );
      console.log('triggerText 1',triggerText);
      var qvScroll         = $trigger.data( dataAttr.quickViewScroll ) || "scroll";

      //if(quickView == undefined) {
        
        //if(isLoadingQuickView) return; // Return early, we're already fetching a quick view, sorry!

        //isLoadingQuickView = true;

        $triggerText.text('Loading');
        $qvParent.find('.variant-form').attr('action','');
        // generate a new QV
        quickView = new slate.models.QuickView({
          $quickviewParent: $qvParent,
          url: URL,
          qvScroll: qvScroll,
          transitionDuration: slate.animations.getTransitionTimingDuration('slow'),
          transitionTimingFunction: slate.animations.getTransitionTimingFunction('inOutUI')
        });

        $qvParent.one('loaded.quickView', function() {
          isLoadingQuickView = false;
          console.log('triggerText 2',triggerText);
          $triggerText.text(triggerText); // Return the button to it's original state
          quickViewManager.closeOpenQuickViews( quickView.open.bind(quickView) ); // Make sure all the QVs are closed before opening this new one
          // so instead of Select [Shade, Style, Size...] button text we'll show the name of the selected variaty later on
          if (!($qvParent.attr('data-ajax-item') == undefined)) {
            console.log('GWP Quick View in Ajax Cart Loaded.');
              /*
              var inputString = '<input type="hidden" name="properties[_gwp_variants_seen_by_user]" value="true">';
              $qvParent.find('form')[0].prepend(inputString);
              */
            //TODO Add property _gwp_variants_seen_by_user:true to line item in the cart
            var lineItemIndex = Number($qvParent.attr('data-line-item-index'));
            var properties = {'_gwp_variants_seen_by_user':'true'}
            ShopifyAPI.updateItemPropsByIndex(lineItemIndex,properties).then(function(cart){console.log(cart)});
          }
        });

        quickViewManager.register(quickView);

      //}
      //else {
      //  if(!quickView.isOpen()) {
      //    quickViewManager.closeOpenQuickViews( quickView.open.bind(quickView) );
      //  }
      //}
    };

    return this;
  }

  var quickViewManager = new QuickViewManager();

  $(function() {

    $body.on('click', selectors.quickViewTrigger, function(e) {
      e.preventDefault();
      quickViewManager.onQuickViewTriggerClick($(this));
      slate.quantityAdjuster.refresh();
    });

  });

}());

/**
 * Yotpo API Wrapper
 * -----------------------------------------------------------------------------
 * Library for interacting with the Yotpo API
 * Wraps all API calls with a promise interface
 * see: https://apidocs.yotpo.com/reference
 *
 * @namespace yotpoAPI
 *
 * - Requires:
 *   - window.yotpoConfig - object with valid `apiKey` property
 */

slate.yotpoAPI = (function($) {

  var API_ORIGIN = 'https://api.yotpo.com';

 /**
  * Constructor
  */
  function YotpoAPI() {
    this.name = 'yotpoAPI';
    this.namespace = '.' + this.name;

    if( !window.yotpoConfig || !window.yotpoConfig.hasOwnProperty('appKey') ) {
      console.warn('['+this.name+'] - App key required to initialize.  If Yotpo isn\'t required, please remove this file.');
      return;
    }

    this.appKey = yotpoConfig.appKey;

    return this;
  }

  YotpoAPI.prototype = $.extend({}, YotpoAPI.prototype, {

   /**
    * Makes a request to the Yotpo API
    * Returns the data as shown in the API docs
    *
    * @param {string} endpoint - combines with the API_ORIGIN to create a full URL
    * @returns {promise}
    * @resolve {object}
    * @rejects {object}
    */
    _makeRequest: function(endpoint) {

      var promise = $.Deferred();
      var url = API_ORIGIN + endpoint;

      $.get( url )
        .done(function(data) {
          promise.resolve(data);
        })
        .fail(function(data) {
          promise.reject(data.responseJSON);
        });

      return promise;
    },

   /**
    * Retrieves all images generated from product reviews and/or Instagram.
    * See: https://apidocs.yotpo.com/reference#get-all-images
    *
    * @param {string} source - optional - must be "instagram" or "yotpo_reviews", defaults to "instagram";
    * @param {object} params - plain object of key values mapping to optional query parameters defined in the docs.
    * @returns {promise} - see this._makeRequest
    */
    getAllImages: function(source, params) {
    
      var baseParams = { source: 'instagram' };

      if(source == 'yotpo_reviews') {
        baseParams.source = 'yotpo_reviews';
      }

      params = params || {};

      var endpoint = '/v1/widget/' + this.appKey + '/images/all.json?';

      var url = endpoint + $.param( $.extend(baseParams, params) );

      return this._makeRequest(url);

    },

   /**
    * Retrieves images for specific products by product_id
    * See: https://apidocs.yotpo.com/reference#get-all-images
    *
    * @param {integer} id
    * @param {object} params - plain object of key values mapping to optional query parameters defined in the docs.    
    * @returns {promise} - see this._makeRequest
    */
    getProductImages: function(id, params) {

      if(!id) {
        console.warn('['+this.name+'] - product id required.');
        return;
      }

      params = params || {};
      
      var endpoint = '/v1/widget/' + this.appKey + '/products/' + id + '/images.json?';
      
      var url = endpoint + $.param(params);

      return this._makeRequest(url);
    },

   /**
    * Retrieve an album by name
    * See: https://apidocs.yotpo.com/v1.0/reference?showHidden=dfd93#custom-albums
    *
    * @param {string} album name
    * @param {object} params - plain object of key values mapping to optional query parameters defined in the docs.    
    * @returns {promise} - see this._makeRequest
    */
    getCustomAlbum: function(albumName, params) {
      if(!albumName) {
        console.warn('['+this.name+'] - album name required.');
        return;
      }

      params = params || {};
      
      var endpoint = '/v1/widget/' + this.appKey + '/albums/by_name?album_name=' + encodeURI(albumName);
      
      endpoint += '&' + $.param(params);
      
      return this._makeRequest(endpoint);
    },

   /**
    * Retrieve Reviews for a Product
    * See: https://apidocs.yotpo.com/reference#retrieve-a-review-by-review-id
    *
    * @param {integer} id
    * @param {object} params - plain object of key values mapping to optional query parameters defined in the docs.    
    * @returns {promise} - see this._makeRequest
    */
    getReviewsForProduct: function(id, params) {

      if(!id) {
        console.warn('['+this.name+'] - product id required.');
        return;
      }

      params = params || {};

      var endpoint = '/v1/widget/' + this.appKey + '/products/' + id + '/reviews.json?';
      
      var url = endpoint + $.param(params);

      return this._makeRequest(url);
    },

   /**
    * Retrieve Bottom Line (Total Reviews and Average Score) for a Specific Product
    * See: https://apidocs.yotpo.com/reference#get-bottom-line-total-reviews-and-average-score-fo-1
    *
    * @param {integer} id
    * @returns {promise} - see this._makeRequest
    */
    getBottomLineForProduct: function(id) {

      if(!id) {
        console.warn('['+this.name+'] - product id required.');
        return;
      }

      var endpoint = '/products/' + this.appKey + '/' + id + '/bottomline';
      
      return this._makeRequest(endpoint);
    },

   /**
    * Retrieve Bottom Line (Total Reviews and Average Score) for All Site Reviews
    * See: https://apidocs.yotpo.com/reference#retrieve-bottom-line-for-all-site-reviews
    *
    * @returns {promise} - see this._makeRequest
    */
    getBottomLineForAllReviews: function() {
      
      var endpoint = '/products/' + this.appKey + '/yotpo_site_reviews/bottomline';

      return this._makeRequest(endpoint);
    }

  });

  return new YotpoAPI();

}(jQuery));
/**
 * Quantity Adjuster Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the quantity adjuster component
 *
 *  [data-quantity-adjuster]
 *    [data-increment]
 *    input[type="number"]
 *    [data-decrement]
 *
 */

slate.quantityAdjuster = (function() {

  var selectors = {
    adjuster: '[data-quantity-adjuster]',
    increment: '[data-increment]',
    decrement: '[data-decrement]',
    input: 'input[type="number"]'
  };

  var classes = {

  };

  /**
   * Quantity Adjuster Constructor
   *
   * @param {HTMLElement | jQuery} el - element, either matching selectors.adjuster or a child element
   */
  function QuantityAdjuster(el) {

    this.name = 'quantityAdjuster',
    this.namespace = '.'+this.name;

    this.$el = $(el).is(selectors.adjuster) ? $(el) : $(el).parents(selectors.adjuster);

    if(!this.$el) {
      console.warn('['+this.name+'] - Element required to initialize');
      return;
    }

    this.$increment = $(selectors.increment, this.$el);
    this.$decrement = $(selectors.decrement, this.$el);
    this.$input     = $(selectors.input, this.$el);

    this.$increment.on('click', this.onIncrementClick.bind(this));
    this.$decrement.on('click', this.onDecrementClick.bind(this));
    this.$input.on('change', this.onInputChange.bind(this));

    this._addMutationObserver(this.$input.get(0));

    this._updateDisabledState();
  }

  QuantityAdjuster.prototype = {

    _getMin: function() {
      return parseInt(this.$input.attr('min')) || 0;
    },

    _getMax: function() {
      return parseInt(this.$input.attr('max')) || 999;
    },

    _addMutationObserver: function(el) {
      if(!el) return;

      var observer;
      var config = { attributes: true };
      var self = this;

      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.type == "attributes") {
            if(mutation.attributeName == "max" || mutation.attributeName == "min") {
              self.onMinMaxAttributeChange();
            }
            else if(mutation.attributeName == "disabled") {
              self.onDisabledAttributeChange();
            }
          }
        });
      });

      observer.observe(el, config);
    },

    _updateDisabledState: function() {
      var val = parseInt(this.$input.val());

      if(this.$input.is(':disabled')) {
        this.$increment.prop('disabled', true);
        this.$decrement.prop('disabled', true);
      }
      else {
        if (val == this._getMax() && val == this._getMin()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', true);
        }
        else if(val >= this._getMax()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', false);
        }
        else if(val <= this._getMin()) {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', true);
        }
        else {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', false);
        }
      }
    },

    _changeValue: function(amount) {

      if(this.$input.is(':disabled') || typeof amount == "undefined") return;

      amount = parseInt(amount);

      var val = parseInt(this.$input.val());
      var newVal = val + amount;

      // Don't change if the value is the same or invalid
      if(newVal == val || newVal > this._getMax() || newVal < this._getMin()) return;

      this.$input.val(newVal);
      this.$input.trigger('change');
    },

    _clampInputVal: function() {
      var currVal = parseInt(this.$input.val());
      var max = this._getMax();
      var min = this._getMin();

      if(currVal > max) {
        this.$input.val(max);
      }
      else if(currVal < min) {
        this.$input.val(min);
      }
    },

    onDisabledAttributeChange: function() {
      this._updateDisabledState();
    },

    onMinMaxAttributeChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onInputChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onIncrementClick: function(e) {
      e.preventDefault();
      this._changeValue(1);
    },

    onDecrementClick: function(e) {
      e.preventDefault();
      this._changeValue(-1);
    }
  };

  // End prototype

  // QA DATA-API
  // ===========

  var dataKey = 'quantity-adjuster';

  function ensureQuantityAdjuster(el) {
    var $el =  $(el);

    if(!$el.is(selectors.adjuster)) {
      $el = $el.parents(selectors.adjuster);
    }

    var data = $el.data(dataKey);

    if(!data) {
      $el.data(dataKey, (data = new QuantityAdjuster($el)));
    }

    return data;
  }

  // Check all adjuster elements on the page and initialize them if necessary
  function refresh() {
    $(selectors.adjuster).each(function(i, el) {
      ensureQuantityAdjuster(el);
    });
  }

  $(function() {

    refresh();

    $(document)
      .on('shopify:section:load', refresh)
      .on('shopify:section:unload', refresh)
      .on('shopify:section:select', refresh)
      .on('shopify:section:deselect', refresh)
      .on('shopify:section:reorder', refresh)
      .on('shopify:block:select', refresh)
      .on('shopify:block:deselect', refresh);
  });

  return {
    refresh: refresh
  };

}());
/**
 * Forms Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with forms on the site
 */

slate.forms = (function($) {

  var selectors = {
    formControl: '.form-control',
    formGroup: '.form-group',
    chosen: '.chosen-container'
  };

  var classes = {
   formGroupIsFocused: 'is-focused',
   formGroupHasError: 'has-error'
  };

  var $body = $(document.body);

  var initialized = false;

  function onFormControlFocus(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.addClass(classes.formGroupIsFocused);
  }

  function onFormControlBlur(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupIsFocused);
  }

  function removeFormControlErrorState(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupHasError);
  }

  function onChosenShowingDropdown(e) {
    onFormControlFocus(e);
  }

  function onChosenHidingDropdown(e) {
    onFormControlBlur(e);
  }



  function initialize() {
    if(initialized) return;

    $body.on('focus', selectors.formControl, onFormControlFocus);
    $body.on('blur',  selectors.formControl, onFormControlBlur);
    $body.on('change keydown', selectors.formControl, removeFormControlErrorState);
    $body.on('chosen:showing_dropdown', selectors.formControl, onChosenShowingDropdown);
    $body.on('chosen:hiding_dropdown', selectors.formControl, onChosenHidingDropdown);

    initialized = true;

    return initialized;
  }

  return {
    initialize: initialize
  };

}(jQuery));
/**
 * Parallax Scroll Animation Script
 * -----------------------------------------------------------------------------
 * Handles any events associated with scrolling items on the site
 */

slate.parallaxScroll = (function($) {

  var selectors = {
    parallaxScroll: '[data-parallax-scroll]'
  };

  var classes = {
  };

  var $body = $(document.body);

  var initialized = false;

  //Check for the global scroll animation setting.
  if ( window.parallaxScroll && !window.parallaxScroll.enabled ) {
    return;
  }

  var $parallaxEls = $( selectors.parallaxScroll );

  function initialize(){
    if ( !$parallaxEls.length ) {
      return; //no parallax elements found
    }

    //Define paroller settings here.
    $parallaxEls.paroller({
      factor: 0.2,  // multiplier for scrolling speed and offset
      /*factorXs: 0.1,  // multiplier for scrolling speed and offset
      factorSm: 0.125,          // multiplier for scrolling speed and offset if window width is <=768px
      factorMd: 0.15,          // multiplier for scrolling speed and offset if window width is <=1024px
      factorLg: 0.0,          // multiplier for scrolling speed and offset if window width is <=1200px*/
      type: 'foreground',
      direction: 'vertical'
    });

  }

  return {
    initialize: initialize
  };

}(jQuery));

/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

 slate.models = slate.models || {};

 slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open',
    forcedOpen: 'is-forced-open'
  };  

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-trigger' and 'data-block'
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el      = $( this.$trigger.data('dropdown-trigger') );
    this.blockId  = this.$trigger.data('block').toString();
  }

  Dropdown.prototype = {

    isOpen: function() {
      return this.$el.hasClass( classes.open );
    },

    open: function() {
      this.$el.addClass( classes.open );
      document.body.dispatchEvent(new CustomEvent('dropdown:open', { detail: { dropdown: this, trigger: this.$trigger } }));
    },

    close: function() {
      this.$el.removeClass( classes.open );
      document.body.dispatchEvent(new CustomEvent('dropdown:close', { detail: { dropdown: this, trigger: this.$trigger } }));
    },

    /**
     * Dropdown manager doesn't use the forced open class
     * So we can use it in conjunction with the theme editor to ensure dropdowns are open while editing
     */
    forceOpen: function() {
      this.$el.addClass( classes.forcedOpen );
    },

    forceClose: function() {
      this.$el.removeClass( classes.forcedOpen );
    }
        
  };

  return Dropdown;

 }(jQuery));
/**
 * Model - DropdownManager
 * -----------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.models.Dropdown
 *  - slate.utils
 *
 * @namespace models.DropdownManager
 */

 slate.models = slate.models || {};

 slate.models.DropdownManager = (function($) {

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 200;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    this.events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

  }

  DropdownManager.prototype = {
    register: function($trigger) {
      var dd = new slate.models.Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);

      return dd;
    },    
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      if(this.activeDropdown !== dd) {
        this.closeAllDropdowns();
        dd.open();
        this.activeDropdown = dd;
      }
    },
    closeDropdown: function(dd) {
      dd.close();

      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  return DropdownManager;

 }(jQuery));
/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-drawer-close]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'    
  };

 /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  * @param {Object} options
  */
  function Drawer(el, options) {

    this.name = 'drawer';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.$backdrop              = null;
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
      return;
    }     

    var defaults = {
      closeSelector: selectors.close,
      backdrop: true
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {

    addBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.stateIsOpen) {
        this.$backdrop = $(document.createElement('div'));

        this.$backdrop.addClass(classes.backdrop)
                      .appendTo($body);

        this.$backdrop.one(this.transitionEndEvent, cb);
        this.$backdrop.one('click', this.hide.bind(this));

        // debug this...
        setTimeout(function() {
          $body.addClass(classes.bodyDrawerOpen);          
          _this.$backdrop.addClass(classes.backdropVisible);
        }, 10);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.$backdrop) {
        this.$backdrop.one(this.transitionEndEvent, function(){
          _this.$backdrop && _this.$backdrop.remove();
          _this.$backdrop = null;
          cb();
        });

        setTimeout(function() {
          _this.$backdrop.removeClass(classes.backdropVisible);
          $body.removeClass(classes.bodyDrawerOpen);
        }, 10);
      }
      else {
        cb();
      }
    },
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.$el.removeClass(classes.visible);

      if(this.settings.backdrop) {
        this.removeBackdrop();
      }        

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.settings.backdrop) {
        this.addBackdrop();
      }

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }        
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });  

  return Drawer;
  
}(jQuery, Modernizr));

/**
 * Slideshow
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.Slideshow
*/

slate.models = slate.models || {};

slate.models.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow element
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$slideshow = $el;
    this.$wrapper   = $el.closest(selectors.slideShowWrapper);

    if(!this.$slideshow.length){
      console.warn('['+this.name+'] - Slideshow element required to initialize');
      return;
    }

    var fade = this.$slideshow.attr('data-fade') && this.$slideshow.attr('data-fade').length ? this.$slideshow.data('fade') : true; // Allows us to pass data-fade="false".  $.fn.attr coerces to string, $.fn.data does *not*

    var defaults = {
      accessibility: false, // prevents page from jumping on focus
      arrows: this.$slideshow.data('arrows') || !Modernizr.touchevents,
      dots: this.$slideshow.data('dots'),
      fade: fade,
      draggable: true,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<button class="slick-arrow slick-arrow--prev btn-link"><span class="arrow arrow--left" aria-hidden="true"><span class="arrow__icon"></span></span><span class="sr-only">Previous slide</span></button>',
      nextArrow: '<button class="slick-arrow slick-arrow--next btn-link"><span class="arrow arrow--right" aria-hidden="true"><span class="arrow__icon"></span></span><span class="sr-only">Next slide</span></button>',
      //BH requests
      speed: 100,
      infinite: true,
      cssEase: 'linear',
      swipeToSlide: true,
      touchThreshold: 32,
      waitForAnimate: false,
      // Options below here are not used in slick
      equalHeightSlides: this.$slideshow.data('equal-heights') || false,
      adaptiveHeight: this.$slideshow.data('adaptive-height') || false
    };

    this.settings = $.extend({}, defaults, options);

    if(this.$slideshow.children().length <= 1) {
      this.settings.dots = false;
    }

    this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    if(this.settings.equalHeightSlides) {
      this.$slideshow.addClass('has-equal-height-slides');
    }
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if(this.settings.autoplay) {
        this.play();
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the slide element must have the attribute - data-block-id="{{ block.id }}"
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');

      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    }

  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Slideup
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Slideup
*/

slate.models = slate.models || {};

slate.models.Slideup = (function($, Modernizr) {

  var $document = $(document);

  var selectors = {
    close: '[data-slideup-close]',
  };

  var classes = {
    slideup: 'slideup',
    visible: 'is-visible'
  };

 /**
  * Slideup constructor
  *
  * @param {HTMLElement | $} el - The slideup element
  * @param {Object} options
  */
  function Slideup(el, options) {

    this.name = 'slideup';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;


    if (this.$el == undefined || !this.$el.hasClass(classes.slideup)) {
      console.warn('['+this.name+'] - Element with class `'+classes.slideup+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Slideup.prototype = $.extend({}, Slideup.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.$el.removeClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // SLIDEUP DATA-API
  // ===============

  $document.on('click.slideup', '[data-toggle="slideup"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('slideup');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('slideup', (data = new Slideup($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Slideup;
}(jQuery, Modernizr));

/**
 * Slideup Alert
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - snippets/slideup-template.liquid
 *
 * @namespace - models.SlideupAlert
*/

slate.models = slate.models || {};

slate.models.SlideupAlert = (function($) {

  var $body = $(document.body);

  var selectors = {
    template: 'script[data-slideup-template]'
  };  

 /**
  * Slideup Alert constructor
  *
  * @param {Object} options
  * @param {String} options.title - Title text of the slideup
  * @param {String} options.text - Body text of the slideup
  * @param {Integer} options.timeoutDuration - How long to display the alert before closing automatically (in ms)
  */
  function SlideupAlert(options) {

    this.name = 'slideupAlert';
    this.namespace = '.'+this.name;

    if(!$(selectors.template).length){
      console.warn('['+this.name+'] - Handlebars template required to initialize');
      return;
    }

    var template = Handlebars.compile($(selectors.template).html());
    var defaults = {
      title: null,
      text: null,
      timeoutDuration: 5000
    };
    
    this.settings = $.extend({}, defaults, options);
    this.interactionTimeout = false;

    this.$el = $(template(this.settings));

    this.$el.appendTo($body);

    this.$el.on('shown.slideup', this.onShown.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));
    this.$el.on('mouseenter', this.onMouseenter.bind(this));
    this.$el.on('mouseleave', this.onMouseleave.bind(this));    

    this.slideup = new slate.models.Slideup(this.$el);

    setTimeout(function() {
      this.slideup.show();
    }.bind(this), 10);

  }

  SlideupAlert.prototype = $.extend({}, SlideupAlert.prototype, {
    
    setInteractionTimeout: function() {
      this.interactionTimeout = setTimeout(function() {
        this.slideup.hide();
      }.bind(this), this.settings.timeoutDuration);
    },

    clearInteractionTimeout: function() {
      clearTimeout(this.interactionTimeout);
    },

    onMouseenter: function() {
      this.clearInteractionTimeout();
    },

    onMouseleave: function() {
      this.setInteractionTimeout();
    },

    onHidden: function() {
      this.clearInteractionTimeout();
      this.$el.remove();
    },

    onShown: function() {
      this.setInteractionTimeout();
    }

  });

  return SlideupAlert;
}(jQuery));

/**
 * Overlay
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Overlay
*/

slate.models = slate.models || {};

slate.models.Overlay = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-overlay-close]'
  };

  var classes = {
    overlay: 'overlay',
    visible: 'is-visible',
    bodyOverlayOpen: 'overlay-open'
  };

 /**
  * Overlay constructor
  *
  * @param {HTMLElement | $} el - The overlay element
  * @param {Object} options
  */
  function Overlay(el, options) {

    this.name = 'overlay';
    this.namespace = '.'+this.name;

    this.$el      = $(el);

    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.overlay)) {
      console.warn('['+this.name+'] - Element with class `'+classes.overlay+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace,
      FOCUS:  'focus'  + this.namespace,
      KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Overlay.prototype = $.extend({}, Overlay.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      $body.removeClass(classes.bodyOverlayOpen);

      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      this.enforceFocus();

      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
      this.$el.trigger('focus');
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.updateEscapeHandler();

      $document.off(this.events.FOCUS);

      this.$el.removeClass(classes.visible);      

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.updateEscapeHandler();

      $body.addClass(classes.bodyOverlayOpen);
      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {      
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    enforceFocus: function() {
      $document.off(this.events.FOCUS);
      $document.on(this.events.FOCUS, $.proxy(function(e) {
        if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$el.trigger('focus');
        }
      }, this));
    },

    updateEscapeHandler: function() {
      if(this.stateIsOpen) {
        this.$el.on(this.events.KEYDOWN_DISMISS, $.proxy(function(e) {
          e.which == 27 && this.hide();
        }, this));
      }
      else {
        this.$el.off(this.events.KEYDOWN_DISMISS);
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // OVERLAY DATA-API
  // ===============

  $document.on('click.overlay', '[data-toggle="overlay"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('overlay');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('overlay', (data = new Overlay($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Overlay;
}(jQuery, Modernizr));

/**
 * Model - QuickView
 * -----------------------------------------------------------------------------
 * QuickViews are versions of the product detail form that we pull down via AJAX and append to a product card.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.imagesLoaded
 *  - Modernizr (for Modernizr.csstransitions)
 *
 * @namespace models.quickView
 */

 slate.models = slate.models || {};

 slate.models.QuickView = (function($, Modernizr, undefined) {

  var selectors = {
    quickView: '[data-quick-view]',
    quickViewContentsBody: '[data-quick-view-contents-body]',
    quickViewClose: '[data-quick-view-close]',
    quickviewParentContents: '[data-product-card-contents], [data-quick-view-parent-contents]',
    productDetailForm: '[data-product-detail-form]',
    slickSlideshow: '.slick-slider'
  };

  var classes = {
    quickViewIsOpen: 'is-open',
    productCardHasOpenQuickView: 'has-open-quick-view',
  };

  /**
   * QuickView constructor
   *
   * @param { Object } settings
   * @param { HTMLElement | jQuery } settings.$productCard
   * @param { String } settings.url - URL pointing to the quick view of the product
   * @param { Function } settings.onProductDetailFormReady - Called after the product form is initialized.  `this` references the QuickView instance
   * @param { Number } settings.transitionDuration - ms
   * @param { String } settings.transitionTimingFunction - string matching a jQuery easing equation.  see slate.animations.
   */
  function QuickView(options) {

    this.name = 'quickView';
    this.namespace = '.'+this.name;

    var self = this;
    var defaults = {
      onProductDetailFormReady: $.noop,
      transitionDuration: 800,
      transitionTimingFunction: 'ease-in-out',
      style: 'normal'
    };

    this.settings = $.extend({}, defaults, options);

    if(typeof this.settings.$productCard == undefined) {
      console.warn('['+this.name+'] - $productCard element required to initialize');
      return;
    }

    if(typeof this.settings.url != "string" || this.settings.url.length == 0 || this.settings.url.indexOf('quick-view') == -1) {
      console.warn('['+this.name+'] - valid URL required to initialize');
      return;
    }

    // Elements we'll need for everything to work
    this.$qvParent                 = this.settings.$quickviewParent;
    this.$qvParentContents         = this.$qvParent.find(selectors.quickviewParentContents);
    this.qvScroll                  = this.settings.qvScroll;

    // These get bound after the QV is loaded.
    this.$productDetailForm        = null;
    this.$quickView                = null;
    this.$quickViewContentsBody    = null;
    this.$close                    = null;

    //State properties
    this.stateIsOpen               = false;
    this.supportsCssTransitions    = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.productDetailFormInstance = null;

    this.events = {
      OPEN:   'open'   + this.namespace,
      OPENED: 'opened' + this.namespace,
      CLOSE:  'close'  + this.namespace,
      CLOSED: 'closed' + this.namespace,
      LOADED: 'loaded' + this.namespace
    };

    // this.$qvParent.on('click', selectors.quickViewClose, this.onCloseClick.bind(this));

    // this.$qvParent.on('touch touchstart touchmove', selectors.quickview, this.onQuickViewClick.bind(this));

    // this.$qvParent.height( this.$qvParentContents.outerHeight(true) );
    this.inSlideshow = this.$qvParent.parents( selectors.slickSlideshow ).length > 0 ? true : false; //check if this quick view is in a slideshow by checking for a parent with the slick class

    // if ( this.inSlideshow ) {
    //   this.$parentSlideshow = this.$qvParent.parents( selectors.slickSlideshow ); //get slideshow element
    //   this.$parentSlideshow.on('destroy', this.resetFromSlidePosition.bind(this)); //when slick is destroyed, remove the quickview positioning.
    // }

    // Initial ajax request to get the quick view content
    $.get(this.settings.url, this._onAjaxSuccess.bind(this));
    return this;
  }

  QuickView.prototype = {

    /**
     * Initial AJAX Call callback
     * Gets the returned HTML, adds it to the DOM, sets the instance's dom element variables, initializes the product detail form
     *
     */
    _onAjaxSuccess: function(ajaxResponse) {
      this.$qvParent[0].insertAdjacentHTML('beforeend', ajaxResponse);

      this.$productDetailForm     = this.$qvParent.find(selectors.productDetailForm);
      this.$quickView             = this.$qvParent.find(selectors.quickView).last();
      this.$quickViewContentsBody = this.$qvParent.find(selectors.quickViewContentsBody);
      this.$close                 = this.$qvParent.find(selectors.quickViewClose);

      this.$productDetailForm.on('ready.productDetailForm', this.onProductDetailFormReady.bind(this));

      var config = {
        $el: this.$productDetailForm,
        $container: this.$quickView,
        zoomEnabled: true,
        enableHistoryState: false
      };

      this.productDetailFormInstance = new slate.ProductDetailForm(config);
      this.productDetailFormInstance.initialize();

      this.$close.on('click', this.onCloseClick.bind(this));

      // Fire off the loaded event once all the images in the quick view are loaded
      this.$quickView.imagesLoaded()
        .always( function() {
          var e = $.Event(this.events.LOADED);
          this.$qvParent.trigger(e);
        }.bind(this));
    },

    /**
     * Called after the product detail form is done initializing
     */
    onProductDetailFormReady: function() {
      this.settings.onProductDetailFormReady.call(this);
    },

    open: function() {
      this.onOpen();

      if(this.isOpen()) {
        return;
      }

      this.stateIsOpen = true;
    },

    close: function() {

      this.onClose();

      if(this.isClosed()) {
        return;
      }

      this.stateIsOpen = false;
    },

    isOpen: function() {
      return this.stateIsOpen;
    },

    isClosed: function() {
      return !this.isOpen();
    },

    /**
     * Called after this.open is called but before any opening animation has run
     */
    onOpen: function() {
      this.$qvParent.addClass(classes.productCardHasOpenQuickView);

      var e = $.Event(this.events.OPEN);
      this.$qvParent.trigger(e);
      slate.quantityAdjuster.refresh();

      this.$quickView.addClass(classes.quickViewIsOpen);
      this.$quickView.show();
      $('body').addClass('has-quick-view-open');
    },

    /**
     * Called after this.close is called but before any closing animation has run
     */
    onClose: function() {
      this.$qvParent.removeClass(classes.productCardHasOpenQuickView);
      var e = $.Event(this.events.CLOSE);
      this.$qvParent.trigger(e);

      this.$quickView.removeClass(classes.quickViewIsOpen);
      this.$quickView.hide();
      $('body').removeClass('has-quick-view-open');
    },

    positionQuickviewUnderSlide : function(){
      if ( !this.inSlideshow || !this.$parentSlideshow ) {
        return;
      }

      var cardPositionLeft = this.$qvParent.position().left;
      var cardOffsetLeft = this.$qvParent.offset().left;

      this.$quickView.css({
        left: cardPositionLeft - cardOffsetLeft + 'px',
        width: $(window).width()+'px' //set width = window, since
      });
    },

    resetFromSlidePosition : function(){
      this.inSlideshow = false;

      this.$quickView.css({
        left: 0,
        width: '100%'
      });
    },

    onQuickViewClick: function(e){
      if (this.isOpen()) {
        e.stopPropagation(); //prevent touch events inside the quickview from propagating outside (specifically swiping the slick slider)
      }
    },

    setTransitions: function() {
      var trans = 'height ' + this.settings.transitionDuration + 'ms ' + this.settings.transitionTimingFunction;
      this.$quickView.css( 'transition', trans);
      this.$qvParent.css( 'transition', trans);
    },

    scrollToProductCard: function() {
      $('html, body').animate( { scrollTop : (this.$qvParent.offset().top - 100) } );
    },
    scrollToQuickView: function() {
      $('html, body').animate( { scrollTop : (this.$quickView.offset().top -100) } );
    },
    onCloseClick: function(e) {
      e.preventDefault();
      this.close();
    }
  };

  return QuickView;

})(jQuery, Modernizr);

/**
 * Model - Collection Filters - Desktop + Mobile
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionFilters
 */

slate.models = slate.models || {}; 

slate.models.CollectionFilters = (function(){

  var $body = $(document.body);
  
  var selectors = {
    filterSelect: '[data-filters-type][data-filters-type-select]',
    mobileFilterGroup: '[data-mobile-filter-group]',
    mobileFilterTag: '[data-mobile-filter-tag][data-mobile-filter-type]',
    mobileFilterApply: '[data-mobile-filter-apply]'    
  };

  var classes = {
    mobileFilterTagSelected: 'is-selected'
  };  

  /**
   * CollectionFilters constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionFilters(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionFilters';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$filterSelects    = $(selectors.filterSelect, this.$container);
    this.$mobileFilterTags = $(selectors.mobileFilterTag, this.$container);

    this.$container.on('change', selectors.filterSelect, this.onFilterSelectChange.bind(this));
    this.$container.on('click',  selectors.mobileFilterTag, this.onMobileFilterTagClick.bind(this));
    this.$container.on('click',  selectors.mobileFilterApply, this.onMobileFilterApplyClick.bind(this));

    this._sortFilters();
  }

  CollectionFilters.prototype = $.extend({}, CollectionFilters.prototype, {

    /**
     * Returns a url for the current collection with selected tags
     *
     * @return {string} - url
     */
    _getCollectionUrlWithTags: function(tags) {
      var collectionUrl = this.collectionData.url;
      
      tags = tags || [];

      tags = tags.map(function (str) {
        return str
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      });

      return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
    },

    _getSelectedTags: function() {
      return $.map(this.$filterSelects.find('option:selected'), function(opt, i) {
        // Make sure we don't push empty strings
        if($(opt).val()) {
          return $(opt).val();
        }
      });
    },

    _getSelectedMobileTags: function() {
      return $.map(this.$mobileFilterTags, function(tag, i) {
        if($(tag).hasClass(classes.mobileFilterTagSelected)) {
          return $(tag).data('mobile-filter-tag');
        }
      });
    },

    _sortingFunctions: {

      /**
       * Sorts sizes based on a predefined order
       *
       * @param (string) a
       * @param (string) b
       * @return (int)
       */
      size: function(a, b) {
        console.warn('[collectionFilters] - _sortingFunctions.size - This method hasn\'t been implemented yet.');
        // Implement this so sizes show up how we expect them to? small, med, large..
      }
    },

    /**
     * Sorts the filter options inside each select tag if there is an applicable sort function available
     */
    _sortFilters: function() {
      var self = this;

      this.$filterSelects.each(function(){
        var $select = $(this);
        var $toSort = $select.find('option');
        var sortingFunction = self._sortingFunctions[ $select.data('filters-type') ];

        if(sortingFunction){
          $toSort.sort(function(a, b) {
            return sortingFunction($(a).val(), $(b).val());
          });
        }
      });
    },

    /**
     * Redirects the browser to the passed in URL while mainting the query string
     *
     * @param (string) url
     */
    redirect: function(url) {
      window.location.href = url + slate.utils.getQueryString();
    },

    /**
     * Redirects the browser to the collection page without any filters applied
     */
    clear: function() {
      window.location.href = this.collectionData.url + slate.utils.getQueryString();
    },   

    /**
     * Applies the selected filter options
     * Looks for selected options and creates a URL for them, then redirects the browser
     *
     * @param (event) e - click event
     */
    onFilterSelectChange: function(e) {

      var selectedTags = this._getSelectedTags();
      var url = this._getCollectionUrlWithTags(selectedTags);

      this.redirect(url);      
    },

    /**
     * Toggles the selected class for the clicked on filter tag while removing the selected class from other filter tags in the same group
     *
     * @param (event) e - click event
     */
    onMobileFilterTagClick: function(e) {
      e.preventDefault();

      var $tag = $(e.currentTarget);
      var tagIsSelected = $tag.hasClass(classes.mobileFilterTagSelected);
      
      $tag.parents(selectors.mobileFilterGroup).find(selectors.mobileFilterTag).removeClass(classes.mobileFilterTagSelected);

      if(!tagIsSelected) {
        $tag.addClass(classes.mobileFilterTagSelected);  
      }
      
    },

    /**
     * Applies the selected mobile filter tags.
     * Looks for selected tags and creates a URL for them, then redirects the browser
     *
     * @param (event) e - click event
     */
    onMobileFilterApplyClick: function(e) {
      e.preventDefault();

      var selectedTags = this._getSelectedMobileTags();
      var url = this._getCollectionUrlWithTags(selectedTags);

      this.redirect(url);
    }    
  });

  return CollectionFilters;
})();
/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

 slate.models.CollectionSort = (function(){

  var $body = $(document.body);
  
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();
/**
 * Model - Scroll With Page
 * -----------------------------------------------------------------------------
 * Scroll With Page will sticky elements to the top of the viewport when scrolled past
 * This script is made slightly complex by the fact that it checks to make sure the scrolling content fits within the viewport.  If it doesn't, it abs. positions it and allows it to scroll 'organically' until it meets an edge of the window.
 *
 * Note: This element needs a relatively positioned parent.
 *
 * Requires:
 *  - jQuery
 *
 * @namespace models.scrollWithPage
 */

 slate.models.ScrollWithPage = (function(){

  var selectors = {
  contentToScroll: '[data-scroll-with-content-content]',
  containerContent: '[data-scroll-with-content-container]'
  };

  var classes = {
  isScrolling: 'is-scrolling'
  };

  /**
   * ScrollWithContent constructor
   * scrollingElement - Whatevers scrolling with the page
   * containerElement - The parent to constrain scrolling of the first param
   * offsetElement - optional element to allow items to start scrolling *before* the top of the viewport gets there
   */

  function ScrollWithPage(scrollingElement, containerElement, offsetElement) {

    this.name = 'scrollWithPage';
    this.namespace = '.'+this.name;

    this.events = {
       RESIZE: 'resize' + this.namespace,
       READY:  'ready'  + this.namespace,
       SCROLL: 'scroll' + this.namespace
    };

    this.$window = $(window);

    var self = this;

    //Scrolling Element
    this.$scrollingElement = scrollingElement;
    this.isScrolling = false;
    this.$scrollingElement.scrollWithPage = true; //prop value to tell productDetailForm the object is initialized.

    //Scrolling element initial css styles
    this.origCss = {
      position: this.$scrollingElement.css('position'),
      top: this.$scrollingElement.css('top'),
      bottom: this.$scrollingElement.css('bottom'),
      width: "auto" //force a reset of the width to 'auto', will break if the element originally had a set width
    };

    //Initial viewport info
    this.viewport = {
      height: window.innerHeight,
      bottom: window.innerHeight
    };

    //Scrolling element initial position data
    this.origOffset = scrollingElement.parent().offset().top; //original position of links based on parent
    this.currentPos = scrollingElement.position().top; //current position of links relative to parent
    this.height = scrollingElement.outerHeight(true); //height of element w/ margin
    this.width = scrollingElement.parent().width(); //width - based off parent element (since el will be fixed)
    this.top = scrollingElement.offset().top; //current offset relative to document
    this.bottom = Math.ceil(scrollingElement.offset().top + scrollingElement.outerHeight(true));

    //container element
    this.container = {
      element: containerElement,
      height: containerElement.outerHeight(), //height of the content-wrap element,
      bottom: containerElement.outerHeight() + containerElement.offset().top //bottom of the content-wrap element
    };

    //if offset element
    this.offsetEl = {
      element: offsetElement ? offsetElement : null,
      height: offsetElement ? offsetElement.outerHeight() : 0
    };

    //Check if the scrolling element is taller than the viewport
    this.isTallerThanViewport = this.height > this.viewport.height - this.offsetEl.height;
  }

  ScrollWithPage.prototype = {

  //Initialize the item to scroll with the page.
  init: function() {
    this.isScrolling = true;
    this.distanceScrolled = $(window).scrollTop();
    this.scrollDir = false;
    this.isTallerThanViewport = this.height > this.viewport.height - this.offsetEl.height;
    this.distanceScrolled = $(window).scrollTop();

    var self = this;
    //bind event handlers
    self.update();
    setTimeout(function(){self.update();},500); //update once, slightly after load of page.

    this.$window.on( this.events.SCROLL, $.throttle(10, this.update.bind(this)) ); //bind the nav to update on scroll

    this.$window.on( this.events.RESIZE,  $.throttle(10, this.handleResize.bind(this)) ); //update on resize

    $("a").on('click', function() {
      setTimeout(function() {
        self.update();
      }, 100); //set the nav to update 100ms after clicking any anchor tag in the content.  This helps with relative links
    });
  },

  stop: function(){
    this.isScrolling = false;
    //remove event handlers, put styles back the way they were.
    this.$window.off( this.events.SCROLL );
    this.$window.off( this.events.RESIZE );
    this.resetPosition();

  },

  restart: function(){
    //reset css and restart the event handlers.
    this.$window.on( this.events.SCROLL, $.throttle(10, this.update.bind(this)) ); //bind the nav to update on scroll

    this.$window.on( this.events.RESIZE,  $.throttle(10, this.handleResize.bind(this)) ); //update on resize
    this.isScrolling = true;
    this.handleResize();//call the handle resize method to calc new top
  },

  //Update positioning of the item on scroll
  update: function(){
    if ( !this.isScrolling || this.$scrollingElement.is(":hidden")) {
      return; //catch if the isScrolling prop has been toggled off, or if the element is hidden. Return if so.
    }

    var $scrollingElement = this.$scrollingElement;
    var $containerElement = this.container.element;

    this.currentPos = $scrollingElement.position().top; //current relative position of links.
    this.height = $scrollingElement.outerHeight(true); //height of element

    this.width  = $scrollingElement.parent().width(); //width - based off parent element (since el will be fixed)
    this.top    = $scrollingElement.offset().top - parseInt($scrollingElement.css("marginTop")); //current offset relative to document
    this.bottom = Math.floor( this.top + this.height ); //Bottom of the scroll element.  Gets weird/jumpy unless you round it down.

    //container vars
    this.container.height = $containerElement.outerHeight();  //height of the container element
    this.container.heightWithMargin = $containerElement.outerHeight(true);
    this.container.bottom = this.container.height + $containerElement.offset().top; //bottom of the content-wrap element

    //offset Elements height
    this.offsetEl.height = this.offsetEl.element ? this.offsetEl.element.outerHeight() : 0;

    //scroll vars
    this.lastDistanceScrolled = this.distanceScrolled; //save lastDistance scrolled to compare for direction
    this.distanceScrolled = Math.ceil( this.$window.scrollTop() );
    this.scrollDir = this.distanceScrolled - this.lastDistanceScrolled > 0 ? "down" : "up";

    //bottom of the viewport's relative pixel location
    this.viewport.bottom = window.innerHeight + this.distanceScrolled;

    //event comparisons
    var heightDifference = this.distanceScrolled > this.top - this.offsetEl.height ? Math.floor(this.distanceScrolled - this.top + this.offsetEl.height) : 0; //represents the portion of the element that is 'offscreen' above the viewport.
    var hasReachedBottom = this.distanceScrolled + this.height - heightDifference + this.offsetEl.height >= Math.floor( this.container.bottom );
    var hasScrolledPastElement = this.distanceScrolled > this.origOffset - this.offsetEl.height;
    var isTallerThanContainer = this.height >= this.container.height;
    var isTallerThanViewport = this.isTallerThanViewport;

    //set a minheight on container in case it's shorter than the scrolling content.
    //This keeps content from resizing when the item gets fixed/absolutely positioned.
    if (this.container.heightWithMargin < this.height) {
      this.container.element.css("minHeight", this.height + "px");
    }

    //Start checking
    if ( !hasScrolledPastElement ) {
      //Hasn't scrolled past the item, do nothing
      this.resetPosition();

    } else if ( hasReachedBottom ) {
      //Scrolling element has reached the bottom bounding edge of its parent.
      //Note:  THe parent element may have collapsed its height with its child being abs. positioned, hence using top: ... instead of bottom: 0;
      this.changePosition("absolute", this.container.height - this.height, "auto", this.width); //Has reached the bottom of its container.  Position is at the bottom

    } else if ( hasScrolledPastElement && !hasReachedBottom ) {
      if ( isTallerThanContainer ) {
        this.changePosition("relative", "auto", "auto"); //Normal position
      } else if ( isTallerThanViewport ) {
        if (this.distanceScrolled + this.offsetEl.height <= this.top && this.scrollDir === "up") {
          this.changePosition("fixed", 0 + this.offsetEl.height, "auto", this.width); //Item is being pulled upwards, with its top edge hooked to the viewport.
        } else if ( this.viewport.bottom >= this.bottom && this.scrollDir === "down") {
          this.changePosition("fixed", "auto", 0, this.width); //Item is being pulled downwards, with its bottom edge hooked to the viewport.
        } else if ( $scrollingElement.css('position') === "fixed" ) {
          this.changePosition("absolute", (this.top - this.origOffset), "auto", this.width); //Item is taller than the viewport, and we're in the middle of it, so abs. position it based on its last known position.
        } else {
        }
      } else {
        this.changePosition("fixed", this.offsetEl.height, "auto", this.width);
      }
    }
  },

  handleResize:function(){
    this.viewport.height = window.innerHeight;
    this.isTallerThanViewport = this.height > this.viewport.height - this.offsetEl.height;
    this.origOffset = this.$scrollingElement.parent().offset().top;
    this.update();
  },

  changePosition: function(position, top, bottom, width) {
    this.$scrollingElement.css({
      position: position,
      top: top,
      bottom: bottom
    });

    if (width) {
      this.$scrollingElement.css({ width: width + "px" });
    } else {
      this.$scrollingElement.css({ width: "auto" });
    }
  },

  resetPosition: function() {
    this.$scrollingElement.css( this.origCss );
  }
  };

  return ScrollWithPage;

})(jQuery);




/**
* Model - Scrollspy
* -----------------------------------------------------------------------------
* Not to be confused with bootstrap's, this just checks scroll position and assigns the 'is-active' class to a thumbnail when the viewport has scrolled to its related image.
* This handles two things : 1) Setting thumbnails to active when its corresponding image is visible, and 2) smooth scrolling to a given image in desktop mode.
*
* Requires:
*  - jQuery
*
* @namespace models.scrollspy
*/

slate.models.Scrollspy = (function(){

  var classes = {
    scrollspyActiveLink: 'scrollspy-link-is-active',
    scrollspyActiveTarget: 'scrollspy-target-is-active'
  };  

  var $window = $(window);

  /**
   * Scrollspy constructor
   * scrollspyLinkSelector - Thumbnails in this case
   * scrollspyTargetSelector - Gallery images, in this case
   * offsetElement - optional element to allow items to start scrolling *before* the top of the viewport gets there (fixed header)
   */

  function Scrollspy(scrollspyLinks, scrollspyTargets, offsetElement) {

    this.name = 'scrollspy';
    this.namespace = '.'+this.name;

    this.events = {
       RESIZE: 'resize' + this.namespace,
       READY:  'ready'  + this.namespace,
       SCROLL: 'scroll' + this.namespace,
       CLICK: 'click' + this.namespace
    };

    var self = this;

    this.$scrollspyLinks = scrollspyLinks;
    this.$scrollspyTargets = scrollspyTargets;
    this.visibleTargets = []; //empty array we use to keep track of targets that are visible.

    this.offsetElement = offsetElement ? offsetElement : false; //set the offset element if necessary, otherwise set it to false

    //Keep track of where the viewport is, its height, and what the 'hotspot' is to decide which element is active.
    this.viewport = {
      scrollPos: $window.scrollTop(),
      height: $window.innerHeight(),
      activeRegion: 0.25 //fraction representing how far down the viewport the 'active' region should be.  0.5 == halfway down the viewport.
    };

    if ( offsetElement ) {
      this.viewport.scrollPos += offsetElement.outerHeight(true);
    } 

    //Check if the links/targets exist.  If they do, initialize.
    if ( ! this.$scrollspyLinks.length ) {
      console.warn("["+this.namespace+"] - Scrollspy links don't exist.");
      return;
    } else if ( !this.$scrollspyTargets.length ) {
      console.warn("["+this.namespace+"] - Scrollspy targets don't exist.");
      return;
    } else {
      this.init(); //init scrollspy
    }

  }

  Scrollspy.prototype = {

    init: function() {
      var self = this;
      //Initialize scrollspy
      this.$scrollspyLinks.each(function(ind, el) {
        //get data-scrollspy-target, find id associated with it.
        var linkEl = el;
        var $scrollspyLinkEl = $(el);
        var linkTargetSelector = $scrollspyLinkEl.data('scrollspy-target');

        self.$scrollspyTargets.each(function(ind, el) {
          if ( $(el).data('scrollspy-id') == linkTargetSelector ) {
            $scrollspyLinkEl.prop('scrollspyTarget', $(el)); //add a property to the link to form a connection between link and target.  
            //There should ever only be one presence of a given scroll spy target, but this enables multiple links to target the same element.
            
            //Now add a property to the target itself, an array to be filled in with any links that have its ID as their target...
            if ( !el.scrollspyLinks ) {
              el.scrollspyLinks = [ linkEl ]; //if this is the first time this target has been matched, add the link to the targets array of associated links that target it.
            } else {
              el.scrollspyLinks.push( linkEl ); //otherwise push it to the array
            }

            $scrollspyLinkEl.on( self.events.CLICK, self.scrollToTarget.bind(self) );

          }
        });        
      });

      this.refreshTargets(); //Update list of visible targets...

      //onScroll
      $window.on( this.events.SCROLL, $.debounce(50, self.handleScroll.bind(self)) ); //use debounce here, to prevent the scroll handler from firing until the user is done scrolling.
      
      //onResize
      $window.on( this.events.RESIZE, $.throttle(50, self.handleResize.bind(self)) );
    },

    stop: function(){
      //cease functioning

      //unbind event handlers
      $window.off( this.events.SCROLL );
      $window.off( this.events.RESIZE );
      this.$scrollspyLinks.off( this.events.CLICK );

      //Remove classes from elements
      this.$scrollspyLinks.removeClass( classes.scrollspyActiveLink ); 
      this.$scrollspyTargets.removeClass( classes.scrollspyActiveTarget ); 
    },

    restart:function() {
      var self = this;
      //restart
      this.refreshTargets(); //Update list of visible targets...

      //onScroll
      $window.on( this.events.SCROLL, $.debounce(50, self.handleScroll.bind(self)) ); //use debounce here, to prevent the scroll handler from firing until the user is done scrolling.
      
      //onResize
      $window.on( this.events.RESIZE, $.throttle(50, self.handleResize.bind(self)) );

      //onclick
      this.$scrollspyLinks.on( self.events.CLICK, this.scrollToTarget.bind(this) );
    },

    handleResize: function(){
      //Update viewport height/position
      this.viewport.height = $window.innerHeight();
      this.handleScroll();
    },

    handleScroll: function(){ 
      this.viewport.scrollPos = $window.scrollTop();//update scroll top
      
      //loop backwards through the array of visible targets, looking for the first target that is found past the viewport activate region.
      var activeScrollPos = this.viewport.scrollPos + ( this.viewport.height * this.viewport.activeRegion);

      for (var i = this.visibleTargets.length - 1; i >= 0; i--) {
        var $targetEl = this.visibleTargets[i];
        if ( $targetEl.offset().top < activeScrollPos || i == 0 ) {
          //We found the right element, but if it already has the active class we can safely ignore it
          if ( !$targetEl.hasClass( classes.scrollspyActiveTarget)) {
            //add classes to images
            this.$scrollspyTargets.removeClass( classes.scrollspyActiveTarget );
            $targetEl.addClass( classes.scrollspyActiveTarget );

            //add classes to thumbnails
            this.$scrollspyLinks.removeClass( classes.scrollspyActiveLink ); //remove class from all links
            if ( $targetEl.prop( 'scrollspyLinks' ) ) {
              $targetEl.prop( 'scrollspyLinks' ).forEach(function( el ){
                $(el).addClass( classes.scrollspyActiveLink ); //add class to all links associated with the given target.
              });
            }
          } 
  
          break; //break out of the forloop.
        }
      }
    },

    handleClick: function(e){
      e.preventDefault();
      //handle the clicking of a given item.
      var targetSelector = $(e).data( 'scrollspy-target' );
      var target = $('[' + target +']');
      if ( target.length && target.is(':visible') ) {
        this.scrollToTarget( target );
      }
    },

    refreshTargets: function() {
      var self = this;
      this.visibleTargets = []; //empty out array.

      //Update which links/targets are visible
      this.$scrollspyTargets.each(function(ind, el){
        if ( $(el).is(":visible") ) {
          self.visibleTargets.push( $(el) );
        }
      });

      this.handleScroll();// Call handle scroll against the new elements.
    },

    scrollToTarget: function(e){
      e.preventDefault();
      //method to scroll to a given link's scrollspy target
      var $scrollspyLink = $( e.currentTarget ) ; //link we clicked on
      var $scrollspyLinkTarget = $scrollspyLink.prop( 'scrollspyTarget' ); //get the target by referencing the prop we attached in 1.

      //If the target is present and visible...
      if ( $scrollspyLinkTarget.length && $scrollspyLinkTarget.is(':visible') ) {
        var targetTop = $scrollspyLinkTarget.offset().top; //get the top offset of the target

        if ( this.offsetElement ) {
          targetTop -= this.offsetElement.outerHeight(true); //if offset element is set, push target element's top position down to compensate.
        }
        //Scroll to the given element
        window.scrollTo({
          top: targetTop,
          behavior: "smooth"
        });
      }    
    },
  };

  return Scrollspy;

})(jQuery);




/**
 * Wishlist
 * ------------------------------------------------------------------------------
 * @namespace - models.Wishlist
*/

slate.models = slate.models || {};

slate.models.Wishlist = (function($) {
  
    var selectors = {
      addToWishlist : $(".add-to-wishl"),
      wishlNotification : $("#wishl-notification"),
      wishlNotificationClose : $(".wishl-close"),
    };
    var $body = $("body");

    var wishlBaseUrl = "https://wishl.shopstorm.com";
    var shopifyPermanentDomain = "bh-cosmetics-llc.myshopify.com";
    var wishlToken;
    var storeID;
    var wishlistID;
    var KEYS = {
      tab: 9,
      escape: 27
    };
    /**
     * News section constructor
     *
     * @param {string} container - selector for the section container DOM element
     */
    function Wishlist(container) {
        this.$container = $(container);
        this.name = 'wishlist';
        this.namespace = '.'+this.name;
        this.isOpen = false;
        this.closeModalTimeout = null;

        this.$wishlistItems = $( selectors.newsItems, this.$container );
        
        $body.on('itemadd.wishl', this.showNotification.bind(this));
        selectors.wishlNotificationClose.on('click', this.notificationClose.bind(this));

        // close the modal on pressing the Escape key
        $('body').on('keydown', (function(e) {
          if (e.which !== KEYS.escape || !this.isOpen) return;
          this.notificationClose();
        }).bind(this));

        this._modalTabbingInit();
    }
  
    Wishlist.prototype = $.extend({}, Wishlist.prototype, {

    showNotification : function(){
        var cssToOpen = {opacity: 'show'};
        if ((selectors.wishlNotification.css('bottom') == '30px') || (selectors.wishlNotification.css('bottom') == '100px')){
            cssToOpen.height = 130;
          } else {
            cssToOpen.width = 340;
        }
        selectors.wishlNotification.animate(cssToOpen);
        this.isOpen = true;
        this.focusedElement = document.activeElement;
        selectors.wishlNotificationClose.focus();
        if(this.closeModalTimeout) {
          clearTimeout(this.closeModalTimeout);
          }
        this.closeModalTimeout = setTimeout((function () {
            this.notificationClose();
        }).bind(this), 10000);
    },

    notificationClose : function(){
        if(this.closeModalTimeout) {
            clearTimeout(this.closeModalTimeout);
        }
        var cssToClose = {opacity: 'hide'};
        if ((selectors.wishlNotification.css('bottom') == '30px') || (selectors.wishlNotification.css('bottom') == '100px')){
            cssToClose.height = 0;
          } else {
            cssToClose.width = 0;
          }
        selectors.wishlNotification.animate(cssToClose);
        if(this.focusedElement) {
            this.focusedElement.focus();
        }
        this.isOpen = false;
        this.closeModalTimeout = null;
    },

    initWishlWrapper: function() {
      
      var existingToken = this.getCookie("_wishl_");

      // in order for the addToWishlist and getAllWishlistItems fucntions to work, we need our store id
      var getShopConfigUrl = wishlBaseUrl + "/full?shop=" + shopifyPermanentDomain + "&full=1&notes=0"; 
      
      if (existingToken != undefined) { 
        getShopConfigUrl += "&token=" + existingToken; 
      }

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": getShopConfigUrl,
        "method": "GET",
        "headers": {}
      }

      $.ajax(settings).done(function (response1) {
        storeID = response1.store.id;
        if (existingToken != undefined && response1.error == undefined) { 
          wishlistID = response1.wishlists[0].id;
          wishlToken = existingToken;
        }
      });
    },

    addItem: function(productID, handle, variantID, price, cb) {

      if (storeID != undefined && wishlistID == undefined && wishlToken == undefined) {
        
        // if this customer doesn't have a wishlist, create a default one
        var wishlistsUrl = wishlBaseUrl + "/stores/" + storeID + "/wishlists";

        var settings2 = {
          "async": true,
          "crossDomain": true,
          "url": wishlistsUrl,
          "method": "POST",
          "headers": {},
          "data": "wishlist%5Btitle%5D=My+Wishlist",
          "error": function(XMLHttpRequest, textStatus, errorThrown) { 
            console.log("Status: " + textStatus); 
            console.log("Error: " + errorThrown); 
          }   
        }
        
        $.ajax(settings2).done(function (response2) {
          
          // set cookie to expire in 90 days
          var date = new Date();
          date.setTime(date.getTime()+(90*24*60*60*1000));
          var expires = "; expires="+date.toGMTString();

          // save the new wishlist's token as a cookie and make it available globally 
          document.cookie = "_wishl_=" + response2.token + expires + "; path=/";

          // update our vars
          wishlToken = response2.token;
          wishlistID = response2.id;

          //add item to wishlist url
          var addItemUrl = wishlBaseUrl + "/wishlists/" + wishlistID + "/items";

          var addItemData = ""; 
          addItemData += "item%5Bproductid%5D=" + productID; 
          addItemData += "&item%5Bhandle%5D=" + handle;
          addItemData += "&item%5Bvariantid%5D=" + variantID; 
          addItemData += "&item%5Binitial_price%5D=" + price;
          addItemData += "&token=" + wishlToken;
          addItemData += "&store_id=" + storeID;

          var settings = {
            "async": true,
            "crossDomain": true,
            "url": addItemUrl,
            "method": "POST",
            "headers": {},
            "data": addItemData
          }

          $.ajax(settings)
            .done(function(data) {
              if (data.errors != undefined) {
                console.log("item already in wishlist, redirecting to wishlist page.");
                window.location.href = "/pages/wishl-wishlist";
              } else {
                cb(data);
              }
            });

        });
      } else if (wishlistID != undefined && wishlToken != undefined && storeID != undefined) {

        //add item to wishlist 
        var addItemUrl = wishlBaseUrl + "/wishlists/" + wishlistID + "/items";

        var addItemData = ""; 
        addItemData += "item%5Bproductid%5D=" + productID; 
        addItemData += "&item%5Bhandle%5D=" + handle;
        addItemData += "&item%5Bvariantid%5D=" + variantID; 
        addItemData += "&item%5Binitial_price%5D=" + price;
        addItemData += "&token=" + wishlToken;
        addItemData += "&store_id=" + storeID;

        var settings = {
          "async": true,
          "url": addItemUrl,
          "method": "POST",
          "headers": {},
          "data": addItemData
        }
        
        $.ajax(settings)
          .done(function(data) {
            if (data.errors != undefined) {
              console.log(data.errors);
              window.location.href = "/pages/wishl-wishlist";
            } else {
              console.log("successfully added " + handle + " to wishlist")
              cb(data);
            }

          });

      } else {
        console.warn("[wishlist not initialized] - unable to add items to wishlist");
      }
    
    },

    getAllWishlistItems: function(cb) {

      var getstoreID = wishlBaseUrl + "/full?shop=" + shopifyPermanentDomain + "&full=1&notes=0&token=" + wishlToken; 

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": getstoreID,
        "method": "GET",
        "headers": {} 
      }
      
      $.ajax(settings).done(function(data) {
        if (data.errors != undefined) {
          console.warn("error fetching customer wishlist. check to make sure wishl token is not null and that permanentDomain is set to .myshopify.com url in constructor.");                
        } else if (data.items.length === 0 || data.items === undefined) {
          console.warn("no items found on current user's wishlist.");
        } else {
          //cb(data.items);
          //return data.items;
          findifyWishlist.items = data.items;
          //$(document).on('findify.wishlistLoaded', ()=>{console.log('findify.wishlistItemsLoaded trigerred')});
          //console.log('triggering findify.wishlistItemsLoaded on document');
          $(document).trigger('findify.wishlistItemsLoaded');
        }
      });
    },

    getCookie: function(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      }
    },

    _modalTabbingInit: function() {
      var inputs = selectors.wishlNotification.find('select, input, textarea, button, a');
      var firstInput = inputs.first();
      var lastInput = inputs.last();
      
      /*redirect last tab to first input*/
      lastInput.on('keydown', (function (e) {
        if ((e.which === KEYS.tab && !e.shiftKey && this.isOpen)) {
            e.preventDefault();
            firstInput.focus();
        }
      }).bind(this));

      /*redirect first shift+tab to last input*/
      firstInput.on('keydown', (function (e) {
          console.log('First input clicked');
          if ((e.which === KEYS.tab && e.shiftKey && this.isOpen)) {
              e.preventDefault();
              lastInput.focus();
          }
      }).bind(this));
    }
  });

  return Wishlist;
})(jQuery);
/**
 * Timer
 * A slate model that creates a countdown timer to a specific date.
 *
 * Requires moment.js
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.Timer
 *
 */

slate.models = slate.models || {};

slate.models.Timer = (function($) {
  var selectors = {
    timerOutput: "[data-countdown-timer-rendered]",
    timerAccessible: "[data-countdown-timer-accessible]"
  };

  var dataAttr = {
    timerTarget: "countdown-timer-target",
    timerTimezone: "countdown-timer-timezone",
    timerType: "countdown-timer-type"
  };

  var classes = {
    hiddenTimer: "hidden"
  };

  function Timer(el) {
    this.name = "timer";
    this.namespace = "." + this.name;
    this.$el = el instanceof jQuery ? el : $(el);

    //Events
    this.events = {
      ENDED: "ended" + this.namespace
    };

    //Datetime data
    this.timerData = this.$el.data(dataAttr.timerTarget);
    this.timezone = this.$el.data(dataAttr.timerTimezone);

    //Format the timer should take.
    /* options are:
     *
     * 'normal'   - shows the timer as HH:MM:SS (useful for durations that are < 72 hours)
     * 'adaptive' - shows HH:MM when > 1 hour, then MM:SS when < 1 hour. (useful for ???)
     *
     */
    this.timerType = this.$el.data(dataAttr.timerType)
      ? this.$el.data(dataAttr.timerType)
      : "normal";

    //Element where timer will be rendered
    this.$outputEl = $(selectors.timerOutput, this.$el);

    if (slate.utils.isThemeEditor()) {
      if (!this.$outputEl.length) {
        console.warn(
          "[" +
            this.name +
            "] - Timer doesn't have an element to render timer in."
        );
        return;
      } else if (!this.timerData) {
        console.warn(
          "[" + this.name + "] - Timer doesn't have a target end-time set."
        );
        return;
      } else if (!this.timezone) {
        console.warn("[" + this.name + "] - Timer doesn't have a timezone");
        return;
      }
    }
    //Initialize timer
    this.init();
  }

  Timer.prototype = $.extend({}, Timer.prototype, {
    init: function() {
      var timeFormat = "MM-DD-YYYY hh:mm:ss A"; //ex. 01-01-2018 12:00:00 PM

      //Convert the current time and target time into moments.
      this.currentTime = moment.tz(this.timezone); // get current time in desired timezone.
      this.targetTime = moment.tz(this.timerData, timeFormat, this.timezone); //get target time in desired timezone

      //Calculate the time remaining with moment helper functions.
      this.timeDiff = this.targetTime.diff(this.currentTime); //Time difference between the target time and now
      this.timeRemaining = moment.duration(this.timeDiff); //turn the time difference into something moment.js recognizes
      
      //Validate timer, abort if something's wrong.
      if (!this.validate(this.targetTime)) {
        this.stopTimer();
        this.removeTimer();
        return;
      }

      //Show and start timer.
      this.startTimer();
      this.$el.removeClass(classes.hiddenTimer);
    },

    /*
     * Method to make sure the timer is valid.  Uses moment's 'isValid()' helper function.
     */
    validate: function(momentDateTime) {
      if (!momentDateTime.isValid()) {
        if (slate.utils.isThemeEditor()) {
          //If we're in the theme editor, give the admin editing it a message + console log.
          console.warn(
            "[" + this.name + "] - Invalid datetime for countdown timer"
          );
          this.$el.text("[Error: Invalid time format for timer!]");
        } else {
          //If we're not in the themeEditor, remove the countdown element entirely.
          this.$el.remove();
        }
        return false;
      }

      return true;
    },

    /*
     * Method to start timer.
     */
    startTimer: function() {
      this.step();
      this.interval = setInterval(this.step.bind(this), 1000);
    },

    /*
     * Method to stop timer.
     */
    stopTimer: function() {
      clearInterval(this.interval); //clear the interval for the timer
    },

    /*
     * Method to remove timer once it's elapsed.
     */
    removeTimer: function() {
      //Trigger 'ended' event in case the parent needs to know the timer has elapsed.
      var e = $.Event(this.events.ENDED);
      this.$el.trigger(e);

      //Remove the timer from the DOM
      this.$el.remove();
    },

    /*
     * Method to render updated time to timer element.  Only updates if output has changed from the last time.
     */
    render: function(output, setHtml) {
      if (this.output != output) {
        if (setHtml) {
          this.output = output;
          this.$outputEl.html(output);
        } else {
          this.output = output;
          this.$outputEl.text(output);
        }
      }
    },

    /*
     * Method to step timer forward 1 second.
     */
    step: function() {
      //Moment function to subtract 1 second.
      this.timeRemaining = this.timeRemaining.subtract(1, "seconds");

      //If time remaining goes below 0, stop the timer, remove the element.
      if (this.timeRemaining < 0) {
        this.stopTimer(); //destroy timer and remove panel if timer has elapsed.
        this.removeTimer(); //destroy timer and remove panel if timer has elapsed.
      }

      var output = "";
      var outputHtml = false;
      /*
       * Note on Moment.js - The .hours(), .minutes(), etc helper methods return the
       * number of days/hours/minutes left, but won't elapse into another unit.
       *
       * Ex. if there's 3 hours, 40 minutes remaining, .hours() will return 3, and .minutes()
       * will return 40.
       *
       * You can use the asHours(), asMinutes(), etc. helper methods to return the total
       * remaining duration in a given unit.
       */

      var daysRemaining = this.timeRemaining.days();
      var hoursRemaining = this.timeRemaining.hours();
      var minutesRemaining = this.timeRemaining.minutes();
      var secondsRemaining = this.timeRemaining.seconds();

      var timeRemainingInHours = this.timeRemaining.asHours();

      if (this.timerType == "normal") {
        var hours = Math.floor(timeRemainingInHours);
        hours = hours < 10 ? "0" + hours : hours;
        var minutes =
          minutesRemaining < 10 ? "0" + minutesRemaining : minutesRemaining;
        var seconds =
          secondsRemaining < 10 ? "0" + secondsRemaining : secondsRemaining;

          output = hours + ":" + minutes + ":" + seconds;
      } else if (this.timerType == "adaptive") {
        //Adaptive countdown timer
        if (daysRemaining >= 1) {
          output = daysRemaining + " day";
          if (daysRemaining >= 2) output += "s";
        } else if (hoursRemaining >= 1) {
          output = hoursRemaining + " hour";
          if (hoursRemaining >= 2) output += "s";
        } else if (minutesRemaining >= 1) {
          output = minutesRemaining + " minute";
          if (minutesRemaining >= 2) output += "s";
        } else {
          //When timer falls under 1 minute, remove it.
          this.stopTimer();
          this.removeTimer();
        }
      } else if (this.timerType == "incremented") {
        if (daysRemaining >= 3) {
          // show timer with days to go format when more than 3 days out
          output = daysRemaining + " day";
          if (daysRemaining >= 2) output += "s";
        } else {
          // show timer with HH:MM:SS format when less than three days out 
          var hours = Math.floor(timeRemainingInHours);
          hours = hours < 10 ? "0" + hours : hours;
          var minutes = minutesRemaining < 10 ? "0" + minutesRemaining : minutesRemaining;
          var seconds = secondsRemaining < 10 ? "0" + secondsRemaining : secondsRemaining;
          
          output = hours + ":" + minutes + ":" + seconds;
        }
      } else if (this.timerType == "normal-long") {
        var days = daysRemaining < 10 ? "0" + daysRemaining : daysRemaining;
        var hours = hoursRemaining < 10 ? "0" + hoursRemaining : hoursRemaining;
        var minutes = minutesRemaining < 10 ? "0" + minutesRemaining : minutesRemaining;
        var seconds = secondsRemaining < 10 ? "0" + secondsRemaining : secondsRemaining;

        outputHtml = true;
        output = "<div class='normal-long'><div class='timer-normal-long__day'>"  + days + "<div class='day-label'>DAYS</div></div><div class='normal-long-spacer'> : </div><div class='timer-normal-long__hour'>" + hours + "<div class='hour-label'>HOURS</div></div><div class='normal-long-spacer'> : </div><div class='timer-normal-long__minutes'>" + minutes + "<div class='minute-label'>MINUTES</div></div><div class='normal-long-spacer'> : </div><div class='timer-normal-long__seconds'>" + seconds + "<div class='second-label'>SECONDS</div></div></div>";
      }
      
      //Render the new countdown timer.
      this.render(output, outputHtml);
    }
  });

  return Timer;
})(jQuery, moment);

/**
 * Model - Vimeo Player
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.vimeoPlayer
 */

slate.models.VimeoPlayer = (function ($, Vimeo) {

    var selectors = {
      playToggle: '.video__play-pause-btn',
      player: '.video__player',
      poster: '.video__poster'
    };
  
    var dataAttr = {
      videoId: 'video-id'
    };
    
    var classes = {
      videoLoaded : 'video-loaded',
      initialized : 'video-initialized'
    };
  
    function VimeoPlayer(el, options) {
      this.name = 'vimeoPlayer';
      this.namespace = '.' + this.name;
      this.disallowAutoplay = false;
      this.initialized = false;
  
      var options = options || {};

      this.$el = el instanceof jQuery ? el : $(el);

      //Get Video Player
      this.$player = $( selectors.player, this.$el );

      if( !this.$player ){
        console.warn('['+this.name+'] - Player element is required.');
        return;
      }
  
      //Get Video ID
      this.videoId = this.$el.data( dataAttr.videoId );
      if(!this.videoId){
        console.warn('['+this.name+'] - Element needs the [data-video-id] attribute.');
        return;
      }
  
      //Player Defaults
      var defaults = {
        id         : this.videoId, //id of the video
        muted      : true,
        autoplay   : false,
        portrait   : false,
        byline     : false,
        loop       : true,
        title      : false,
        controls   : false,
        background : true //IMPORTANT: Setting this to true forces vimeo videos into 'background' mode.
      };
  
      // Determine video settings from defaults and passed options
      this.videoSettings = $.extend({}, defaults, options);
  
      // // Disable autoplay background videos in safari to compensate for apple's insertion of blank frames
      // // if the audio duration, video duration, and stream duration metafields have different ms values
      // var ua = navigator.userAgent.toLowerCase();
      // if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1) {
      //   // if we are on safari
      //   // Override any of the options that don't agree with safari's video encoding rules
      //   this.disallowAutoplay = true;
  
      //   //If background is set to true, prevent the video from displaying at all.
      //   if (this.videoSettings.background){
      //     //console.warn('['+this.name+'] - Vimeo with background mode currently disabled on Safari.');
      //     return;
      //   }
      // }
  
      //Initialize
      this.init();
    }
  
    VimeoPlayer.prototype = $.extend({}, VimeoPlayer.prototype, {
  
      init: function(){
        this.player = new Vimeo.Player(this.$player, this.videoSettings);
        this.$el.addClass('initialized');

        this.$poster = $( selectors.poster, this.$el );
        this.$poster.on('click', this.onPlayToggleClick.bind(this));
  
        //Find play button (only present when autoplay = false). Set click handler
        this.$playButton = $( selectors.playToggle, this.$el );
        this.$playButton.on('click', this.onPlayToggleClick.bind(this));
        
        //Event Handlers
        this.player.on('loaded', this.onLoadVideo.bind(this));
        this.player.on('pause', this.onPauseVideo.bind(this));
        this.player.on('play', this.onPlayVideo.bind(this));
        this.player.on('ended', this.onPauseVideo.bind(this));
        
        //Check if autoplay is set, sometimes vimeo needs a kick to get started.
        if (this.videoSettings.autoplay && !this.disallowAutoplay){
          this.playVideo();
        }
  
        //If video is setup as a background/autoplay, and autoplay is disableday is enabled...
        if (this.disallowAutoplay && (this.videoSettings.background || this.videoSettings.autoplay)) {
          this.pauseVideo();
        }
      },
  
      toggleVideo: function () {
        if (this.$el.hasClass('is-playing')) {
          this.player.pause();
        }else{
          this.player.play();
        }
      },
  
      toggleAudio: function () {
        if ( this.$el.hasClass('is-muted')) {
          this.unMuteVideo();
        } else {
          this.muteVideo();
        }
      },
  
      playVideo: function () {
        if (!this.$el.hasClass('is-playing')) {
          this.player.play();
        }
      },
  
      pauseVideo: function () {
        this.player.pause();
      },
  
      onPauseVideo: function () {
        this.$el.removeClass('is-playing');
      },
  
      onPlayVideo: function () {
        this.$el.addClass('is-playing');
      },
  
      onLoadVideo: function(e){
        this.$el.addClass(classes.videoLoaded);
      },
  
      onVideoFinish: function() {
        this.player.play();
      },
  
      unMuteVideo: function () {
        this.player.setVolume(1);
        this.$el.removeClass('is-muted');
      },
  
      muteVideo: function () {
        this.player.setVolume(0);
        this.$el.addClass('is-muted');
      },
  
      onPlayToggleClick: function () {
        if (!this.$el.hasClass('is-playing')) {
          this.player.play();
        } else {
          this.player.pause();
        }
      }
  
    });
  
    return VimeoPlayer;
  
  })(jQuery, Vimeo);

/**
 * Model - YouTube Player
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.youtubePlayer
 */

slate.models.YouTubePlayer = (function ($, ytPlayer) {

  var selectors = {
    playToggle: '.video__play-pause-btn',
    player: '.video__player',
    poster: '.video__poster'
  };

  var dataAttr = {
    videoId: 'video-id'
  };
  
  var classes = {
    videoLoaded : 'video-loaded',
    initialized : 'video-initialized'
  };

  function YouTubePlayer(el, options) {
    this.name = 'youtubePlayer';
    this.namespace = '.' + this.name;
    this.disallowAutoplay = false;
    this.initialized = false;

    var options = options || {};
    this.$el = el instanceof jQuery ? el : $(el);

    //Get Video Player
    this.$player = $( selectors.player, this.$el );

    if( !this.$player ){
      console.warn('['+this.name+'] - Player element is required.');
      return;
    }

    //Get Video ID
    this.videoId = this.$el.data( dataAttr.videoId );
    if(!this.videoId){
      console.warn('['+this.name+'] - Element needs the [data-video-id] attribute.');
      return;
    }

    //Initialize
    this.init();
  }

  YouTubePlayer.prototype = $.extend({}, YouTubePlayer.prototype, {

    init: function(){
      this.player = new ytPlayer(this.$player[0]);
      this.player.load(this.videoId);
      this.$el.addClass('initialized');

      this.$poster = $( selectors.poster, this.$el );
      this.$poster.on('click', this.onPlayToggleClick.bind(this));

      this.$playButton = $( selectors.playToggle, this.$el );
      this.$playButton.on('click', this.onPlayToggleClick.bind(this));

      //Event Handlers
      this.player.on('cued', this.onLoadVideo.bind(this));
      this.player.on('paused', this.onPauseVideo.bind(this));
      this.player.on('playing', this.onPlayVideo.bind(this));
      this.player.on('ended', this.onPauseVideo.bind(this));
    },

    toggleVideo: function () {
      if (this.$el.hasClass('is-playing')) {
        this.player.pause();
      }else{
        this.player.play();
      }
    },

    toggleAudio: function () {
      if ( this.$el.hasClass('is-muted')) {
        this.unMuteVideo();
      } else {
        this.muteVideo();
      }
    },

    playVideo: function () {
      if (!this.$el.hasClass('is-playing')) {
        this.player.play();
      }
    },

    pauseVideo: function () {
      this.player.pause();
    },

    onPauseVideo: function () {
      this.$el.removeClass('is-playing');
    },

    onPlayVideo: function () {
      this.$el.addClass('is-playing');
    },

    onLoadVideo: function(e){
      this.$el.addClass(classes.videoLoaded);
    },

    onVideoFinish: function() {
      this.player.play();
    },

    unMuteVideo: function () {
      this.player.setVolume(1);
      this.$el.removeClass('is-muted');
    },

    muteVideo: function () {
      this.player.setVolume(0);
      this.$el.addClass('is-muted');
    },

    onPlayToggleClick: function () {
      if (!this.$el.hasClass('is-playing')) {
        this.player.play();
      } else {
        this.player.pause();
      }
    }

  });

  return YouTubePlayer;

})(jQuery, ytPlayer);

/**
 * ResponsiveCollapse
 * -----------------------------------------------------------------------------
 * Disables collapse on selected breakpoint
 *
 */

slate.responsiveCollapse = (function ($) {
    'use strict';
  
    var DEFAULT_DISABLE_BREAKPOINT = 'sm';
    var BREAKPOINTS = ['xs','sm','md','lg','xl'];
  
    function getTargetFromTrigger($trigger) {
      var href;
      var target = $trigger.attr('data-target')
        || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
  
      return $(target);
    }

    var ResponsiveCollapse = function (element, options) {
      this.$element = $(element);
      this.$target = getTargetFromTrigger(this.$element);
      this.options = $.extend({}, ResponsiveCollapse.DEFAULTS, options);
      
      if(BREAKPOINTS.indexOf(this.options.breakpoint.toLowerCase()) < 0)
        this.options.breakpoint = ResponsiveCollapse.DEFAULTS.breakpoint;

      this.minWidth = slate.breakpoints.getBreakpointMinWidth(this.options.breakpoint);

      this.disabled = null;

      var self = this;

      // disable the default collapsible behavior on large screens
      $(this.$element).click(function(e) {
        if(self.disabled) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
  
      $(window).resize(this.onResize.bind(this));
  
      this.onResize();
    }
  
    ResponsiveCollapse.DEFAULTS = {
      breakpoint: DEFAULT_DISABLE_BREAKPOINT
    };
  
    ResponsiveCollapse.prototype.onResize = function() {
      var window_width = window.innerWidth;
      var disabled = (window_width >= this.minWidth);
      if(this.disabled != disabled) {
        this.disabled = disabled;
        this.disableCollapse();
      }
    };

    ResponsiveCollapse.prototype.disableCollapse = function() {
      if(this.disabled)
        $(this.$target).collapse('show');
      else
        $(this.$target).collapse('hide');
    }

    $('[data-toggle="collapse"][data-toggle-breakpoint-off]').each(function () {
      var $this = $(this);
      new ResponsiveCollapse($this, {breakpoint: $this.data('toggle-breakpoint-off')});
    });
  
}(jQuery));


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    addToCartForm: '[data-add-to-cart-form]',
    addToCartFormWrapper: '[data-add-to-cart-form-wrapper]',
    reviewsButton: '[data-product-reviews-link]',
    reviewsTab: '.yotpo-nav-tab'
  };

  var classes = {
    stickyBarVisible: 'is-visible',
    infoLinkIsActive: 'is-active',
    yotpoTabActive: 'yotpo-active'
  };

  var dataAttr = {
    reviewsLinkTargetTab: 'product-reviews-link',
    yotpoTabId: 'type'
  }

  var $window   = $(window);
  var $document = $(document);

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize'  + this.namespace,
      CLICK: 'click'   + this.namespace,
      SCROLL: 'scroll' + this.namespace
    };

    this.$addToCartFormWrapper = $(selectors.addToCartFormWrapper, this.$container);
    this.$addToCartForm = $(selectors.addToCartForm, this.$container);

    var productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });
    // this.showNotification = new slate.models.Wishlist(container);

    productDetailForm.initialize();

    //if the reviews link exists, and the yotpo wrapper exists...
    $( selectors.reviewsButton, this.$container ).on('click', this.handleReviewsLinkClick.bind(this));
  }

  Product.prototype = $.extend({}, Product.prototype, {
    handleReviewsLinkClick: function(e){
      //On click of a reviews link, find the corresponding tab in yotpo (if it exists), and trigger a click on it.
      var targetTab = $(e.target).data( dataAttr.reviewsLinkTargetTab );

      $( selectors.reviewsTab ).each(function(i,el){
        if ($(el).data( dataAttr.yotpoTabId ) == targetTab && !$(el).hasClass( classes.yotpoTabActive )) {
          $(el).trigger('click'); //trigger click on this tab, so it's active when we scroll down.
        }
      });
    }
  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function(slate) {
  var $window = $(window);

  var selectors = {
    collectionJson: "[data-collection-json]",
    contentBlockStore: "[data-content-block-store]",
    productGridItemProduct: "[data-product-grid-product]",
    productGridItemContentBlock: "[data-product-grid-content-block]",
    subCollectionLink: "[data-subcollection-link]",
    ActiveSubCollectionLink: ".is-active[data-subcollection-link]",
    subCollectionLinkWrap: "[data-subcollection-link-wrap]",
    backInStockTrigger: "[data-back-in-stock-trigger]",
    backInStockTriggerInner: "[data-back-in-stock-trigger-inner]"
  };

  function Collection(container) {
    this.$container = $(container);

    this.name = "collection";
    this.namespace = "." + this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn(
        "[" +
          this.name +
          "] - Element matching " +
          selectors.collectionJson +
          " required."
      );
      return;
    }

    this.collectionData = JSON.parse(
      $(selectors.collectionJson, this.$container).html()
    );

    this.filters = new slate.models.CollectionFilters( container, this.collectionData );
    this.sort    = new slate.models.CollectionSort( container, this.collectionData );
    window.wishl = window.wishl || new slate.models.Wishlist(container);
    this.wishl = window.wishl;


    this.$subcollectionLinks = $(selectors.subCollectionLink, this.$container);
    this.$subcollectionLinkWrap = $(
      selectors.subCollectionLinkWrap,
      this.$container
    );

    //disable this functionality for hard pagination
    //this.$subcollectionLinks.on("click", this.redirectWithParams.bind(this));

    //If collection filters exist, call the onLoad method to scroll to the active filter if its out of viewport.
    if (this.$subcollectionLinks.length) {
      this.onLoad();
    }

    //Place promo/content blocks
    this.placeContentBlocks();

    $window.on("resize", $.debounce(50, this.handleResize.bind(this)));
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    onLoad: function(e) {
      //method to scroll a filter into view on load.
      var activeFilterPos = $(
        selectors.ActiveSubCollectionLink,
        this.$container
      ).position().left;
      var activeFilterWidth = $(
        selectors.ActiveSubCollectionLink,
        this.$container
      ).outerWidth(true);
      var activeFilterRightEdge = activeFilterPos + activeFilterWidth;
      var filterListWidth = this.$subcollectionLinkWrap.width();

      if (activeFilterRightEdge > filterListWidth) {
        var scrollDiff = activeFilterRightEdge - filterListWidth;
        this.$subcollectionLinkWrap[0].scrollTo({ left: scrollDiff });
      }
    },

    redirectWithParams: function(e) {
      //method to redirect with the current sorting intact when a subcollection is clicked
      if (typeof findify_initialized != "undefined" && findify_initialized != true) {
        e.preventDefault();
        var url = $(e.currentTarget).attr("href");

        window.location.href = url + slate.utils.getQueryString();
      }
    },

    placeContentBlocks: function(sortNeeded) {
      var $productGridContentBlocks = $(
        selectors.productGridItemContentBlock,
        this.$container
      );
      
      if ($productGridContentBlocks.length > 0) {
        var sortNeeded = slate.utils.defaultTo(sortNeeded, false);
        var desktop =
          $window.width() > slate.breakpoints.getBreakpointMinWidth("md");

        var $productGridProducts = $(
          selectors.productGridItemProduct,
          this.$container
        );

        var $contentBlockStore = $(selectors.contentBlockStore, this.$container);
        var outputtedContentBlockCount = 0;

        // First put all the content blocks into the store
        $productGridContentBlocks.detach().appendTo($contentBlockStore);

        if (sortNeeded) {
          // Then sort them by index in case they get mixed up
          // Theme editor screws with the ordering
          $productGridContentBlocks.sort(function(a, b) {
            var aI = parseInt($(a).data("product-grid-content-block"));
            var bI = parseInt($(b).data("product-grid-content-block"));

            if (aI > bI) {
              return 1;
            }
            if (aI < bI) {
              return -1;
            }
            return 0;
          });
        }

        // Then loop through all the product grid products and insert a content block where needed until we run out of content blocks or places to put them
        $productGridProducts.each(function(i) {
          var $gridProduct = $(this);
          var positionFlag;

          if (outputtedContentBlockCount >= $productGridContentBlocks.length) {
            return false; // break $.each
          }

          /*
          * For desktop
          * - Product grid is 4 across
          * - Insert a promo block after every 8 product blocks
          *
          * For mobile
          * - Product grid is 2 across, still placing promo block every 8 blocks
          */
          positionFlag = (i + 1) % 8;

          if (positionFlag == 0) {
            $productGridContentBlocks
              .eq(outputtedContentBlockCount)
              .detach()
              .insertAfter($gridProduct);
            outputtedContentBlockCount += 1;
          }
        });

        //Then set a max-height = their initial height to prevent stretching due to the flexbox stuff
        this.calcContentBlocksMaxHeight();
      }
    },

    handleResize: function(e) {
      var desktop =
        $window.width() > slate.breakpoints.getBreakpointMinWidth("md");
      if (desktop) {
        this.calcContentBlocksMaxHeight();
      } else {
        $(selectors.productGridItemContentBlock, this.$container).css({
          maxHeight: "none"
        });
      }
    },

    calcContentBlocksMaxHeight: function() {
      var $productGridProduct = $(
        selectors.productGridItemProduct,
        this.$container
      ).eq(0);
      var $productGridContentBlocks = $(
        selectors.productGridItemContentBlock,
        this.$container
      );
      // only set maxHeight when window is greater than md brekpoint
      var desktop =
        $window.width() > slate.breakpoints.getBreakpointMinWidth("md");
      if (desktop) {
        $productGridContentBlocks.css({
          maxHeight: $productGridProduct.height()
        });
      }
    },

    /**
     * Theme Editor section events below
     */
    onBlockDeselect: function() {
      this.placeContentBlocks(true);
    }
  });

  return Collection;
})(slate);

/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {
  var $window = $(window);

  var selectors = {
    pencilBannerPanel: "[data-pencil-banner-block]",
    pencilBannerTimer: "[data-pencil-banner-timer]",
    timers: "[data-countdown-timer]",
    pencilBannerPlayButton: "[data-pencil-banner-play-button]"
  };

  var dataAttr = {
    transitionDelay: "pencil-banner-transition-delay"
  };

  var classes = {
    hasHover: "has-hover" //class applied to the pencil banner to keep it from animating
  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);
    this.delay = Number(this.$container.data(dataAttr.transitionDelay)) * 1000;
    this.isRunning = false;

    this.name = "pencilBanner";
    this.namespace = "." + this.name;

    this.events = {
      SHOW: "show" + this.namespace,
      CLOSE: "close" + this.namespace
    };

    this.$pencilBannerPanels = $(selectors.pencilBannerPanel, this.$container); //get panels, to check if there are multiples
    this.$pencilBannerTimers = this.$pencilBannerPanels.filter(
      selectors.pencilBannerTimer
    );
    this.$pencilBannerPlayButton = $(selectors.pencilBannerPlayButton, this.$container);

    // Set event handler to remove panel when a timer emits the 'ended' event
    if (this.$pencilBannerTimers && this.$pencilBannerTimers.length) {
      this.$pencilBannerTimers.on("ended.timer", this.onTimerEnd.bind(this));
    }

    this.init();
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {
    //initialization method
    init: function() {
      //if there are multiple panels, begin the animation between them
      if (this.$pencilBannerPanels.length > 1) {
        this.activePanel = 0; //activePanel property keeps track of which panel is currently displayed.
        this.numberOfPanels = this.$pencilBannerPanels.length; //number of total panels

        if(!this.isRunning)
          this.onPlayButton();
        // this.$container.on("mouseover", this.onMouseover.bind(this)); //bind event handlers for mouse interaction
        // this.$container.on("mouseout", this.onMouseout.bind(this));
        this.$pencilBannerPlayButton.on('click', this.onPlayButton.bind(this));
      }

      if (!$(selectors.pencilBannerPanel).length) {
        $("body").addClass("no-pencil-banner");
      }
    },

    //Method to begin the transitions between multiple pencil banner messages
    startAnimation: function() {
      var self = this;

      this.animationInterval = setInterval(function() {
        requestAnimationFrame(self.showNextPanel.bind(self));
      }, this.delay);
    },

    //Stops the animation by clearing the interval
    stopAnimation: function() {
      clearInterval(this.animationInterval);
    },

    //Method to get the next banner panel to show, or loop back to the first.
    showNextPanel: function() {
      //if the pencil banner doesnt have hover...
      if (!this.hasHover) {
        var nextPanel =
          this.activePanel + 1 >= this.numberOfPanels
            ? 0
            : this.activePanel + 1;
        this.activePanel = nextPanel;

        $(this.$pencilBannerPanels[nextPanel])
          .show()
          .siblings(selectors.pencilBannerPanel)
          .hide(); //show given index, hide all siblings
      }
    },

    onMouseover: function() {
      this.hasHover = true; //stops animation from continuing while pencil banner has hover
    },

    onMouseout: function() {
      this.hasHover = false;
    },

    onPlayButton: function() {
      this.isRunning = !this.isRunning;
      if(this.isRunning) {
        this.$pencilBannerPlayButton.addClass('pencil-banner__button--pressed');
        this.startAnimation();
      }
      else {
        this.$pencilBannerPlayButton.removeClass('pencil-banner__button--pressed');
        this.stopAnimation();
      }
    },

    onTimerEnd: function(e) {
      this.removePanel($(e.currentTarget));
    },

    removePanel: function($el) {
      $el.remove(); //remove the panel
      this.numberOfPanels--;

      if (this.numberOfPanels <= 0) {
        this.close();
        $("body").addClass("no-pencil-banner");
      }
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to close the banner
     */
    close: function() {
      $window.trigger($.Event(this.events.CLOSE));
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.close();
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to show the banner
     */
    show: function() {
      $window.trigger($.Event(this.events.SHOW));
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log("[" + this.name + "] - section:select");
      //reinit timers

      $(selectors.timers, this.$container).each(function(i, el) {
        new slate.models.Timer($(el));
      });
    },

    onShow: function() {
      console.log("[" + this.name + "] - section:show");
    },

    onLoad: function() {
      console.log("[" + this.name + "] - section::load");
    },

    onUnload: function() {
      console.log("[" + this.name + "] - section::unload");
    },

    onBlockSelect: function(e) {
      console.log("[" + this.name + "] - section::block::select");
      //Stop animation
      this.stopAnimation();
      this.$pencilBannerPanels.hide();
      $(e.target).show();
    },

    onBlockDeselect: function(e) {
      console.log("[" + this.name + "] - section::block::deselect");
      //resume animation
      this.startAnimation();
    }
  });

  return PencilBanner;
})(jQuery);

/**
 * Subscription Slideup Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.utils
 *  - slate.user
 *  - slate.models.Slideup
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionSlideup
 */

theme.SubscriptionSlideup = (function($, slate) {

  var selectors = {
    slideup: '[data-subscription-slideup]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]',
    subscribeForm: '[data-subscription-slideup-form]',
    formSubmitted: '[data-form-submitted-successfully]', //data selector present when form is submitted
    subscribeFormInitialFocus: '[data-subscribe-slideup-initial-focus]'
  };

  var classes = {
    showMessage: 'show-message'
  };

  var $body = $('body');

  /**
   * Subscription Slideup section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionSlideup(container) {
    this.$container = $(container);

    this.name = 'subscriptionSlideup';
    this.namespace = '.'+this.name;

    this.settings = {
      enabled        : this.$container.data('enabled'),
      delay          : !isNaN(parseInt( this.$container.data('delay')) ) ? (parseInt( this.$container.data('delay') )*1000) : 3000, // delay before showing the modal on pageload,
      seenExpiration : !isNaN(parseInt( this.$container.data('seen-expiration')) ) ? parseInt( this.$container.data('seen-expiration') ) : 30 // days before showing the modal again
    };

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)
    if(this.settings.seenExpiration == 0) {
      this.settings.seenExpiration = 365;
    }

    // DOM elements we'll need
    this.$el          = $(selectors.slideup, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);

    this.slideup = new slate.models.Slideup(this.$el);

    // Hook up the form to an ESP here
    this.$subscribeForm = $(selectors.subscribeForm, this.$container);

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the slideup
     */
    this.cookies = {};

    this.cookies.seen = slate.user.generateCookie('subscriptionSlideupSeen');
    this.cookies.seen.value = slate.utils.hashFromString(this.$el.text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = this.settings.seenExpiration;

    this.cookies.emailCollected = slate.user.generateCookie('emailCollected');
    this.cookies.emailCollected.expiration = this.settings.seenExpiration;

    //This data attribute is added via the form_posted_successfully liquid variable in the markup, so its presence confirms the form was submitted.
    var formSubmittedSuccessfully = $( selectors.formSubmitted, this.$container ).length ? true : false;

    /**
     * Attach event handlers
     */
    this.$el.on('hide.slideup',   this.onHide.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));

    //Fire the onSubscribeSuccess after the slideup is shown to set the emailCollected cookie and prevent the slideup from being seen again
    if ( formSubmittedSuccessfully ) {
      this.$el.on('show.slideup',   this.onSubscribeSuccess.bind(this));
    }

    /**
     * Checks the show logic and displays the popup if everything checks out
     */
    if(this.shouldShow()) {
      setTimeout(function(){
        this.slideup.show();
        $(selectors.subscribeFormInitialFocus).focus();
      }.bind(this), this.settings.delay);
    }

  }

  SubscriptionSlideup.prototype = $.extend({}, SubscriptionSlideup.prototype, {

    /**
     * Resets everything to it's initial state.  Only call when slideup isn't visible.
     */
    reset: function() {
      this.$formContent.find('input[type="email"]').val('');
      this.$formMessage.html('');
      this.$formContent.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }
    },

    onSubmitFail: function() {
      this.$formMessage.html( this.$formMessage.data('message-fail') );
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function(){
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    shouldShow: function() {

      // Checks should be done in this order!

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }

      if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false;
      }

      if ($body.attr('id') == 'challenge' ) { //dont show slideup on challenge page
        return false;
      }

      return true;
    },

    onHide: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    onHidden: function() {
      this.reset();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.slideup.show();
    },

    onDeselect: function() {
      this.slideup.hide();
    }
  });

  return SubscriptionSlideup;
})(jQuery, slate);

/**
 * Subscription Modal Section Script
 * ------------------------------------------------------------------------------
 * 
 * Requires:
 *  - slate.utils
 *  - slate.user
 *  - $.modal (bootstrap modal)
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionModal
 */

theme.SubscriptionModal = (function($, slate) {

    var selectors = {
      modal: '[data-subscription-modal]',
      form: '[data-subscription-modal-form]',
      emailInput: '[data-subscription-modal-form] input[type="email"]',
      subscribeModalText: '[data-subscribe-modal-text]',
      successMessage: '[data-subscription-modal-success]',
      formSubmitted: '[data-form-submitted-successfully]' //data selector present when form is submitted
    };
  
    var classes = {
  
    };
  
    var $body = $('body');

    /**
     * Subscription Modal section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function SubscriptionModal(container) {
      this.$container = $(container);
  
      this.name = 'subscriptionModal';
      this.namespace = '.'+this.name;
  
      this.settings = {
        enabled        : this.$container.data('enabled'),
        delay          : !isNaN(parseInt( this.$container.data('delay') )) ? (parseInt( this.$container.data('delay') )*1000) : 3000, // delay before showing the modal on pageload,
        seenExpiration : !isNaN(parseInt( this.$container.data('seen-expiration') )) ? parseInt( this.$container.data('seen-expiration') ) : 30 // days before showing the modal again
      };
  
      // if seenExpiration is set to 0, set it to 1 year (very far into the future)
      if(this.settings.seenExpiration == 0) {
        this.settings.seenExpiration = 365;
      }
  
      // DOM elements we'll need
      this.$modal          = $(selectors.modal, this.$container);
      this.$form           = $(selectors.form, this.$container);
      this.$successMessage = $(selectors.successMessage, this.$container);
      this.$subscribeText  = $(selectors.subscribeModalText, this.$container);

      /**
       * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the popup
       */
      this.cookies = {};
  
      this.cookies.seen = slate.user.generateCookie('subscriptionModalSeen');
      this.cookies.seen.value = slate.utils.hashFromString(this.$modal.text()).toString(); // Set the cookie value based on the content
      this.cookies.seen.expiration = this.settings.seenExpiration;
  
      this.cookies.emailCollected = slate.user.generateCookie('emailCollected');
      this.cookies.emailCollected.expiration = this.settings.seenExpiration;


      //This data attribute is added via the form_posted_successfully liquid variable in the markup, so its presence confirms the form was submitted.
      var formSubmittedSuccessfully = $( selectors.formSubmitted, this.$container ).length ? true : false;
      /**
       * Attach event handlers
       */

      this.$modal.on('hidden.bs.modal', this.onHidden.bind(this));
      // $(selectors.form, this.$modal).on('submit', this.onFormSubmit.bind(this));

      if ( formSubmittedSuccessfully ) {
        this.$modal.on('shown.bs.modal', this.onSubscribeSuccess.bind(this));
      } else {
        this.$modal.on('shown.bs.modal', this.onShown.bind(this));
      }

      /**
       * Checks the show logic and displays the popup if everything checks out
       */
      if(this.shouldShow()) {
        setTimeout(this.show.bind(this), this.settings.delay);
      }
  
    }
  
    SubscriptionModal.prototype = $.extend({}, SubscriptionModal.prototype, {
      reset: function() {
        this.$formContent.find('input[type="email"]').val('');
        this.$formMessage.html('');
        this.$formContent.removeClass(classes.showMessage);
      },
  
      onSubscribeSuccess: function() {
        this.$successMessage.show();
        this.$subscribeText.hide();
        this.$form.hide();
        if(!slate.utils.isThemeEditor()) {
          slate.user.setCookie(this.cookies.emailCollected);
        }
      },
  
      onSubmitFail: function() {
        this.$formMessage.html( this.$formMessage.data('message-fail') );
        this.$formContent.addClass(classes.showMessage);
        setTimeout(function(){
          this.$formContent.removeClass(classes.showMessage);
        }.bind(this), 5000);
      },
  
      onFormSubmit: function(e) {       
         
        // e.preventDefault();
        // this.onFormSuccess();
        // setTimeout(this.hide , 3000);

        console.log('['+this.name+'] - onFormSubmit');
      },

      onFormSuccess: function() {
        this.$successMessage.show();
        this.$subscribeText.hide();
        this.$form.hide();
      },
      
      hide: function() {
        $(selectors.modal, this.$container).modal('hide');
        if(!slate.utils.isThemeEditor()) {
          slate.user.setCookie(this.cookies.seen);
        }      
      },
  
      show: function() {
        $(selectors.modal, this.$container).modal('show');
      },
  
      shouldShow: function() {
  
        // Checks should be done in this order!
  
        if(slate.utils.isThemeEditor() || !this.settings.enabled) {
          return false;
        }
  
        if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
          return false;
        }      
  
        if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
          return false;
        }

        if ($body.attr('id') == 'challenge' ) { //dont show slideup on challenge page
          return false;
        }

        return true;
      },
  
      onShown: function() {
        // $(selectors.emailInput).focus();
      },
  
      onHidden: function() {
        if(!slate.utils.isThemeEditor()) {
          slate.user.setCookie(this.cookies.seen);
        }
      },
  
      /**
       * Theme Editor section events below
       */
      onSelect: function() {
        this.show();
      },
  
      onDeselect: function() {
        this.hide();
      },
  
      onUnload: function() {
        $('.modal-backdrop').remove();
      }
    });
  
    return SubscriptionModal;
  })(jQuery, slate);
/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 * 
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - instagramFeed
 */

theme.InstagramFeed = (function($, Instafeed) {

  var selectors = {
    target: '[data-instagram-feed-target]',
    template: 'script[data-instagram-media-template]'
  };

  var classes = {

  };

  /**
   * Instagram Feed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InstagramFeed(container) {
    this.$container = $(container);

    this.name = 'instagramFeed';
    this.namespace = '.'+this.name;

    this.$target = $(selectors.target, this.$container);

    // Compile this once during initialization
    this.template = Handlebars.compile($(selectors.template).html());    

    this.settings = {
      accessToken: this.$container.attr('data-access-token'),
      get: 'user',
      mock: true,
      success: this.onInstafeedMockSuccess.bind(this),
      limit: this.$container.attr('data-limit') || 8
    };

    if(!this.settings.accessToken) {
      console.warn('[InstagramFeed] - An access token is required to interact with the Instagram API');
      return;
    }

    this.init();
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {

    /**
     * Kick off the network requests.  Retrieve the user profile from the API and then fire up the feed.
     *
     */
    init: function() {
      $.ajax({
        type: 'GET',
        url: 'https://api.instagram.com/v1/users/self?access_token=' + this.settings.accessToken,
        dataType: 'jsonp'
      })
      .then(function(response){
        
        // Handle invalid response
        if(response.meta.hasOwnProperty('error_message')){
          console.warn('['+this.name+'] - ' + response.meta.error_message);
          return;
        }

        this.settings.userId = response.data.id;

        /*
         *  Use this space to make any adjustments to the section now that you have access to the user profile object
         */

        this.feed = new Instafeed(this.settings);
        this.feed.run();
      }.bind(this));
    },

  /**
   * Callback that runs after Instafeed.run() if the 'mock' setting is set to true
   * Use this function to sort through images, select proper resolution, and construct a gallery of images to insert into the DOM
   *
   * @param {Object} feed - object returned from Instagram API
   * @param {Array} feed.data - Array of feed data objects containing images + info
   */
    onInstafeedMockSuccess: function(feed) {
      
      var self = this;

      feed.data.forEach(function(photo){

        var data = {
          url: photo.link,
          src: photo.images && photo.images.standard_resolution && photo.images.standard_resolution.url,
          caption: photo.caption && photo.caption.text || ''
        };

        self.$target.append(self.template(data));
      });

    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return InstagramFeed;
})(jQuery, Instafeed);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
      speed: 100,
      infinite: true,
      cssEase: 'linear',
      swipeToSlide: true,
      slidesToScroll: 1,
      touchThreshold: 32,
      waitForAnimate: false
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    header: '[data-header]',
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
    dropdownButton: '[data-dropdown-button]',
    search: '[data-search]',
    searchOpen: '[data-search-open]',
    searchClose: '[data-search-close]',
    searchInput: '[data-search-input]',
  };

  var classes = {
    headerFixed: 'is-fixed',
    siteHasFixedHeader: 'site-fixed-header',
    searchActive: 'search-is-active'
  };

  function Header(container) {

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.name = 'header';
    this.namespace = '.'+this.name;
    this.dropdownManager = new slate.models.DropdownManager();

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    // Register each dropdown trigger
    $(selectors.dropdownTrigger, this.$container).each(function(i, trigger) {
      var dd = _this.dropdownManager.register( $(trigger) );

      $(selectors.dropdownButton, trigger).each(function(i, btn) {
        $(btn).keydown(function(e) {
          if(e.which != 13) return true;
          e.preventDefault();
          if(dd.isOpen()) {
            _this.dropdownManager.closeDropdown(dd);
          }
          else {
            _this.dropdownManager.openDropdown(dd);
          }
        });
      });
    });

    $(document.body).on('dropdown:open dropdown:close', function(e) {
      if(!e.detail) return true;
      var $trigger = $(e.detail.trigger);
      $trigger.find(selectors.dropdownButton).attr('aria-expanded', (e.type === 'dropdown:open' ? "true" : "false"));
    });

    this.$container.on('pointerenter mouseenter', this.onMouseEnter.bind(this));
    this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this));

    this.$container.on('keydown', selectors.search, this.onSearchKeyDown.bind(this));
    this.$container.on('click',   selectors.searchOpen, this.onSearchOpenClick.bind(this));
    this.$container.on('click',   selectors.searchClose, this.onSearchCloseClick.bind(this));

    // We pass in the fixed behavior as a class on the body of the site
    if($body.hasClass(classes.siteHasFixedHeader)) {
      $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
      this.onScroll(); // hit this one time on init to make sure everything is good
    }

    // On the search page, pop open the search functionality if there are no results
    if($body.hasClass('template-search') && $('.product-grid__item').length==0 && $('.content-grid__item').length==0) {
      this.openSearch();
    }
  }

  Header.prototype = $.extend({}, Header.prototype, {

    scrollCheck: function() {
      // Do measurements outside of rAF.
      var scrollTop = $window.scrollTop();
      var actualOffset = this.$container.offset()['top'] - this.$el.outerHeight();

      // Do DOM updates inside.
      requestAnimationFrame(function() {
        if( scrollTop < actualOffset ){
          this.$el.removeClass( classes.headerFixed );
        }
        else {
          this.$el.addClass( classes.headerFixed );
        }
      }.bind(this));
    },

    onScroll: function() {
      //this.scrollCheck();
    },

    onMouseEnter: function() {

    },

    onMouseLeave: function() {
      this.dropdownManager.closeAllDropdowns();
    },

    //Search methods
    onSearchKeyDown: function(e) {
      if(e.which == 27) { // esc key
        this.closeSearch();
        // return focus?
      }
    },

    onSearchOpenClick: function(e) {
      e.preventDefault();
      this.openSearch();
    },

    onSearchCloseClick: function(e) {
      e.preventDefault();
      this.closeSearch();
    },

    openSearch: function() {
      this.$container.addClass(classes.searchActive);
      $(selectors.searchInput, this.$container).first().focus();
    },

    closeSearch: function() {
      $(this.$container).removeClass(classes.searchActive);
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceOpen();
      }
    },

    onBlockDeselect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceClose();
      }
    }
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var selectors = {
    subscribeForm : '[data-footer-subscribe]',
    subscribeFormInput : '[data-footer-subscribe-input]',
    subscribeFormSuccessMessage : "[data-footer-subscribe-success]"
  };

  var classes = {
    formSubmitted: "form-submitted"
  };

  function Footer(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    //////////////////////////////////////////////////////
    //IMPORTANT:  Currently not tied to any mail service.
    //TODO: Tie to whatever mail list app the client uses.
    //////////////////////////////////////////////////////
    this.$subscribeForm = $( selectors.subscribeForm, this.$container );
    this.$subscribeFormInput = $( selectors.subscribeFormInput, this.$container );
    this.$subscribeFormSuccessMessage = $( selectors.subscribeFormSuccessMessage, this.$container );

    this.cookies = {};
    this.cookies.emailCollected = slate.user.generateCookie('emailCollected');

    this.$subscribeForm.on( 'submit', this.onSubscribeSubmit.bind(this) );


  }

  Footer.prototype = $.extend({}, Footer.prototype, {

    onSubscribeSubmit: function(e) {
      //method to handle submission of the footer subscribe form.
      this.$subscribeForm.addClass( classes.formSubmitted ); //add class to make message appear
      slate.user.setCookie(this.cookies.emailCollected); //set cookie to prevent subscribe slideup from appearing.
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return Footer;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      var ajaxCart = this.ajaxCart.init(); //initialize ajax cart

      //Extend AjaxCart with the exposed form manipulation methods
      slate.AjaxCart.refreshForms = ajaxCart.refreshForms;
      slate.AjaxCart.ajaxifyForm = ajaxCart.ajaxifyForm;
      window.findifyAjaxCart = {
        refreshForms : ajaxCart.refreshForms,
        ajaxifyForm : ajaxCart.ajaxifyForm
      }
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cart
 */

theme.Cart = (function($) {

  var selectors = {
    form: '[data-cart-form]',
    itemQtySelect: '[data-item-quantity-select]',
    cartFooter: '[data-cart-footer]',
    cartJson: '[data-cart-json]',
    lineItem: '[data-line-item]',
    bundleProduct: '[data-bundle-product]'
  };

  var classes = {
    footerIsFixed : "is-fixed"
  };

  var dataAttr = {
    bundleId: 'bundle-product',
    lineItemIndex: 'line-item'
  };

  function Cart(container) {
    var self = this;

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    this.cart = JSON.parse($(selectors.cartJson, this.$container).html());

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.$window = $(window);

    var $form = $(selectors.form, this.$container);

    // Since we have more than 1 quantity select per row (1 for mobile, 1 for desktop)
    // We need to use single input per row, which is responsible for sending the form data for that line item
    // Watch for changes on the quantity selects, and then update the input.  These two are tied together using a data attribute
    this.$container.on('change', selectors.itemQtySelect, this.onQuantityChange.bind(this));

    this.breakpointMin = slate.breakpoints.getBreakpointMinWidth('sm'); //break the scrolling at the medium breakpoint.
    this.belowBreakpoint = false;

    this.$footer = $( selectors.cartFooter, this.$container );

    //Check if footer exists before calling this, since the footer is hidden when there are no items in the cart.
    if ( this.$footer.length ) {
      this.footerIsFixed = false; //boolean to keep track of whether the footer is fixed.

      this.$footerPlaceholder = $('<div class="footer-placeholder"></div>');
      this.$footerPlaceholder.css({
        width : "100px",
        height: this.$footer.outerHeight(true),
        display: "none"
      });

      this.$footerPlaceholder.insertAfter( this.$footer );

      this.$window.on('resize', $.throttle(50, this.handleResizeForFooter.bind(this)));

      this.handleResizeForFooter();
    }

    //Update all quantity adjusters to respect the maximums calculated in the cart.json


    //Update free gifts once on load.  Because we can't include sections in sections, we have to ajax the cart json response.
    ShopifyAPI.getCart().then(this.updateFreeGifts.bind(this));
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    onQuantityChange: function(e){
      var $target = $(e.currentTarget);
      var isBundleProduct = $target.parents( selectors.bundleProduct ).length; //check if there's a [data-bundle-product] parent.

      var $itemQtyInput = $('[id="' + $target.data('item-quantity-select') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select

      $itemQtyInput.val( $target.val() );

      var newQty = $target.val();

      if (isBundleProduct) {
        var bundleId = $target.parents( selectors.bundleProduct ).data( dataAttr.bundleId ); //get the id of the bundle

        var lineItems = this.cart.items;

        //Updated quantities for each lineitem
        var updatedQuantities = [];

        //Loop over items, compose array of quantities
        var quantities = [];

        for (var i = 0; i < lineItems.length; i++) {
          var lineItem = lineItems[i];

          //If the lineitem's product id matches the bundle id, it's the parent product
          //If the lineitem's _bundle_id matches the bundleId, it's a child product

          if(lineItem.variant_id == Number(bundleId) || lineItem.properties['_bundle_id'] == bundleId) {
            quantities.push(newQty); //push the updated qty of the parent to all children
          } else {
            quantities.push(Number(lineItem.quantity)); //keep the other item quantities the same
          }
        }

        //update quantities, update free gifts, reload.
        this.updateQuantities(quantities)
          .then(this.updateFreeGifts)
          .then(function(){
            window.location.reload();
          });

      } else {
        //This is the normal behavior the cart form submission
        //$(selectors.form, this.$container).submit();

        //Because we're not rendering out Bundle Children, the normal form is invalid.  Instead, use the API to update based on lineitem index.
        var lineItemIndex = Number( $target.parents(selectors.lineItem).data( dataAttr.lineItemIndex ));
        this.changeItemQuantity(lineItemIndex, newQty)
          .then(function(){
            window.location.reload();
          });
      }

    },

    changeItemQuantity: function(lineItemIndex, qty) {
      return $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/change.js',
        data: {
          line: lineItemIndex,
          quantity: qty
        }
      });
    },


    updateQuantities: function(arrayOfQuantities){
      var promise = $.Deferred();

      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: {updates: arrayOfQuantities }
      }).then(function(){
        ShopifyAPI.getCartAndVerifyQuantities().then(function(cart){
          promise.resolve(cart);
        });
      });

      return promise;
    },


    /*
    * Method to update free gifts.  Slightly modified version of the ajaxCart's version.
    *
    * @param cart {obj} - a JSON representation of the cart.  Returns a promise
    */

    updateFreeGifts: function(cart) {
      if (!cart.gwp) {
        return; //gwp property doesn't exist if no products are in the GWP collection, so we can safely bail.
      }


      var promise = $.Deferred();

      var lineItems = cart.items;
      var gwp = cart.gwp;

      var outdatedGifts = []; //array to hold any GWP items currently in the cart.  When we loop throught he GWP array, we remove items we find.  If we have any left over, they need to be removed.
      var giftsToAdd = []; //array to hold GWP product information (variant ID + lineitem props) that we need to add.
      var giftsToRemove = []; //array to hold the lineitem indexes of gifts we need to remove.
      //var giftsToAddWithVariants = []; //unused atm

      //Step 1: Check for any gifts in the cart.  If they've since been removed from the GWP, collection, we'll need to remove them.
      for (var i = 0; i < lineItems.length; i++) {
        var item = lineItems[i];
        if ( item.is_gwp ) {
          //if the lineitem is a GWP, push it to the giftsincart array, with its index matching that of its lineitem index in shopify.
          outdatedGifts[item.lineitem_index] = item.id;
        }
      }

      //Step 2: Loop through the GWP array returned with the cart JSON, to get a full concept of the GWP's available on the site
      for (var j = 0; j < gwp.length; j++) {
        var freeGift = gwp[j];
        if (!freeGift.available) {
          continue; //skip free gifts that aren't available
        }

        //For each GWP, we remove them from the outdatedGifts array if they're still present.
        var giftInCartIndex = outdatedGifts.indexOf(freeGift.id);
        if (giftInCartIndex > -1){
          outdatedGifts.splice(giftInCartIndex, 1);
        }

        if (freeGift.requirements_met && !freeGift.in_cart) {
          //The user's cart is eligible for the gift, but gift is not present in cart...

          //The eligible gift does not have variants, so we can auto-add it!
          var giftToAdd = {
            gwp_id : freeGift.id,
            variant_id : freeGift.variant_id
          };

          //Lineitem props to be added with the item.
          giftToAdd.requires = freeGift.requires;
          giftToAdd.requires_details = freeGift.requires_details;
          giftToAdd.requires_msg = freeGift.requires_msg;

          if (freeGift.non_combinable_w_discount) {
            giftToAdd.non_combinable = true;
            giftToAdd.non_combinable_msg = freeGift.non_combinable_msg;
          }

          //Push the gift to the array of GWP we'll need to add.
          giftsToAdd.push(giftToAdd);
        } else if (!freeGift.requirements_met && freeGift.in_cart) {
          //Gift is in cart, but requirements are no longer met. Mark for removal.
          giftsToRemove.push(freeGift.lineitem_index);
        }
      }

      //If we have any gifts left over in the outdatedGifts array, they've been removed from the GWP
      //since the user last modified their cart, so we also need to remove them!
      $.each(outdatedGifts, function(i, el){
        if (el !== undefined) {
          giftsToRemove.push(i); //the elements are pushed to outdatedGifts at the index == to their lineitem index, so we push the index to remove.
        }
      });

      //Function to update the next gift
      var updateNext = function(){
        if (giftsToAdd.length){
          //add item, shift the giftsToAdd array
          var giftToAdd = giftsToAdd[0];
          var giftToAddId = giftToAdd.variant_id;
          var giftToAddProps = {
            "_gwp_id": giftToAdd.gwp_id,
            "_gwp_requires": giftToAdd.requires,
            "_gwp_details": giftToAdd.requires_details,
            "Free Gift": giftToAdd.requires_msg //message that display in checkout
          };

          if (giftToAdd.non_combinable) {
            giftToAddProps["Not Combinable"] = giftToAdd.non_combinable_msg;
          }

          ShopifyAPI.addItemToCart(giftToAddId, 1, giftToAddProps)
            .then(function(){
              giftsToAdd.shift();
              updateNext();
            });

        } else if (giftsToRemove){
          //Because the lineitem indexes would change if we did these one at a time, we instead use the change.js's array feature to update all quantities at once, but first we have to get the current state of the cart.
          ShopifyAPI.getCart().then(function(cart){
            var quantities = [];
            for (var i = 0; i < cart.items.length; i++) {
              if (giftsToRemove.indexOf(i+1) > -1) {
                quantities.push(0);
              } else {
                quantities.push(cart.items[i].quantity);
              }
            }

            giftsToRemove = false;

            ShopifyAPI.changeItemQuantities(quantities)
              .then(function(){
                updateNext();
              });
          });

        } else {
          //We're done, resolve the promise and reload the page if you want.
          ShopifyAPI.getCart().then(function(cart){
            window.location.reload();
          });
        }
      };

      //If there are no gift changes, resolve with the cart data we originally fetched in this method.
      if (giftsToAdd.length == 0 && giftsToRemove.length == 0){
        promise.resolve(cart);
      } else {
        //If there are, we instead kick off the gift updating above by calling updateNext once.
        updateNext();
      }

      return promise;
    },

    handleResizeForFooter: function() {
      //If the viewport exceeds the width of the bp (small, at this point), unfix the footer.  If it shrinks below, fire the scroll event to determine if it should be fixed.  Bind the onscroll event handler
      var $window = this.$window;

      this.$footerPlaceholder.css('height', this.$footer.outerHeight(true)); //sync heights of the placeholder to the actual footer

      if ($window.innerWidth() < this.breakpointMin && !this.belowBreakpoint) {
        //Viewport is below breakpoint
        $window.on(this.events.SCROLL, $.throttle(25, this.handleScrollForFooter.bind(this)));
        this.handleScrollForFooter();
        this.belowBreakpoint = true;

      } else if ($window.innerWidth() >= this.breakpointMin && this.belowBreakpoint) {
        //Viewport is over breakpoint, remove evt handler and unstick footer.
        $window.off(this.events.SCROLL);
        this.unfixFooter();
        this.belowBreakpoint = false;
      }

    },

    handleScrollForFooter: function(){
      var scrollDist = $(document).scrollTop();
      var windowHeight = this.$window.innerHeight();

      if (scrollDist + windowHeight - this.$footer.outerHeight() >= this.$footerPlaceholder.offset().top && this.footerIsFixed) {
        this.unfixFooter();
      } else if (scrollDist + windowHeight - this.$footer.outerHeight() < this.$footer.offset().top && !this.footerIsFixed) {
        this.fixFooter();
      }
    },

    fixFooter : function() {
      //create a placeholder dom element, place it next to the footer, then grab the footer and fix it to the bottom of the viewport.
      this.$footer.addClass( classes.footerIsFixed );
      this.$footerPlaceholder.show();
      this.footerIsFixed = true;
    },

    unfixFooter : function() {
      //remove placeholder dom element, place footer back in position.
      this.$footer.removeClass( classes.footerIsFixed );
      this.$footerPlaceholder.hide();
      this.footerIsFixed = false;
    }
  });

  return Cart;
})(jQuery);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($) {

  var $window = $(window);

  var selectors = {
    toggle: '[data-mobile-menu-toggle]',
    menu: '[data-mobile-menu]',
    menuList: '[data-mobile-menu] .mobile-menu',
    menuItem: '[data-mobile-menu-item]',
    menuItemWithSubmenu : '[data-mobile-menu-has-submenu]',
    closeButton : '[data-mobile-menu] [data-drawer-close]',
    closeSubmenuButton : '[data-mobile-menu-submenu-close-btn]'
  };

  var classes = {
    menuHasSubmenuOpen: "submenu-is-shown", //class that gets applied to the given selectors.menu when a submenu is visible.
    submenuIsActive : "is-shown", //class applied to a given submenu
    menuItemIsActive: "is-active", //active menu items (has its submenu visible)
    menuItemIsInactive: "is-inactive" //class applied to sibling menu items that disappear while a given submenu is shown
  };

  function MobileMenu(container) {
    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.'+this.name;

    this.events = {
      "CLOSE" : 'hidden'
    };

    this.$el     = $(selectors.menu, this.$container);
    this.$toggle = $(selectors.toggle); // Don't scope to this.$container
    this.$menu = $(selectors.menu, this.$container);
    this.$menuList = $( selectors.menuList, this.$container );
    this.$menuItems = $(selectors.menuItem, this.$container);
    this.$menuItemsWithSubmenu = $(selectors.menuItemWithSubmenu, this.$container);

    this.$closeButton = $(selectors.closeButton, this.$container);
    this.$submenuCloseButton = $(selectors.closeSubmenuButton, this.$container);

    this.drawer  = new slate.models.Drawer(this.$el);

    this.$toggle.on('click', this.onToggleClick.bind(this));

    //When the menu is hidden, reset it.
    this.$el.on('hidden.drawer', this.resetMenu.bind(this));

    this.$el.on('shown.drawer', this.onShownDrawer.bind(this));
    this.$el.on('hidden.drawer', this.onHiddenDrawer.bind(this));

    this.$el.on('show.drawer', this.onShowDrawer.bind(this));

    //bind click handler to menu items with submenus. This method handles the opening/closing of submenus.
    this.$menuItemsWithSubmenu.on('click', this.onMenuItemClick.bind(this));

    this.$submenuCloseButton.on('click', this.onSubmenuCloseBtnClick.bind(this));


  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {

    onToggleClick: function(e) {
      e.preventDefault();
      this.drawer.toggle();
    },

    onMenuItemClick: function(e) {
      var menuItem = $(e.delegateTarget);
      var subMenu = menuItem.siblings('ul.mobile-menu__submenu').eq(0); //get first submenu ul
      var parentListItem = menuItem.parent('li');

      if (!menuItem.hasClass( classes.menuItemIsActive )){
        e.preventDefault();
        parentListItem.addClass( classes.menuItemIsActive );
        parentListItem.siblings('li').addClass( classes.menuItemIsInactive );
        this.showSubmenu( subMenu );
        menuItem.attr('aria-expanded', true);
      }
    },

    showSubmenu: function($subMenu){
      var self = this;
      this.$menu.addClass( classes.menuHasSubmenuOpen ); //add class to mobile menu element
      this.$activeSubmenu = $subMenu; //set a property on the menu obj to keep track of which submenu is active
      $subMenu.show({
        complete: self.scrollToTop.bind(self)
      });
    },

    hideSubmenu: function(){
      if ( this.$activeSubmenu ) {
        this.$activeSubmenu.removeClass( classes.submenuIsActive ).hide();
        this.$activeSubmenu = null;
        this.$menu.removeClass( classes.menuHasSubmenuOpen );
        this.$menuItems.removeClass( classes.menuItemIsActive + " " + classes.menuItemIsInactive ); //remove active/inactive classes from all menu items
        this.$menuItemsWithSubmenu.attr('aria-expanded', false);
      }
    },

    onSubmenuCloseBtnClick: function(e){
      e.preventDefault();
      this.hideSubmenu();
    },

    scrollToTop: function(){
      this.$el.scrollTop(0); //reset scroll of drawer div.
    },

    //Method to reset mobile menu when drawer is closed.
    resetMenu: function(){
      this.hideSubmenu(); //hide submenu if it's shown
      this.scrollToTop();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.drawer.show();
    },

    onDeselect: function() {
      this.drawer.hide();
    },

    onUnload: function() {
      this.drawer && $('.drawer-backdrop').remove();
    },

    onShownDrawer: function() {
      this._setAriaExpanded(true);
      this.$closeButton.focus();
    },

    onHiddenDrawer: function() {
      this._setAriaExpanded(false);
      this.$toggle.focus();
      this.$el.hide();
    },

    onShowDrawer: function() {
      this.$el.show();
    },

    _setAriaExpanded: function(isExpanded) {
      this.$toggle.attr('aria-expanded', isExpanded);
    },
  });

  return MobileMenu;
})(jQuery);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var selectors = {
    articleItemWrap: '[data-article-item-wrap]',
    articleItem: '[data-article-item]',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
    featuredArticleSlideshow: '[data-article-slideshow]',
    featuredArticleContent: '[data-featured-article-content]',
    dots: '.slick-dots',
    blogFilterLink: '[data-blog-filter-link]', //link that causes new content to be loaded.
    blogArticleContent : '[data-blog-filter-content]' //the content that gets replaced when a filter is selected.

  };

  var classes = {
    activeDots : 'slick-active',
    activeFilter: 'is-active'
  };

  function Blog(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));

    this.$nextPageLink = $( selectors.nextPageLink, this.$container );

    var settings = {
      // Put your settings here
      appendDots: $( selectors.featuredArticleContent ) //move dots to be under the content on *each* slide
    };

    //If the featured articles slideshow exists, init the slideshow, and bind a method to update each slide's dots when the slide changes.
    if ( $(selectors.featuredArticleSlideshow).length > 0 ) {
      this.slideshow = new slate.models.Slideshow( $(selectors.featuredArticleSlideshow, this.$container), settings); //Init featured article slideshow, if selector is found.
      this.$dots = $( selectors.dots, this.$container );

      $( selectors.featuredArticleSlideshow, this.$container ).on('afterChange', this.updateSliderDots.bind(this) );
    }

    this.$blogFilterLinks = $( selectors.blogFilterLink, this.$container );
    this.$blogArticleContent = $( selectors.blogArticleContent, this.$container );

    //If blog filters exist, bind click handlers to show content, and change the load more target url.
    if ( this.$blogFilterLinks.length > 0 ) {
      this.$blogFilterLinks.on('click', this.onFilterClick.bind(this));
    }
  }

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self = this;
      var url  = this.$nextPageLink.attr('href');

      this.$nextPageLink.find('span').html(theme.strings.loading || 'Loading');
      this.loadContent( url );

    },

    loadContent: function(url, emptyOldContent) {
      var self = this;

      if (emptyOldContent) {
        this.$blogArticleContent.addClass('loading-content'); //gray out the old content
      }

      $.ajax({
        url: url
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $( selectors.articleItem, $dom );
        var $newNextPageLink = $( selectors.nextPageLink, $dom );

        if (emptyOldContent) {
          self.$blogArticleContent.empty(); //empty out the old content
          self.$blogArticleContent.removeClass('loading-content');
        }

        $(selectors.articleItemWrap, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $( selectors.pagination, self.$container ).show(); //show, just in case it's hidden.
          self.$nextPageLink.replaceWith( $newNextPageLink );
          self.$nextPageLink = $newNextPageLink; //reset the reference to nextPageLink
        }
        else {
          $( selectors.pagination, self.$container ).hide();
        }
      });
    },

    onFilterClick: function(e) {
      //remove active states, set start on event target, call loadContent.
      e.preventDefault();

      var url = $(e.target).attr('href');

      if ( $( e.target ).hasClass('is-active')) {
        return; //link is already active, return to prevent a needless fetch.
      }

      this.$blogFilterLinks.removeClass('is-active');
      $( e.target ).addClass('is-active');

      this.loadContent(url, true);
    },


    updateSliderDots: function( event, slick, currentSlide ) {
      this.$dots.removeClass( classes.activeDots );

      this.$dots.each( function() {
          $( 'li', $( this ) ).eq( currentSlide ).addClass( classes.activeDots );
      });
    }

  });

  return Blog;
})(jQuery);

/**
 * Triptych Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Triptych
 */

theme.Triptych = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };

  /**
   * Triptych section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Triptych(container) {
    this.$container = $(container);

    this.name = 'triptych';
    this.namespace = '.'+this.name;

    var settings = {
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left arrow--light arrow--small"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right arrow--light arrow--small"><span class="arrow__icon"></span></span></div>',
    };

    //Initialize these each separately so that their data-attributes are considered inidividually
    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container)[0], settings );
    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container)[1], settings );
    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container)[2], settings );
  }

  Triptych.prototype = $.extend({}, Triptych.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return Triptych;
})(jQuery);

/**
 * Testimonials Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Testimonials
 */

theme.Testimonials = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    arrow: '.slick-arrow',
    image: '.testimonial-slide__image'
  };

  var classes = {
  };

  /**
   * Testimonials section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Testimonials(container) {
    this.$container = $(container);

    this.name = 'Testimonials';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    this.W = $window.width();
    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));
    
    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);

    this.onResize();
  }

  Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    },
    onResize: function () {
      var $image = this.slideshow.$slideshow.find(selectors.image).first();
      if ($window.width() >= 992) {
        this.slideshow.$slideshow.find(selectors.arrow).each(function(index, $el) {
          $el.style.top = $image.height() + 'px';
        })
      }
      else {
        this.slideshow.$slideshow.find(selectors.arrow).each(function(index, $el) {
          $el.style.top = null;
        })
      }
    }
  });

  return Testimonials;
})(jQuery);

/**
 * ProductGrid Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - ProductGrid
 */

theme.ProductGrid = (function($) {

  var selectors = {
    slideshow : '[data-slideshow]',
    productGrid: '[data-product-grid]'
  };

  var classes = {

  };

  var $window = $(window);

  /**
   * ProductGrid section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function ProductGrid(container) {
    this.$container = $(container);

    this.name = 'product-grid';
    this.namespace = '.'+this.name;

    this.$productGrid = $( selectors.productGrid, this.$container );

    this.settings = {
      slidestoScroll: 4,
      slidesToShow: 4,
      arrows: false,
      draggable: true,
      dots: true,
      swipe: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 922,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    };

    this.breakpointMin = slate.breakpoints.getBreakpointMinWidth('md'); //Breakpont: change this to cause the behavior to swap at diff. breakpoints.

    if (this.$productGrid.length){
        this.initSlick();
    }
  }

  ProductGrid.prototype = $.extend({}, ProductGrid.prototype, {

    initSlick : function(){
      this.$productGrid.slick( this.settings );
      this.slideshowActive = true;
    },

    destroySlick: function(){
      this.$productGrid.slick('unslick');
      this.slideshowActive = false;
    }
  });

  return ProductGrid;
})(jQuery);

/**
 * Article Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - article
 */

theme.Article = (function($) {

  var selectors = {
    relatedArticlesSlideshow: '[data-related-articles-slideshow]' //slideshow at mobile, content grid when not.

  };

  var classes = {
  };

  var $window = $(window);

  function Article(container) {

    this.$container = $(container);

    this.name = 'article';
    this.namespace = '.'+this.name;

    this.$relatedArticles = $( selectors.relatedArticlesSlideshow );

    this.slideshowActive= false;

    if ( this.$relatedArticles.length ) {
      this.breakpointMin = slate.breakpoints.getBreakpointMinWidth('md'); //Breakpont: change this to cause the behavior to swap at diff. breakpoints.
      this.belowBreakpoint = window.innerWidth < this.breakpointMin ? true : false; //bool to keep track of whether we're under/over

      if (this.belowBreakpoint) {
        this.initSlideshow();
      }

      $window.on( 'resize', $.throttle(25, this.handleResize.bind(this)) ); //bind event handler
    }
  }

  Article.prototype = $.extend({}, Article.prototype, {

    handleResize: function() {
      this.belowBreakpoint = window.innerWidth < this.breakpointMin ? true : false;

      if ( this.belowBreakpoint && !this.slideshowActive ) {
        this.initSlideshow();
      } else if ( !this.belowBreakpoint && this.slideshowActive ) {
        this.destroySlideshow();
      }
    },

    initSlideshow: function() {
      this.$relatedArticles.slick({
        speed: 600,
        dots: true,
        swipe: Modernizr.touchevents,
        arrows: !Modernizr.touchevents,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        accessibility: false,
        draggable: true
      });

      this.slideshowActive = true;
    },

    destroySlideshow: function() {
      this.$relatedArticles.slick( 'unslick' );
      this.slideshowActive = false;
    }


  });

  return Article;
})(jQuery);

/**
 * About Us Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - aboutUs
 */

theme.AboutUs = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    aboutVideo: '[data-video-id]',
    videoPlaceholder: '[data-video-placeholder]'
  };

  var classes = {

  };

  var dataAttr = {
    videoType     : 'video-type',
    videoAutoplay : 'video-autoplay'
  };

  /**
   * Testimonials section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AboutUs(container) {
    this.$container = $(container);

    this.name = 'AboutUs';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    var $aboutVideo = this.$container.find( selectors.aboutVideo ).eq(0);

    //If the panel has a descendant with a video...
    if ( $aboutVideo && $aboutVideo.length > 0 ) {
      var videoPlaceholder = $( selectors.videoPlaceholder, $aboutVideo );
      var autoplayVideo = $aboutVideo.data( dataAttr.videoAutoplay ) !== undefined ? true : false;
      
      if ($aboutVideo.data(dataAttr.videoType) == 'youtube') {
        //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
        $aboutVideo[0].videoPlayer = new slate.models.YouTubePlayer( $aboutVideo );
      } else if ($aboutVideo.data(dataAttr.videoType) == 'vimeo' ) {
        //Configure vimeo options
        var options = {
          autoplay : autoplayVideo
        };
        
        //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
        $aboutVideo.videoPlayer = new slate.models.VimeoPlayer( $aboutVideo, options );
    
      }
    }
    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container));
  }

  AboutUs.prototype = $.extend({}, AboutUs.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return AboutUs;
})(jQuery);

/**
 * Career Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Careers
 */

theme.Careers = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };

  /**
   * Career section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Careers(container) {
    this.$container = $(container);

    this.name = 'Careers';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);
  }

  Careers.prototype = $.extend({}, Careers.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Careers;
})(jQuery);

/**
 * Support Center Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - supportCenter
 */

theme.SupportCenter = (function($) {

  var $window = $(window);

  var selectors = {
    faqCategorySelect : '[data-faq-category-select]',
    faqCategory : '[data-faq-category-id]'
  };

  var classes = {
    categoryIsVisible : 'is-visible'
  };

  /**
   * Support Center section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SupportCenter(container) {
    this.$container = $(container);

    this.name = 'supportCenter';
    this.namespace = '.'+this.name;

    this.$faqCategorySelect = $( selectors.faqCategorySelect, this.$container );

    this.$container.on('change', selectors.faqCategorySelect, this.onSelectChange.bind(this));
    
  }

  SupportCenter.prototype = $.extend({}, SupportCenter.prototype, {
    onSelectChange : function(e){
      var targetCategoryId = $( e.currentTarget ).val();
      var $target = $( targetCategoryId );

      if ( $target.length ){
        $target.siblings( selectors.faqCategory ).hide().removeClass( classes.categoryIsVisible );
        $target.show().addClass( classes.categoryIsVisible );
      }
    }

  });

  return SupportCenter;
})(jQuery);

/**
 * Search Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - search
 */

theme.Search = (function($) {

  var selectors = {
    pagination: '[data-search-pagination]',
    nextPageLink: '[data-search-next-page]',
    searchItem: '[data-search-item-product]',
    searchItemWrap: '[data-search-item-product-wrap]',
    backInStockTrigger: '[data-back-in-stock-trigger]',
    backInStockTriggerInner: '[data-back-in-stock-trigger-inner]',
    focusedElem: '.product-card a'
  };

  function Search(container) {

    this.$container = $(container);

    this.name = 'search';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
    this.$nextPageLink = $( selectors.nextPageLink, this.$container );

    window.wishl = window.wishl || new slate.models.Wishlist(container);
    this.wishl = window.wishl;
    this.wishl.initWishlWrapper();
    //debugger
    window.findifyWishlist = {
      addItem: this.wishl.addItem,
      getAllWishlistItems: this.wishl.getAllWishlistItems
    };
  }

  Search.prototype = $.extend({}, Search.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self = this;
      var url  = this.$nextPageLink.attr('href');

      this.$nextPageLink.html(theme.strings.loading || 'Loading');
      this.loadContent( url );

    },

    loadContent: function(url) {
      var self = this;

      $.ajax({
        url: url
      })
      .done(function( data ) {
        var $dom = $(data);

        // scrape search results from next link page
        var $productItems = $( selectors.searchItem, $dom );

        // inject them into the current page
        $(selectors.searchItemWrap, self.$container).append($productItems);

        // focus the first loaded product
        $productItems.first().find(selectors.focusedElem).focus();

        // refresh link if it exists
        var $newNextPageLink = $( selectors.nextPageLink, $dom );

        if($newNextPageLink.length) {
          $( selectors.pagination, self.$container ).show(); //show, just in case it's hidden.
          self.$nextPageLink.replaceWith($newNextPageLink);
        }
        else {
          $( selectors.pagination, self.$container ).hide();
        }
      });
    }

  });

  return Search;
})(jQuery);

/**
 * Influencer Signup Form Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - InfluencerSignup
 */

theme.InfluencerSignup = (function($) {

  var selectors = {
    signupForm: "[data-influencer-signup-form]",
    signupSuccess: "[data-influencer-signup-success]",
    inputEmail: "[data-influencer-signup-form] input#email",
    inputFirstName: "[data-influencer-signup-form] input#firstname",
    inputLastName: "[data-influencer-signup-form] input#lastname"
  };

  var classes = {
    success: "send-successful",
    hasError: "has-error"
  };

  var $window = $(window);

  /**
   * InfluencerSignup section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InfluencerSignup(container) {
    this.$container = $(container);
    this.$form = $( selectors.signupForm, this.$container );
    this.$successMessage = $( selectors.signupSuccess, this.$container );

    this.name = 'influencer-signup';
    this.namespace = '.'+this.name;

    //Bind Event Handler
    this.$form.on('submit', this.onSubmit.bind(this));


  }

  InfluencerSignup.prototype = $.extend({}, InfluencerSignup.prototype, {
    /*
    * Method to handle form submission
    */
    onSubmit : function(e){
      e.preventDefault();

      if ( typeof window._iaq == "undefined" ) {
        return;
      }

      var self = this;

      var dataFields = {
        "first_name": $(selectors.inputFirstName).val().trim(),
        "last_name": $(selectors.inputLastName).val().trim()
      };

      self.onSubmitSuccess();
    },

    /*
    * Method to handle when the form is successfully submitted
    */
    onSubmitSuccess: function(){
      this.$form.addClass( classes.success );
      this.$successMessage.show();
    },

    /*
    * Method to handle when the form submit fails
    */
    onSubmitFail: function(){
      //
    }

  });

  return InfluencerSignup;
})(jQuery);

/**
 * News Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - news
 */

theme.News = (function($) {

  var selectors = {
    newsItems : '[data-news-items-wrap]',
  };

  var $window = $(window);

  /**
   * News section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function News(container) {
    this.$container = $(container);

    this.name = 'news';
    this.namespace = '.'+this.name;

    this.$newsItems = $( selectors.newsItems, this.$container );

    this.settings = {
      slidestoScroll: 1,
      accessibility: false,
      slidesToShow: 1,
      arrows: false,
      draggable: true,
      dots: true,
      swipe: true,
      swipeToSlide: true
    };

    this.breakpointMin = slate.breakpoints.getBreakpointMinWidth('md'); //Breakpont: change this to cause the behavior to swap at diff. breakpoints.

    if (this.$newsItems.length){
      if ( window.innerWidth < this.breakpointMin ) {
        this.initSlick();
      }

      $window.on('resize', this.handleResize.bind(this) );  //Set resizehandler to check if we're below/above the breakpoint moving forward
    }
  }

  News.prototype = $.extend({}, News.prototype, {
    handleResize : function(){
      if ( window.innerWidth < this.breakpointMin && !this.slideshowActive ) {
        this.initSlick();
      } else if ( window.innerWidth >= this.breakpointMin  && this.slideshowActive ) {
        this.destroySlick();
      }
    },

    initSlick : function(){
      this.$newsItems.slick( this.settings );
      this.slideshowActive = true;
    },

    destroySlick: function(){
      this.$newsItems.slick('unslick');
      this.slideshowActive = false;
    }
  });

  return News;
})(jQuery);

/**
 * Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - banner
 */

theme.Banner = (function($) {
  var $window = $(window);

  var selectors = {
    timers: "[data-countdown-timer]",
    bannerVideo: '[data-video-id]',
    heroVideoInitialized: '[data-video-id].video-initialized',
    videoPlaceholder: '[data-video-id] ~ iframe',
    playButton: '[data-video-play-toggle]',
    audioButton: '[data-video-audio-toggle]',
    bannerVideoDsk: '[data-vimeo-video]',
    bannerVideoMob: '[data-vimeo-video-mobile]'
  };

  var dataAttr = {
    videoType     : 'video-type',
    videoAutoplay : 'video-autoplay'
  };
  
  /**
   * Banner section constructor. Runs on page load as well as Theme Editor  
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Banner(container) {
    this.$container = $(container);

    this.name = "banner";
    this.namespace = "." + this.name;
    //this.timer = new slate.models.Timer();


    var $bannerVideo = this.$container.find( selectors.bannerVideoDsk ).eq(0);
  
    //If the panel has a descendant with a video...
    if ( $bannerVideo && $bannerVideo.length > 0 ) {
      var videoPlaceholder = $( selectors.videoPlaceholder, $bannerVideo );
      var autoplayVideo = $bannerVideo.data( dataAttr.videoAutoplay ) !== undefined ? true : false;

      if ($bannerVideo.data(dataAttr.videoType) == 'youtube') {
        //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
        $bannerVideo[0].videoPlayer = new slate.models.YouTubePlayer( $bannerVideo );
      } else if ($bannerVideo.data(dataAttr.videoType) == 'vimeo' ) {
        //Configure vimeo options
        var options = {
          autoplay : autoplayVideo
        };
        
        //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
        $bannerVideo.videoPlayer = new slate.models.VimeoPlayer( $bannerVideo, options );
      }
    }
    var $bannerVideoMob = this.$container.find( selectors.bannerVideoMob ).eq(0);
  
    //If the panel has a descendant with a video...
    if ( $bannerVideoMob && $bannerVideoMob.length > 0 ) {
      var videoPlaceholder = $( selectors.videoPlaceholder, $bannerVideoMob );
      var autoplayVideo = $bannerVideoMob.data( dataAttr.videoAutoplay ) !== undefined ? true : false;

      if ($bannerVideoMob.data(dataAttr.videoType) == 'youtube') {
        //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
        $bannerVideoMob[0].videoPlayer = new slate.models.YouTubePlayer( $bannerVideoMob );
      } else if ($bannerVideoMob.data(dataAttr.videoType) == 'vimeo' ) {
        //Configure vimeo options
        var options = {
          autoplay : autoplayVideo
        };
        
        //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
        $bannerVideoMob.videoPlayer = new slate.models.VimeoPlayer( $bannerVideoMob, options );
    
      }
    }
  }

  Banner.prototype = $.extend({}, Banner.prototype, {
    onSelect: function() {
      //reinit timer
      $(selectors.timers, this.$container).each(function(i, el) {
        new slate.models.Timer($(el));
      });
    }
  });

  return Banner;
})(jQuery);

/**
 * Collection Hero Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - Collection Hero
 */

theme.CollectionHero = (function($) {
    var $window = $(window);
  
    selectors = {
      timers: "[data-countdown-timer]"
    };
  
    /**
     * Collection Hero section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function CollectionHero(container) {
      this.$container = $(container);
  
      this.name = "collection-hero";
      this.namespace = "." + this.name;
    }
  
    CollectionHero.prototype = $.extend({}, CollectionHero.prototype, {
      onSelect: function() {
        //reinit timer
        $(selectors.timers, this.$container).each(function(i, el) {
          new slate.models.Timer($(el));
        });
      }
    });
  
    return CollectionHero;
  })(jQuery);

  
/**
 * Promo Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the promo section
 * 
 * @namespace - promo
 */

theme.Promo = (function($) {
    var $window = $(window);
  
    var selectors = {
      promoVideo: '[data-video-id]',
      videoPlaceholder: '[data-video-id] ~ iframe'
    };
  
    var dataAttr = {
      videoType     : 'video-type',
      videoAutoplay : 'video-autoplay'
    };
    
    /**
     * Promo section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function Promo(container) {
      this.$container = $(container);
  
      this.name = "promo";
      this.namespace = "." + this.name;

      var $promoVideo = this.$container.find( selectors.promoVideo ).eq(0);
    
      //If the panel has a descendant with a video...
      if ( $promoVideo && $promoVideo.length > 0 ) {
        var videoPlaceholder = $( selectors.videoPlaceholder, $promoVideo );
        var autoplayVideo = $promoVideo.data( dataAttr.videoAutoplay ) !== undefined ? true : false;
  
        if ($promoVideo.data(dataAttr.videoType) == 'youtube') {
          //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
          $promoVideo[0].videoPlayer = new slate.models.YouTubePlayer( $promoVideo );
        } else if ($promoVideo.data(dataAttr.videoType) == 'vimeo' ) {
          //Configure vimeo options
          var options = {
            autoplay : autoplayVideo
          };
          
          //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
          $promoVideo.videoPlayer = new slate.models.VimeoPlayer( $promoVideo, options );
        }
      }
    }
  
    Promo.prototype = $.extend({}, Promo.prototype, {

    });
  
    return Promo;
  })(jQuery);
  
/**
 * PageCMS Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the PageCMS
 *
 * @namespace - PageCMS
 */

theme.PageCMS = (function($) {
    var $window = $(window);
  
    var selectors = {
      timers: "[data-countdown-timer]",
      bannerVideo: '[data-video-id]',
      heroVideoInitialized: '[data-video-id].video-initialized',
      videoPlaceholder: '[data-video-id] ~ iframe',
      playButton: '[data-video-play-toggle]',
      audioButton: '[data-video-audio-toggle]',
      bannerVideoMob: '[data-vimeo-video-mobile]'
    };
    
    var dataAttr = {
      videoType     : 'video-type',
      videoAutoplay : 'video-autoplay'
    };
    
    /**
     * PageCMS section constructor. Runs on page load as well as Theme Editor  
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function PageCMS(container) {
      this.$container = $(container);
  
      this.name = "PageCMS";
      this.namespace = "." + this.name;
      //this.timer = new slate.models.Timer();

  
      var $bannerVideo = this.$container.find( selectors.bannerVideo ).eq(0);
    
      //If the panel has a descendant with a video...
      if ( $bannerVideo && $bannerVideo.length > 0 ) {
        var videoPlaceholder = $( selectors.videoPlaceholder, $bannerVideo );
        var autoplayVideo = $bannerVideo.data( dataAttr.videoAutoplay ) !== undefined ? true : false;
        
        if ($bannerVideo.data(dataAttr.videoType) == 'youtube') {
          //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
          $bannerVideo[0].videoPlayer = new slate.models.YouTubePlayer( $bannerVideo );
        } else if ($bannerVideo.data(dataAttr.videoType) == 'vimeo' ) {
          //Configure vimeo options
          var options = {
            autoplay : autoplayVideo
          };
          
          //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
          $bannerVideo.videoPlayer = new slate.models.VimeoPlayer( $bannerVideo, options );
      
        }
      }

      var $bannerVideoMob = this.$container.find( selectors.bannerVideoMob ).eq(0);
  
      //If the panel has a descendant with a video...
      if ( $bannerVideoMob && $bannerVideoMob.length > 0 ) {
        var videoPlaceholder = $( selectors.videoPlaceholder, $bannerVideoMob );
        var autoplayVideo = $bannerVideoMob.data( dataAttr.videoAutoplay ) !== undefined ? true : false;
  
        if ($bannerVideoMob.data(dataAttr.videoType) == 'youtube') {
          //Create new instance of YT player.  Note: We're adding it as prop to the actual DOM node, not the jQuery object
          $bannerVideoMob[0].videoPlayer = new slate.models.YouTubePlayer( $bannerVideoMob );
        } else if ($bannerVideoMob.data(dataAttr.videoType) == 'vimeo' ) {
          //Configure vimeo options
          var options = {
            autoplay : autoplayVideo
          };
          
          //Create new instance of Vimeo player and add it as prop to the DOM node (not the jQuery object!)
          $bannerVideoMob.videoPlayer = new slate.models.VimeoPlayer( $bannerVideoMob, options );
      
        }
      }
    }
  
    PageCMS.prototype = $.extend({}, PageCMS.prototype, {
      onSelect: function() {
        //reinit timer
        $(selectors.timers, this.$container).each(function(i, el) {
          new slate.models.Timer($(el));
        });
      }
    });
  
    return PageCMS;
  })(jQuery);
  
/**
 * Sale Banner Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - SaleBanner
 */

theme.SaleBanner = (function($) {

  var $window = $(window);

  var selectors = {
    marquee: '.sale-banner__text--marquee',
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SaleBanner(container) {
    this.$container = $(container);

    this.name = 'SaleBanner';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    this.offset = 0;
    this.$marquee = this.$container.find(selectors.marquee);

    this.W = $window.width();
    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));

    if (this.$marquee.length) this.init();
  }

  SaleBanner.prototype = $.extend({}, SaleBanner.prototype, {
    init: function () {
      // Try to have the font loaded before doing caculations
      FontFaceOnload('sequel-100-wide', {
        success: this.injectText.bind(this),
        error: this.injectText.bind(this)
      });

      this.$marquee.on('mouseenter', function () {
        this.velocity('pause');
      })
      this.$marquee.on('mouseleave', function () {
        this.velocity('resume');
      })
    },

    loop: function () {
      // from: -{offset}%, to: -50%
      this.animation = this.$marquee.velocity({
        transform: ['translateX(-'+this.offset+'px)', 'translateX(0px)']
      }, {
        duration: 10000,
        easing: 'linear',
        complete: this.loop.bind(this)
      });
    },

    injectText: function () {
      // create initial span
      if (this.$marquee.find('span').length === 0) this.$marquee.wrapInner('<span></span>');
      var $text = this.$marquee.find('span').first();

      // add delimiter
      if ($text[0] && $text[0].innerText.indexOf('·') === -1) $text[0].innerText += ' · ';

      // remove existing instance
      $text.nextAll().remove();

      // calculate the needed copies and space
      var neededW = this.$container.innerWidth() * 1.5;
      var textW = $text.width();
      var copies = Math.round(neededW / textW) - 1;
      var total = copies + 1;
      if (!total % 2) {
        copies++;
        total++;
      }
      else {
        copies = copies + 2;
        total = total + 2;
      }

      // get the offset and create the clones
      for(var i = 0; i < copies; i++){
        this.$marquee.append($text.clone());
      }
      
      // set the size of the container to match the content
      var firstCopyWidth = this.$marquee.find('span').first().width();
      this.$marquee.width(firstCopyWidth * total);
      this.offset = firstCopyWidth * 2;

      // animate
      this.$marquee.velocity('stop');
      this.loop();
    },

    onResize: function () {
      const W = $window.width();
      if (W > this.W) {
        this.injectText();
        this.W = W;
      }
    }
  })

  return SaleBanner;
})(jQuery);

/**
 * Push Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Push
 */

theme.Push = (function($) {

  var $window = $(window);

  var selectors = {
    text: '.push__text',
  };

  var classes = {
    line: 'push__line',
    lineWrapper: 'push__line-wrapper'
  };

  /**
   * Push section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Push(container) {
    this.$container = $(container);

    this.name = 'Push';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.$text = this.$container.find(selectors.text);

    this.init();
  }

  Push.prototype = $.extend({}, Push.prototype, {
    init: function () {
      if (this.$text.length) {
        this.cloneText();

        $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
        this.onScroll();
      }
    },

    cloneText: function () {
      // create initial span
      if (this.$text.find('span').length === 0) this.$text.wrapInner('<span class="'+ classes.line +'"></span>');
      // create initial line
      var $line = this.$text.find('.'+classes.line).first();
      if ($line.find('.'+classes.lineWrapper).length === 0) $line.wrapInner('<span class="'+ classes.lineWrapper +'"></span>');
      var $lineWrapper = $line.find('.'+classes.lineWrapper);
      if ($lineWrapper.find('span').length === 0) $lineWrapper.wrapInner('<span></span>');
      var $text = $lineWrapper.find('span').first();
      $text.nextAll().remove();

      var neededW = this.$container.innerWidth() * 2;
      var textW = $line.width();
      var copies = Math.round(neededW / textW);

      for(var i = 0; i < copies; i++){
        $lineWrapper.append($text.clone());
      }

      // duplicate line thrice (4 lines on mobile, 3 lines on tablet & desktop)
      this.$text.append($line.clone());
      this.$text.append($line.clone());
      this.$text.append($line.clone()); // will be hidden on tablet & desktop

      this.$wrappers = this.$container.find('.'+classes.lineWrapper);
    },

    onScroll: function () {
      var rect = this.$container[0].getBoundingClientRect();
      var bottom = rect.top + rect.height;
      var H = $window.innerHeight();
      if (bottom > 0 && rect.top < H) {
        var progress = bottom / H
        this.$wrappers.each(function (index, el) {
          var direction = index%2 ? 1 : -1
          $(el).css({ transform: 'translateX('+ direction * progress * 25 +'%)' })
        })
      }
    }
  })

  return Push;
})(jQuery);

/**
 * BH Cares Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - BHCares
 */

theme.BHCares = (function($) {

  var $window = $(window);

  var selectors = {
    content: '.bh-cares__content',
    values: '.bh-cares__values'
  };

  var classes = {
    marquee: 'bh-cares--marquee'
  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function BHCares(container) {
    this.$container = $(container);

    this.name = 'BHCares';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    this.offset = 0;

    this.$content = this.$container.find(selectors.content)
    this.$values = this.$container.find(selectors.values)

    this.W = $window.width();

    if (this.$container.hasClass(classes.marquee)) this.init();
  }

  BHCares.prototype = $.extend({}, BHCares.prototype, {
    init: function () {
      FontFaceOnload('sequel-100-wide', {
        success: this.dupplicateValues.bind(this),
        error: this.dupplicateValues.bind(this)
      });

      this.$content.on('mouseenter', function () {
        this.velocity('pause');
      })
      this.$content.on('mouseleave', function () {
        this.velocity('resume');
      })

      $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));
    },

    loop: function () {
      // from: -{offset}%, to: -50%
      this.animation = this.$content.velocity({
        transform: ['translateX(-'+this.offset+'px)', 'translateX(0px)']
      }, {
        duration: 10000,
        easing: 'linear',
        complete: this.loop.bind(this)
      });
    },

    dupplicateValues: function () {
      // remove existing copies
      var $values = this.$values.first();
      $values.nextAll().remove();

      // calculate the needed copies and space
      var neededW = this.$container.innerWidth();
      var valuesW = $values.innerWidth();
      var copies = Math.round(neededW / valuesW) + 1;
      var total = copies + 1;

      // get the offset and create the clones
      for(var i = 0; i < copies; i++){
        $values.after($values.clone());
      }

      // set the size of the container to match the content
      this.$content.width(valuesW * total);
      this.offset = valuesW;

      // animate
      this.$content.velocity('stop');
      this.loop();
    },

    onResize: function () {
      const W = $window.width();
      if (W > this.W) {
        this.dupplicateValues();
        this.W = W;
      }
    }
  })

  return BHCares;
})(jQuery);

/**
 * Categories Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Categories
 */

theme.Categories = (function($) {

  $window = $(window);

  var selectors = {
    slider: '.categories__slider',
    text: '.big-text',
    card: '.category-card'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Categories(container) {
    this.$container = $(container);
    this.$slider = this.$container.find(selectors.slider)
    this.$text = this.$container.find(selectors.text)
    this.$cards = this.$container.find(selectors.card)

    this.name = 'Categories';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));

    this.init();
  }

  Categories.prototype = $.extend({}, Categories.prototype, {
    init: function () {
      var limit = $window.width() < 1024 ? 3 : 4
      if (this.$cards.length >= limit) {
        this.initSlider();
      }
      if (this.$text) {
        FontFaceOnload('sequel-100-wide', {
          success: this.fitText.bind(this),
          error: this.fitText.bind(this)
        });
      }
    },
    initSlider: function () {
      this.$slider.slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 2,
        centerPadding: '16%',
        initialSlide: 1,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              initialSlide: 0,
              centerPadding: 0,
              dots: true
            }
          }
        ]
      })
    },
    fitText: function () {
      fitty(this.$text[0])
    },
    onResize: function () {
      var limit = $window.width() < 1024 ? 3 : 4
      if (this.$slider.slick) {
        if (this.$cards.length >= limit) {
          this.$slider.slick('resize');
        }
        else {
          this.$slider.slick('unslick');
        }
      }
      else if (this.$cards.length >= limit) {
        this.initSlider();
      }
    }
  })

  return Categories;
})(jQuery);

/**
 * CallToAction Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - CallToAction
 */

theme.CallToAction = (function($) {

  $window = $(window);

  var selectors = {
    slider: '.call-to-action__grid',
    text: '.call-to-action__title',
    card: '.call-to-action__item'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function CallToAction(container) {
    this.$container = $(container);
    this.$slider = this.$container.find(selectors.slider)
    this.$text = this.$container.find(selectors.text)
    this.$cards = this.$container.find(selectors.card)

    this.name = 'CallToAction';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));

    this.init();
  }

  CallToAction.prototype = $.extend({}, CallToAction.prototype, {
    init: function () {
/*       var limit = $window.width() < 1024 ? 2 : 3
      if (this.$cards.length >= limit) {
        this.initSlider();
      } */
      this.$text = this.$container.find(selectors.text);
      if (this.$text) {
        FontFaceOnload('sequel-100-wide', {
          success: this.fitText.bind(this),
          error: this.fitText.bind(this)
        });
      }
    },
    initSlider: function () {
      this.$slider.slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 2,
        centerPadding: '16%',
        initialSlide: 1,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              initialSlide: 0,
              centerPadding: 0,
              dots: true
            }
          }
        ]
      })
    },
    fitText: function () {
      this.$text.each(function() {fitty(this);});
    },
    onResize: function () {
      var limit = $window.width() < 1024 ? 2 : 3
      if (this.$slider.slick) {
        if (this.$cards.length >= limit) {
          this.$slider.slick('resize');
        }
        else {
          this.$slider.slick('unslick');
        }
      }
      else if (this.$cards.length >= limit) {
        this.initSlider();
      }
      this.$text = this.$container.find(selectors.text);
      this.fitText();
    }
  })

  return CallToAction;
})(jQuery);

/**
 * UGCSlider Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - UGCSlider
 */

theme.UGCSlider = (function($) {

  $window = $(window);

  var selectors = {
    slider: '.ugc-slider__slides',
    slide: '.ugc-slider__slide'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function UGCSlider(container) {
    this.$container = $(container);
    this.$slider = this.$container.find(selectors.slider)
    this.$slides = this.$container.find(selectors.slide)

    this.name = 'UGCSlider';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));

    this.init();
  }

  UGCSlider.prototype = $.extend({}, UGCSlider.prototype, {
    init: function () {
      var limit = window.innerWidth < 993 ? 2 : 4
      if (this.$slides.length > limit) {
        this.initSlider();
      }
    },
    initSlider: function () {
      this.$slider.slick({
        accessibility: false,
        infinite: true,
        centerMode: false,
        slidesToShow: 4,
        initialSlide: 1,
        arrows: true,
        dots: true,
        variableWidth: false,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        responsive: [
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      })
    },
    onResize: function () {
      var limit = window.innerWidth < 993 ? 2 : 4
      if (this.$slider.hasClass('slick-initialized')) {
        if (this.$slides.length > limit) {
          this.$slider.slick('resize');
        }
        else {
          this.$slider.slick('unslick');
        }
      }
      else if (this.$slides.length > limit) {
        this.initSlider();
      }
    }
  })

  return UGCSlider;
})(jQuery);

/**
 * Video Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Video
 */

theme.Video = (function($) {

  $window = $(window);

  var selectors = {
    video: '.video'
  };

  var dataAttr = {
    videoType: 'video-type'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Video(container) {
    this.$container = $(container);
    this.$video = this.$container.find(selectors.video)

    this.name = 'Video';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.init();
  }

  Video.prototype = $.extend({}, Video.prototype, {
    init: function () {
      if (this.$video.data(dataAttr.videoType) == 'youtube') {
        this.$video[0].videoPlayer = new slate.models.YouTubePlayer( this.$video );
      } else if (this.$video.data(dataAttr.videoType) == 'vimeo' ) {
        this.$video[0].videoPlayer = new slate.models.VimeoPlayer( this.$video, {
          muted      : false,
          autoplay   : false,
          loop       : false,
          controls   : true,
          background : false
        } );
      }
    }
  })

  return Video;
})(jQuery);

/**
 * BigText Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - BigText
 */

theme.BigText = (function($) {

  $window = $(window);

  var selectors = {
    text: '.big-text'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function BigText(container) {
    this.$container = $(container);
    this.$text = this.$container.find(selectors.text)

    this.name = 'BigText';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.init();
  }

  BigText.prototype = $.extend({}, BigText.prototype, {
    init: function () {
      if (this.$text) {
        FontFaceOnload('sequel-100-wide', {
          success: this.fitText.bind(this),
          error: this.fitText.bind(this)
        });
      }
    },
    fitText: function () {
      fitty(this.$text[0])
    }
  })

  return BigText;
})(jQuery);

/**
 * Slider Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slider
 */

theme.Slider = (function($) {

  $window = $(window);

  var selectors = {
    slider: '.slider__list',
    item: '.slider__item',
    thumbnails: '.slider__thumbnails',
    thumbnailItem: '.slider__thumbnail'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slider(container) {
    this.$container = $(container);
    this.$slider = this.$container.find(selectors.slider)
    this.$items = this.$container.find(selectors.item)
    this.$thumbnails = this.$container.find(selectors.thumbnails)
    this.$thumbnailItems = this.$container.find(selectors.thumbnailItem)

    this.name = 'Slider';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.init();
  }

  Slider.prototype = $.extend({}, Slider.prototype, {
    init: function () {
      if (this.$items.length) {
        this.initSlider();
        if (this.$thumbnails.length) {
          this.initThumbnails();
        }
      }
    },
    initSlider: function () {
      this.$slider.slick({
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        asNavFor: this.$thumbnails.length ? this.$thumbnails : null
      })
    },
    initThumbnails: function () {
      this.$thumbnails.slick({
        infinite: false,
        asNavFor: this.$slider,
        variableWidth: true,
        arrows: false,
        centerMode: true
      })

      this.$thumbnailItems.click(this.goTo.bind(this));
      this.$slider.on('afterChange', this.updateActiveSlide.bind(this));
    },
    goTo: function (event) {
      event.preventDefault();
      var index = this.$thumbnailItems.index(event.currentTarget);
      this.$thumbnails.slick('slickGoTo', index);
    },
    updateActiveSlide: function (event, slick, currentSlide) {
      this.$thumbnails.slick('slickGoTo', currentSlide);
    }
  })

  return Slider;
})(jQuery);

/**
 * Key Points Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Key Points
 */

theme.KeyPoints = (function($) {

  $window = $(window);

  var selectors = {
    list: '.key-points__list',
    item: '.key-points__item'
  };

  var classes = {

  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function KeyPoints(container) {
    this.$container = $(container);
    this.$list = this.$container.find(selectors.list)
    this.$items = this.$container.find(selectors.item)

    this.name = 'KeyPoints';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    if (this.$items.length > 1) {
      $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));
      this.init();
    }
  }

  KeyPoints.prototype = $.extend({}, KeyPoints.prototype, {
    init: function () {
      if ($window.width() < 1024) {
        this.initSlider();
      }
    },
    initSlider: function () {
      this.$list.slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        centerPadding: 0,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>'
      })
    },
    onResize: function () {
      if ($window.width() < 1024) {
        if (this.$list.slick) {
          this.$list.slick('resize');
        }
        else {
          this.initSlider();
        }
      }
      else if (this.$list.slick) {
        this.$list.slick('unslick');
      }
    }
  })

  return KeyPoints;
})(jQuery);

/**
 * Product Slider Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Product Slider
 */

theme.ProductSlider = (function($) {

  $window = $(window);

  var selectors = {
    list: '.product-slider__list',
    item: '.product-slider__item'
  };

  var classes = {
    side: 'product-slider--side'
  };

  /**
   * Sale Banner section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function ProductSlider(container) {
    this.$container = $(container);
    this.$list = this.$container.find(selectors.list)
    this.$items = this.$container.find(selectors.item)

    this.name = 'ProductSlider';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.events = {
      RESIZE: 'resize' + this.namespace
    };

    $window.on(this.events.RESIZE, $.throttle(20, this.onResize.bind(this)));

    this.init();
  }

  ProductSlider.prototype = $.extend({}, ProductSlider.prototype, {
    init: function () {
      var limit = $window.width() >= 1024 ? 4 : 2
      if (this.$items.length >= limit) {
        this.initSlider();
      }
      if (this.$text) {
        FontFaceOnload('sequel-100-wide', {
          success: this.fitText.bind(this),
          error: this.fitText.bind(this)
        });
      }
    },
    initSlider: function () {
      this.$list.slick({
        infinite: true,
        slidesToShow: 4,
        arrows: true,
        dots: true,
        prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      })
    },
    onResize: function () {
      var limit = $window.width() >= 1024 ? 4 : 2
      if (this.$list.slick) {
        if (this.$items.length >= limit) {
          this.$list.slick('resize');
        }
        else {
          this.$list.slick('unslick');
        }
      }
      else if (this.$items.length >= limit) {
        this.initSlider();
      }
    }
  })

  return ProductSlider;
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]',
    addAddressBtn: '#ShowAddAddressBtn'
  };

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');

    // ensures that the add address button is not shown at the same tinme
    // as the form that it toggles when clicked
    if ($newAddressForm.hasClass('hide')){
      $('#AddAddressBtn').show();
    } else {
      $('#AddAddressBtn').hide();
    }
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPasswordForm',
    loginForm: '#CustomerLoginForm',
    toggleRecoverPasswordForm: '[data-password-recover-form-toggle]',
    firstNameField: '#FirstName',
    firstNameError: '#FirstNameError',
    lastNameField: '#LastName',
    lastNameError: '#LastNameError',
    emailField: '#Email',
    emailError: '#EmailError',
    passwordField: '#CreatePassword',
    passwordError: '#PasswordError',
    passwordConfirm: '#ConfirmPassword',
    passwordConfirmError: '#ConfirmPasswordError',
    createAccountForm: '#create_customer',
    registerSubmit: '[data-register-submit-button]',
    loginSubmit: '[data-login-submit-button]',
    passwordRecoverSubmit: '[data-password-recover-submit-button]',
    inputError: '[data-form-control-error]',
    recoverEmailField: "#RecoverEmail",
    acceptsMarketing: '#accepts-marketing'
  };

  var classes = {
    error: 'has-error-z', //.has-error gets removed by shopify's default forms, so we add a diff. error class
    hide: 'hide'
  };

  checkUrlHash();
  resetPasswordSuccess();

  var createAccountFormInputs = [
    {
      inputEl : $(config.firstNameField, config.createAccountForm),
      validate: validateFirstName
    },
    {
      inputEl : $(config.lastNameField, config.createAccountForm),
      validate: validateLastName
    },
    {
      inputEl : $(config.emailField, config.createAccountForm),
      validate: validateEmail
    },
    {
      inputEl : $(config.passwordField, config.createAccountForm),
      validate: validatePassword
    },
    {
      inputEl : $(config.passwordConfirm, config.createAccountForm),
      validate: validatePasswordConfirmation
    }
  ];

  var debounceDelay = 500;

  //Bind validation function to each input on blur, and on keyup with a slight debounce
  $.each(createAccountFormInputs, function(i, el) {
    var $input = el.inputEl;
    var validateInput = el.validate;

    $input.on('blur', validateInput);
    $input.on('keyup', $.debounce(debounceDelay, function(e){
      if (e.which !== 9) {
        validateInput();
      }
    }));
  });

  //On keyup of form, update the account submit button
  $("input", config.createAccountForm).on('blur click', updateAccountSubmitState);
  $(config.createAccountForm).on('keyup', $.debounce( debounceDelay, updateAccountSubmitState ));

  //Toggle password recovery form
  $(config.toggleRecoverPasswordForm).on('click', toggleRecoverPasswordForm);

  //Validation of entire form when submit is clicked.
  $(config.createAccountForm).on('submit', onCreateAccountFormSubmit);


  //Function to show the recover password form on page load
  function checkUrlHash() {
    var hash = window.location.hash;
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
      resetPasswordError();
    }
  }

  /*
  * Helper functions to add/remove .has-error and show error fields
  */
  function addError($input){
    var $formControl = $input.parents('.form-group');
    $formControl.addClass( classes.error );
    $input.attr('aria-invalid', 'true');
    $formControl.find( config.inputError ).show();
  }

  function removeError($input){
    var $formControl = $input.parents('.form-group');
    $formControl.removeClass( classes.error );
    $input.attr('aria-invalid', 'false');
    $formControl.find( config.inputError ).hide();
  }

  /*
  * First Name
  */
  function isFirstNameValid(){
    var $firstNameInput = $( config.firstNameField );
    var valid = $firstNameInput.val() != "" ? true : false;
    return valid;
  }

  function validateFirstName() {
    var $firstNameInput = $( config.firstNameField );
    var valid = isFirstNameValid();
    valid ? removeError( $firstNameInput ) : addError( $firstNameInput );
    return valid;
  }

  /*
  * Last Name
  */
  function isLastNameValid(){
    var $lastNameInput = $( config.lastNameField );
    return $lastNameInput.val() != "" ? true : false;
  }

  function validateLastName() {
    var $lastNameInput = $( config.lastNameField );
    var valid = isLastNameValid();
    valid ? removeError( $lastNameInput ) : addError( $lastNameInput );
    return valid;
  }

  /*
  * Password
  */
  function isPasswordValid() {
    var $pwInput = $( config.passwordField );
    var password = $pwInput.val();
    var re = /^(?=.*?[#?!@$%^&*-]).{6,}$/;
    return re.test( password );
  }

  function validatePassword() {
    var $pwInput = $( config.passwordField );
    var valid = isPasswordValid();
    valid ? removeError( $pwInput ) : addError( $pwInput );
    return valid;
  }

  /*
  * Password Confirmation
  */
  function isPasswordConfirmationValid() {
    var $pwConfirmInput = $( config.passwordConfirm );
    var $pwInput = $( config.passwordField );
    var pw = $pwInput.val();
    return ( pw.length && pw == $pwConfirmInput.val() );
  }

  function validatePasswordConfirmation() {
    var $pwConfirmInput = $( config.passwordConfirm );
    var valid = isPasswordConfirmationValid();
    valid ? removeError( $pwConfirmInput ) : addError( $pwConfirmInput );
    return valid;
  }

  /*
  * Email Address
  */
  function isEmailValid() {
    var $emailInput = $( config.emailField );
    var email = $emailInput.val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  function validateEmail() {
    var $emailInput = $( config.emailField );
    var valid = isEmailValid();
    valid ? removeError( $emailInput ) : addError( $emailInput );
    return valid;
  }

  /*
  * Checkboxes - validate them all, checking for the required attributes.  These are only validated on keyup.
  */
  function areCheckboxesValid() {
    $form = $(config.createAccountForm);
    var valid = true;

    $form.find('input[type="checkbox"]').each(function() {
      var $el = $(this);
      //If a checkbox has the required attribute, and it's not checked...
      if( ($el.attr('required') != undefined || $el.attr('data-required') != undefined) && !$el.prop('checked')) {
        valid = false;
      }
    });

    return valid;
  }

  function validateCheckboxes() {
    var valid = areCheckboxesValid();

    $form.find('input[type="checkbox"]').each(function() {
      var $input = $(this);
      //If a checkbox has the required attribute, and it's not checked...
      if( ($input.attr('required') != undefined || $input.attr('data-required') != undefined) && !$input.prop('checked')) {
        addError( $input );
      } else {
        removeError( $input );
      }
    });

    return areCheckboxesValid();
  }

  //Function to validate all fields on the account creation form
  function validateCreateAccountForm() {
    return validateFirstName() && validateLastName() && validateEmail() && validatePassword() && validatePasswordConfirmation() && validateCheckboxes();
  }

  //Function to update the disabled state of the submit button
  function updateAccountSubmitState() {
    var formIsValid = ( isFirstNameValid() && isLastNameValid() && isEmailValid() && isPasswordValid() && isPasswordConfirmationValid() && areCheckboxesValid() );
    $(config.registerSubmit).attr('disabled', !formIsValid);
  }

  //Function to write a cookie if #accepts-marketing is checked
  function writeEmailCollectedCookie() {
    let emailCollectedCookie = slate.user.generateCookie('emailCollected');
    emailCollectedCookie.expiration = 365;
    slate.user.setCookie(emailCollectedCookie);
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm(e) {
    if (e) {
      e.preventDefault(); //toggleRecoverPasswordForm is called on pageload as well, so we're not guaranteed to have an event passed
    }
    $( config.recoverPasswordForm ).toggleClass( classes.hide );
    $( config.loginForm ).toggleClass( classes.hide );
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass( classes.hide );
  }

  function resetPasswordError() {
    if($(config.recoverEmailField).data('has-errors'))
      $(config.recoverEmailField).focus();
  }

  /**
   *  Front end validation for create account form
   */
  function onCreateAccountFormSubmit(evt) {
    var formIsValid = validateCreateAccountForm();
    if (formIsValid && $(config.acceptsMarketing).prop('checked')) {
      console.log('writing new user accepts marketing cooke');
      writeEmailCollectedCookie();
    }
    return formIsValid;
  }
})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  };

  if( !$body.is('.template-page-styles') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the components page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.components = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    slideupAlertForm: '[data-slideup-alert-form]',
    qaSetMax: '[data-qa-set-max]',
    qaToggleEnabled: '[data-qa-toggle-enabled]',
    qa: '[data-quantity-adjuster]'
  };

  if( !$body.is('.template-page-components') ){
    return;
  }

  $(selectors.slideupAlertForm).on('submit', function(e) {
    e.preventDefault();

    new slate.models.SlideupAlert({
      title: $(this).find('input[name="title"]').val(),
      text: $(this).find('input[name="text"]').val()
    });
  });

  // Quantity Adjuster
  $(selectors.qaSetMax).on('click', function(e) {
    $(selectors.qa).find('input[type="number"]').attr('max', $(e.currentTarget).data('qa-set-max'));
  });

  $(selectors.qaToggleEnabled).on('click', function(e) {
    var $qaInput = $(selectors.qa).find('input[type="number"]');
    $qaInput.attr('disabled', !$qaInput.is(':disabled'));
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();

/**
 * Press Page Script
 * ------------------------------------------------------------------------------
 *
 */

 theme.pressPage = (function() {
  
  var $body = $(document.body);

  if( !$body.is('.template-page-press') ){
    return;
  }

  var selectors = {
    pageFilterLinkAll : '[data-page-filter-link-all]',
    pageFilterLink : '[data-page-filter-link]',
    pageFilterItem : '[data-page-filter-item]',
    pageFilterItemList : '[data-page-filter-item-container]'
  };

  var dataAttr = {
    filterTarget: 'page-filter-link',
    filterId: 'page-filter-item'
  };

  var classes = {
    filterLinkIsActive : 'is-active'
  }

  var $pageFilterList = $( selectors.pageFilterItemList );


  $( selectors.pageFilterLinkAll ).addClass( classes.filterLinkIsActive ); //add active class to 'all' button to start

  var originalItems = []; //keep a copy of the original items

  $( selectors.pageFilterItem ).each(function(i){
    originalItems.push( $(this) ); //push each item to the ogItems array
  });

  //Click handler for the 'all' link
  $( selectors.pageFilterLinkAll ).on('click', function(e){
    e.preventDefault();
    if ( $(this).hasClass( classes.filterLinkIsActive ) ) {
      return;
    }

    $( selectors.pageFilterLink ).removeClass( classes.filterLinkIsActive );
    $( selectors.pageFilterLinkAll ).addClass( classes.filterLinkIsActive ); //add active class to any 'all' selectors present (should only be 1)

    $pageFilterList.empty();

    $.each(originalItems, function(i,el){
      $pageFilterList.append(el); //add each item to the original items list.
    });

  });

  //Click handler for all other filter links
  $( selectors.pageFilterLink ).on('click', function(e){
    e.preventDefault();
    //If link is already active, abort
    if ( $(this).hasClass( classes.filterLinkIsActive ) ) {
      return;
    }

    var targetId = $(this).data( dataAttr.filterTarget ); //this is the filter id we're looking for

    $pageFilterList.empty(); //empty the item container
    $.each(originalItems, function(i,el){ //loop through items
      if ( el.data( dataAttr.filterId ) == targetId ) {
        $pageFilterList.append(el); //append each item if it has the matching ID
      }
    });

    $(selectors.pageFilterLink).removeClass( classes.filterLinkIsActive ); //remove active class from links
    $(selectors.pageFilterLinkAll).removeClass( classes.filterLinkIsActive );
    $(this).addClass( classes.filterLinkIsActive ); //add active class to the clicked link
  });

})();


(function($) {
  var $window = $(window);
  var $document = $(document);
  var $body = $(document.body);

  function applySectionMargins () {
    var previousSectionColor = null;
    $(".shopify-section .section").each(function(index, el) {
      var bgColor = $(el).css('background-color');
      el.classList.toggle('section--half-top', bgColor === previousSectionColor);
      previousSectionColor = bgColor;
    });
  }

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register("product", theme.Product);
    sections.register("collection", theme.Collection);
    sections.register("pencil-banner", theme.PencilBanner);
    sections.register("subscription-slideup", theme.SubscriptionSlideup);
    sections.register('subscription-modal', theme.SubscriptionModal);
    sections.register("instagram-feed", theme.InstagramFeed);
    sections.register("slideshow", theme.Slideshow);
    sections.register("triptych", theme.Triptych);
    sections.register("header", theme.Header);
    sections.register("footer", theme.Footer);
    sections.register("ajax-cart", theme.AjaxCart);
    sections.register("cart", theme.Cart);
    sections.register("mobile-menu", theme.MobileMenu);
    sections.register("blog", theme.Blog);
    sections.register("article", theme.Article);
    sections.register("product-grid", theme.ProductGrid);
    sections.register("careers", theme.Careers);
    sections.register("support-center", theme.SupportCenter);
    sections.register("testimonials", theme.Testimonials);
    sections.register("about-us", theme.AboutUs);
    sections.register("search", theme.Search);
    sections.register("influencer-signup", theme.InfluencerSignup);
    sections.register("news", theme.News);
    sections.register("banner", theme.Banner);
    sections.register("collection-hero", theme.CollectionHero);
    sections.register("promo", theme.Promo);
    sections.register("cms-page", theme.PageCMS);
    sections.register("sale-banner", theme.SaleBanner);
    sections.register("push", theme.Push);
    sections.register("bh-cares", theme.BHCares);
    sections.register("categories", theme.Categories);
    sections.register("call-to-action", theme.CallToAction);
    sections.register("ugc-slider", theme.UGCSlider);
    sections.register("video", theme.Video);
    sections.register("big-text", theme.BigText);
    sections.register("slider", theme.Slider);
    sections.register("key-points", theme.KeyPoints);
    sections.register("product-slider", theme.ProductSlider);

    $(".in-page-link").on("click", function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    // Target tables to make them scrollable
    slate.rte.wrapTables({
      $tables: $(".rte table"),
      tableWrapperClass: "table-responsive"
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: "rte__video-wrapper"
    });

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.utils.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Form event handling / validation
    slate.forms.initialize();

    //Parallax scrolling
    slate.parallaxScroll.initialize();

    // START - Global handler for collapse plugin to add state class for open panels
    var panelIsOpenClass = "is-open";

    $document.on("show.bs.collapse", ".collapse", function(e) {
      $(e.currentTarget)
        .parents(".panel")
        .addClass(panelIsOpenClass);
    });

    $document.on("hide.bs.collapse", ".collapse", function(e) {
      $(e.currentTarget)
        .parents(".panel")
        .removeClass(panelIsOpenClass);
    });

    $(".collapse.in").each(function() {
      $(this)
        .parents(".panel")
        .addClass(panelIsOpenClass);
    });
    // END - Global handler for collapse plugin to add state class for open panels

    // Initialize countdown timers
    $("[data-countdown-timer]").each(function(i, el) {
      new slate.models.Timer($(el));
    });

    // If we have the search overlay, make sure we focus the input when it opens
    var $searchOverlay = $("#search-overlay");
    if ($searchOverlay.length) {
      $searchOverlay.on("shown.overlay", function() {
        // Due to CSS animations, this timeout is required
        setTimeout(function() {
          $searchOverlay.find('input[type="search"]').focus();
        }, 10);
      });
    }

    // findify wishl connector set up globally since they replace the entire search file
    window.wishl = window.wishl || new slate.models.Wishlist();
    this.wishl = window.wishl;
    this.wishl.initWishlWrapper();

    window.findifyWishlist = {
      addItem: this.wishl.addItem,
      getAllWishlistItems: this.wishl.getAllWishlistItems,
      items: []
    };

    // Unveil (lazy load) images
    // @TODO: replace with lazysizes
    $(".lazy-load").unveil();

    // apply section margins on load and when the section change in the editor
    applySectionMargins();
    document.addEventListener("shopify:section:load", function(event) {
      applySectionMargins();
    });

  });
})(jQuery);
